import * as Q from "react";
import Ie, { forwardRef as fe, useCallback as _e, createContext as Kt, useMemo as Pt, createElement as ne, useContext as tr, useRef as pe, useEffect as $e, useState as xe, Children as bt, isValidElement as Ht, cloneElement as nr, Fragment as wo, useLayoutEffect as Eo, useReducer as Ni } from "react";
import * as Fi from "react-dom";
import rr, { flushSync as So } from "react-dom";
function $o(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Vn = { exports: {} }, Ot = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Dr;
function Li() {
  if (Dr)
    return Ot;
  Dr = 1;
  var e = Ie, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(s, f, u) {
    var h, v = {}, w = null, y = null;
    u !== void 0 && (w = "" + u), f.key !== void 0 && (w = "" + f.key), f.ref !== void 0 && (y = f.ref);
    for (h in f)
      r.call(f, h) && !a.hasOwnProperty(h) && (v[h] = f[h]);
    if (s && s.defaultProps)
      for (h in f = s.defaultProps, f)
        v[h] === void 0 && (v[h] = f[h]);
    return { $$typeof: t, type: s, key: w, ref: y, props: v, _owner: o.current };
  }
  return Ot.Fragment = n, Ot.jsx = c, Ot.jsxs = c, Ot;
}
var Tt = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jr;
function Vi() {
  return jr || (jr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Ie, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), c = Symbol.for("react.provider"), s = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), v = Symbol.for("react.memo"), w = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), S = Symbol.iterator, m = "@@iterator";
    function C(b) {
      if (b === null || typeof b != "object")
        return null;
      var B = S && b[S] || b[m];
      return typeof B == "function" ? B : null;
    }
    var $ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function _(b) {
      {
        for (var B = arguments.length, z = new Array(B > 1 ? B - 1 : 0), oe = 1; oe < B; oe++)
          z[oe - 1] = arguments[oe];
        N("error", b, z);
      }
    }
    function N(b, B, z) {
      {
        var oe = $.ReactDebugCurrentFrame, he = oe.getStackAddendum();
        he !== "" && (B += "%s", z = z.concat([he]));
        var we = z.map(function(de) {
          return String(de);
        });
        we.unshift("Warning: " + B), Function.prototype.apply.call(console[b], console, we);
      }
    }
    var P = !1, x = !1, j = !1, q = !1, K = !1, Z;
    Z = Symbol.for("react.module.reference");
    function se(b) {
      return !!(typeof b == "string" || typeof b == "function" || b === r || b === a || K || b === o || b === u || b === h || q || b === y || P || x || j || typeof b == "object" && b !== null && (b.$$typeof === w || b.$$typeof === v || b.$$typeof === c || b.$$typeof === s || b.$$typeof === f || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      b.$$typeof === Z || b.getModuleId !== void 0));
    }
    function X(b, B, z) {
      var oe = b.displayName;
      if (oe)
        return oe;
      var he = B.displayName || B.name || "";
      return he !== "" ? z + "(" + he + ")" : z;
    }
    function H(b) {
      return b.displayName || "Context";
    }
    function Y(b) {
      if (b == null)
        return null;
      if (typeof b.tag == "number" && _("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof b == "function")
        return b.displayName || b.name || null;
      if (typeof b == "string")
        return b;
      switch (b) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case a:
          return "Profiler";
        case o:
          return "StrictMode";
        case u:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case s:
            var B = b;
            return H(B) + ".Consumer";
          case c:
            var z = b;
            return H(z._context) + ".Provider";
          case f:
            return X(b, b.render, "ForwardRef");
          case v:
            var oe = b.displayName || null;
            return oe !== null ? oe : Y(b.type) || "Memo";
          case w: {
            var he = b, we = he._payload, de = he._init;
            try {
              return Y(de(we));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ee = Object.assign, re = 0, ie, te, ue, d, p, g, l;
    function i() {
    }
    i.__reactDisabledLog = !0;
    function E() {
      {
        if (re === 0) {
          ie = console.log, te = console.info, ue = console.warn, d = console.error, p = console.group, g = console.groupCollapsed, l = console.groupEnd;
          var b = {
            configurable: !0,
            enumerable: !0,
            value: i,
            writable: !0
          };
          Object.defineProperties(console, {
            info: b,
            log: b,
            warn: b,
            error: b,
            group: b,
            groupCollapsed: b,
            groupEnd: b
          });
        }
        re++;
      }
    }
    function A() {
      {
        if (re--, re === 0) {
          var b = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ee({}, b, {
              value: ie
            }),
            info: ee({}, b, {
              value: te
            }),
            warn: ee({}, b, {
              value: ue
            }),
            error: ee({}, b, {
              value: d
            }),
            group: ee({}, b, {
              value: p
            }),
            groupCollapsed: ee({}, b, {
              value: g
            }),
            groupEnd: ee({}, b, {
              value: l
            })
          });
        }
        re < 0 && _("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var D = $.ReactCurrentDispatcher, O;
    function k(b, B, z) {
      {
        if (O === void 0)
          try {
            throw Error();
          } catch (he) {
            var oe = he.stack.trim().match(/\n( *(at )?)/);
            O = oe && oe[1] || "";
          }
        return `
` + O + b;
      }
    }
    var R = !1, M;
    {
      var L = typeof WeakMap == "function" ? WeakMap : Map;
      M = new L();
    }
    function I(b, B) {
      if (!b || R)
        return "";
      {
        var z = M.get(b);
        if (z !== void 0)
          return z;
      }
      var oe;
      R = !0;
      var he = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var we;
      we = D.current, D.current = null, E();
      try {
        if (B) {
          var de = function() {
            throw Error();
          };
          if (Object.defineProperty(de.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(de, []);
            } catch (Ke) {
              oe = Ke;
            }
            Reflect.construct(b, [], de);
          } else {
            try {
              de.call();
            } catch (Ke) {
              oe = Ke;
            }
            b.call(de.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ke) {
            oe = Ke;
          }
          b();
        }
      } catch (Ke) {
        if (Ke && oe && typeof Ke.stack == "string") {
          for (var le = Ke.stack.split(`
`), Ae = oe.stack.split(`
`), Te = le.length - 1, Pe = Ae.length - 1; Te >= 1 && Pe >= 0 && le[Te] !== Ae[Pe]; )
            Pe--;
          for (; Te >= 1 && Pe >= 0; Te--, Pe--)
            if (le[Te] !== Ae[Pe]) {
              if (Te !== 1 || Pe !== 1)
                do
                  if (Te--, Pe--, Pe < 0 || le[Te] !== Ae[Pe]) {
                    var Fe = `
` + le[Te].replace(" at new ", " at ");
                    return b.displayName && Fe.includes("<anonymous>") && (Fe = Fe.replace("<anonymous>", b.displayName)), typeof b == "function" && M.set(b, Fe), Fe;
                  }
                while (Te >= 1 && Pe >= 0);
              break;
            }
        }
      } finally {
        R = !1, D.current = we, A(), Error.prepareStackTrace = he;
      }
      var pt = b ? b.displayName || b.name : "", Mr = pt ? k(pt) : "";
      return typeof b == "function" && M.set(b, Mr), Mr;
    }
    function T(b, B, z) {
      return I(b, !1);
    }
    function F(b) {
      var B = b.prototype;
      return !!(B && B.isReactComponent);
    }
    function U(b, B, z) {
      if (b == null)
        return "";
      if (typeof b == "function")
        return I(b, F(b));
      if (typeof b == "string")
        return k(b);
      switch (b) {
        case u:
          return k("Suspense");
        case h:
          return k("SuspenseList");
      }
      if (typeof b == "object")
        switch (b.$$typeof) {
          case f:
            return T(b.render);
          case v:
            return U(b.type, B, z);
          case w: {
            var oe = b, he = oe._payload, we = oe._init;
            try {
              return U(we(he), B, z);
            } catch {
            }
          }
        }
      return "";
    }
    var G = Object.prototype.hasOwnProperty, J = {}, ae = $.ReactDebugCurrentFrame;
    function ce(b) {
      if (b) {
        var B = b._owner, z = U(b.type, b._source, B ? B.type : null);
        ae.setExtraStackFrame(z);
      } else
        ae.setExtraStackFrame(null);
    }
    function ve(b, B, z, oe, he) {
      {
        var we = Function.call.bind(G);
        for (var de in b)
          if (we(b, de)) {
            var le = void 0;
            try {
              if (typeof b[de] != "function") {
                var Ae = Error((oe || "React class") + ": " + z + " type `" + de + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof b[de] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Ae.name = "Invariant Violation", Ae;
              }
              le = b[de](B, de, oe, z, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Te) {
              le = Te;
            }
            le && !(le instanceof Error) && (ce(he), _("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", oe || "React class", z, de, typeof le), ce(null)), le instanceof Error && !(le.message in J) && (J[le.message] = !0, ce(he), _("Failed %s type: %s", z, le.message), ce(null));
          }
      }
    }
    var Ce = Array.isArray;
    function Oe(b) {
      return Ce(b);
    }
    function ke(b) {
      {
        var B = typeof Symbol == "function" && Symbol.toStringTag, z = B && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return z;
      }
    }
    function je(b) {
      try {
        return Ne(b), !1;
      } catch {
        return !0;
      }
    }
    function Ne(b) {
      return "" + b;
    }
    function ft(b) {
      if (je(b))
        return _("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", ke(b)), Ne(b);
    }
    var Qe = $.ReactCurrentOwner, Ei = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Or, Tr, bn;
    bn = {};
    function Si(b) {
      if (G.call(b, "ref")) {
        var B = Object.getOwnPropertyDescriptor(b, "ref").get;
        if (B && B.isReactWarning)
          return !1;
      }
      return b.ref !== void 0;
    }
    function $i(b) {
      if (G.call(b, "key")) {
        var B = Object.getOwnPropertyDescriptor(b, "key").get;
        if (B && B.isReactWarning)
          return !1;
      }
      return b.key !== void 0;
    }
    function Ci(b, B) {
      if (typeof b.ref == "string" && Qe.current && B && Qe.current.stateNode !== B) {
        var z = Y(Qe.current.type);
        bn[z] || (_('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', Y(Qe.current.type), b.ref), bn[z] = !0);
      }
    }
    function xi(b, B) {
      {
        var z = function() {
          Or || (Or = !0, _("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", B));
        };
        z.isReactWarning = !0, Object.defineProperty(b, "key", {
          get: z,
          configurable: !0
        });
      }
    }
    function Oi(b, B) {
      {
        var z = function() {
          Tr || (Tr = !0, _("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", B));
        };
        z.isReactWarning = !0, Object.defineProperty(b, "ref", {
          get: z,
          configurable: !0
        });
      }
    }
    var Ti = function(b, B, z, oe, he, we, de) {
      var le = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: b,
        key: B,
        ref: z,
        props: de,
        // Record the component responsible for creating this element.
        _owner: we
      };
      return le._store = {}, Object.defineProperty(le._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(le, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: oe
      }), Object.defineProperty(le, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: he
      }), Object.freeze && (Object.freeze(le.props), Object.freeze(le)), le;
    };
    function Pi(b, B, z, oe, he) {
      {
        var we, de = {}, le = null, Ae = null;
        z !== void 0 && (ft(z), le = "" + z), $i(B) && (ft(B.key), le = "" + B.key), Si(B) && (Ae = B.ref, Ci(B, he));
        for (we in B)
          G.call(B, we) && !Ei.hasOwnProperty(we) && (de[we] = B[we]);
        if (b && b.defaultProps) {
          var Te = b.defaultProps;
          for (we in Te)
            de[we] === void 0 && (de[we] = Te[we]);
        }
        if (le || Ae) {
          var Pe = typeof b == "function" ? b.displayName || b.name || "Unknown" : b;
          le && xi(de, Pe), Ae && Oi(de, Pe);
        }
        return Ti(b, le, Ae, he, oe, Qe.current, de);
      }
    }
    var yn = $.ReactCurrentOwner, Pr = $.ReactDebugCurrentFrame;
    function dt(b) {
      if (b) {
        var B = b._owner, z = U(b.type, b._source, B ? B.type : null);
        Pr.setExtraStackFrame(z);
      } else
        Pr.setExtraStackFrame(null);
    }
    var wn;
    wn = !1;
    function En(b) {
      return typeof b == "object" && b !== null && b.$$typeof === t;
    }
    function _r() {
      {
        if (yn.current) {
          var b = Y(yn.current.type);
          if (b)
            return `

Check the render method of \`` + b + "`.";
        }
        return "";
      }
    }
    function _i(b) {
      {
        if (b !== void 0) {
          var B = b.fileName.replace(/^.*[\\\/]/, ""), z = b.lineNumber;
          return `

Check your code at ` + B + ":" + z + ".";
        }
        return "";
      }
    }
    var Rr = {};
    function Ri(b) {
      {
        var B = _r();
        if (!B) {
          var z = typeof b == "string" ? b : b.displayName || b.name;
          z && (B = `

Check the top-level render call using <` + z + ">.");
        }
        return B;
      }
    }
    function kr(b, B) {
      {
        if (!b._store || b._store.validated || b.key != null)
          return;
        b._store.validated = !0;
        var z = Ri(B);
        if (Rr[z])
          return;
        Rr[z] = !0;
        var oe = "";
        b && b._owner && b._owner !== yn.current && (oe = " It was passed a child from " + Y(b._owner.type) + "."), dt(b), _('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', z, oe), dt(null);
      }
    }
    function Ir(b, B) {
      {
        if (typeof b != "object")
          return;
        if (Oe(b))
          for (var z = 0; z < b.length; z++) {
            var oe = b[z];
            En(oe) && kr(oe, B);
          }
        else if (En(b))
          b._store && (b._store.validated = !0);
        else if (b) {
          var he = C(b);
          if (typeof he == "function" && he !== b.entries)
            for (var we = he.call(b), de; !(de = we.next()).done; )
              En(de.value) && kr(de.value, B);
        }
      }
    }
    function ki(b) {
      {
        var B = b.type;
        if (B == null || typeof B == "string")
          return;
        var z;
        if (typeof B == "function")
          z = B.propTypes;
        else if (typeof B == "object" && (B.$$typeof === f || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        B.$$typeof === v))
          z = B.propTypes;
        else
          return;
        if (z) {
          var oe = Y(B);
          ve(z, b.props, "prop", oe, b);
        } else if (B.PropTypes !== void 0 && !wn) {
          wn = !0;
          var he = Y(B);
          _("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", he || "Unknown");
        }
        typeof B.getDefaultProps == "function" && !B.getDefaultProps.isReactClassApproved && _("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Ii(b) {
      {
        for (var B = Object.keys(b.props), z = 0; z < B.length; z++) {
          var oe = B[z];
          if (oe !== "children" && oe !== "key") {
            dt(b), _("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", oe), dt(null);
            break;
          }
        }
        b.ref !== null && (dt(b), _("Invalid attribute `ref` supplied to `React.Fragment`."), dt(null));
      }
    }
    function Ar(b, B, z, oe, he, we) {
      {
        var de = se(b);
        if (!de) {
          var le = "";
          (b === void 0 || typeof b == "object" && b !== null && Object.keys(b).length === 0) && (le += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Ae = _i(he);
          Ae ? le += Ae : le += _r();
          var Te;
          b === null ? Te = "null" : Oe(b) ? Te = "array" : b !== void 0 && b.$$typeof === t ? (Te = "<" + (Y(b.type) || "Unknown") + " />", le = " Did you accidentally export a JSX literal instead of a component?") : Te = typeof b, _("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Te, le);
        }
        var Pe = Pi(b, B, z, he, we);
        if (Pe == null)
          return Pe;
        if (de) {
          var Fe = B.children;
          if (Fe !== void 0)
            if (oe)
              if (Oe(Fe)) {
                for (var pt = 0; pt < Fe.length; pt++)
                  Ir(Fe[pt], b);
                Object.freeze && Object.freeze(Fe);
              } else
                _("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ir(Fe, b);
        }
        return b === r ? Ii(Pe) : ki(Pe), Pe;
      }
    }
    function Ai(b, B, z) {
      return Ar(b, B, z, !0);
    }
    function Mi(b, B, z) {
      return Ar(b, B, z, !1);
    }
    var Di = Mi, ji = Ai;
    Tt.Fragment = r, Tt.jsx = Di, Tt.jsxs = ji;
  }()), Tt;
}
process.env.NODE_ENV === "production" ? Vn.exports = Li() : Vn.exports = Vi();
var W = Vn.exports, Bn = { exports: {} }, Nt = { exports: {} }, me = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Nr;
function Bi() {
  if (Nr)
    return me;
  Nr = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function N(x) {
    if (typeof x == "object" && x !== null) {
      var j = x.$$typeof;
      switch (j) {
        case t:
          switch (x = x.type, x) {
            case f:
            case u:
            case r:
            case a:
            case o:
            case v:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case h:
                case S:
                case y:
                case c:
                  return x;
                default:
                  return j;
              }
          }
        case n:
          return j;
      }
    }
  }
  function P(x) {
    return N(x) === u;
  }
  return me.AsyncMode = f, me.ConcurrentMode = u, me.ContextConsumer = s, me.ContextProvider = c, me.Element = t, me.ForwardRef = h, me.Fragment = r, me.Lazy = S, me.Memo = y, me.Portal = n, me.Profiler = a, me.StrictMode = o, me.Suspense = v, me.isAsyncMode = function(x) {
    return P(x) || N(x) === f;
  }, me.isConcurrentMode = P, me.isContextConsumer = function(x) {
    return N(x) === s;
  }, me.isContextProvider = function(x) {
    return N(x) === c;
  }, me.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, me.isForwardRef = function(x) {
    return N(x) === h;
  }, me.isFragment = function(x) {
    return N(x) === r;
  }, me.isLazy = function(x) {
    return N(x) === S;
  }, me.isMemo = function(x) {
    return N(x) === y;
  }, me.isPortal = function(x) {
    return N(x) === n;
  }, me.isProfiler = function(x) {
    return N(x) === a;
  }, me.isStrictMode = function(x) {
    return N(x) === o;
  }, me.isSuspense = function(x) {
    return N(x) === v;
  }, me.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === u || x === a || x === o || x === v || x === w || typeof x == "object" && x !== null && (x.$$typeof === S || x.$$typeof === y || x.$$typeof === c || x.$$typeof === s || x.$$typeof === h || x.$$typeof === C || x.$$typeof === $ || x.$$typeof === _ || x.$$typeof === m);
  }, me.typeOf = N, me;
}
var ge = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Fr;
function Ui() {
  return Fr || (Fr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, c = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, h = e ? Symbol.for("react.forward_ref") : 60112, v = e ? Symbol.for("react.suspense") : 60113, w = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, S = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function N(I) {
      return typeof I == "string" || typeof I == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      I === r || I === u || I === a || I === o || I === v || I === w || typeof I == "object" && I !== null && (I.$$typeof === S || I.$$typeof === y || I.$$typeof === c || I.$$typeof === s || I.$$typeof === h || I.$$typeof === C || I.$$typeof === $ || I.$$typeof === _ || I.$$typeof === m);
    }
    function P(I) {
      if (typeof I == "object" && I !== null) {
        var T = I.$$typeof;
        switch (T) {
          case t:
            var F = I.type;
            switch (F) {
              case f:
              case u:
              case r:
              case a:
              case o:
              case v:
                return F;
              default:
                var U = F && F.$$typeof;
                switch (U) {
                  case s:
                  case h:
                  case S:
                  case y:
                  case c:
                    return U;
                  default:
                    return T;
                }
            }
          case n:
            return T;
        }
      }
    }
    var x = f, j = u, q = s, K = c, Z = t, se = h, X = r, H = S, Y = y, ee = n, re = a, ie = o, te = v, ue = !1;
    function d(I) {
      return ue || (ue = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), p(I) || P(I) === f;
    }
    function p(I) {
      return P(I) === u;
    }
    function g(I) {
      return P(I) === s;
    }
    function l(I) {
      return P(I) === c;
    }
    function i(I) {
      return typeof I == "object" && I !== null && I.$$typeof === t;
    }
    function E(I) {
      return P(I) === h;
    }
    function A(I) {
      return P(I) === r;
    }
    function D(I) {
      return P(I) === S;
    }
    function O(I) {
      return P(I) === y;
    }
    function k(I) {
      return P(I) === n;
    }
    function R(I) {
      return P(I) === a;
    }
    function M(I) {
      return P(I) === o;
    }
    function L(I) {
      return P(I) === v;
    }
    ge.AsyncMode = x, ge.ConcurrentMode = j, ge.ContextConsumer = q, ge.ContextProvider = K, ge.Element = Z, ge.ForwardRef = se, ge.Fragment = X, ge.Lazy = H, ge.Memo = Y, ge.Portal = ee, ge.Profiler = re, ge.StrictMode = ie, ge.Suspense = te, ge.isAsyncMode = d, ge.isConcurrentMode = p, ge.isContextConsumer = g, ge.isContextProvider = l, ge.isElement = i, ge.isForwardRef = E, ge.isFragment = A, ge.isLazy = D, ge.isMemo = O, ge.isPortal = k, ge.isProfiler = R, ge.isStrictMode = M, ge.isSuspense = L, ge.isValidElementType = N, ge.typeOf = P;
  }()), ge;
}
var Lr;
function Co() {
  return Lr || (Lr = 1, process.env.NODE_ENV === "production" ? Nt.exports = Bi() : Nt.exports = Ui()), Nt.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Sn, Vr;
function Wi() {
  if (Vr)
    return Sn;
  Vr = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var c = {}, s = 0; s < 10; s++)
        c["_" + String.fromCharCode(s)] = s;
      var f = Object.getOwnPropertyNames(c).map(function(h) {
        return c[h];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(h) {
        u[h] = h;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Sn = o() ? Object.assign : function(a, c) {
    for (var s, f = r(a), u, h = 1; h < arguments.length; h++) {
      s = Object(arguments[h]);
      for (var v in s)
        t.call(s, v) && (f[v] = s[v]);
      if (e) {
        u = e(s);
        for (var w = 0; w < u.length; w++)
          n.call(s, u[w]) && (f[u[w]] = s[u[w]]);
      }
    }
    return f;
  }, Sn;
}
var $n, Br;
function or() {
  if (Br)
    return $n;
  Br = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return $n = e, $n;
}
var Cn, Ur;
function xo() {
  return Ur || (Ur = 1, Cn = Function.call.bind(Object.prototype.hasOwnProperty)), Cn;
}
var xn, Wr;
function Yi() {
  if (Wr)
    return xn;
  Wr = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = or(), n = {}, r = xo();
    e = function(a) {
      var c = "Warning: " + a;
      typeof console < "u" && console.error(c);
      try {
        throw new Error(c);
      } catch {
      }
    };
  }
  function o(a, c, s, f, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var h in a)
        if (r(a, h)) {
          var v;
          try {
            if (typeof a[h] != "function") {
              var w = Error(
                (f || "React class") + ": " + s + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw w.name = "Invariant Violation", w;
            }
            v = a[h](c, h, f, s, null, t);
          } catch (S) {
            v = S;
          }
          if (v && !(v instanceof Error) && e(
            (f || "React class") + ": type specification of " + s + " `" + h + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof v + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), v instanceof Error && !(v.message in n)) {
            n[v.message] = !0;
            var y = u ? u() : "";
            e(
              "Failed " + s + " type: " + v.message + (y ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, xn = o, xn;
}
var On, Yr;
function qi() {
  if (Yr)
    return On;
  Yr = 1;
  var e = Co(), t = Wi(), n = or(), r = xo(), o = Yi(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var f = "Warning: " + s;
    typeof console < "u" && console.error(f);
    try {
      throw new Error(f);
    } catch {
    }
  });
  function c() {
    return null;
  }
  return On = function(s, f) {
    var u = typeof Symbol == "function" && Symbol.iterator, h = "@@iterator";
    function v(p) {
      var g = p && (u && p[u] || p[h]);
      if (typeof g == "function")
        return g;
    }
    var w = "<<anonymous>>", y = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: _(),
      arrayOf: N,
      element: P(),
      elementType: x(),
      instanceOf: j,
      node: se(),
      objectOf: K,
      oneOf: q,
      oneOfType: Z,
      shape: H,
      exact: Y
    };
    function S(p, g) {
      return p === g ? p !== 0 || 1 / p === 1 / g : p !== p && g !== g;
    }
    function m(p, g) {
      this.message = p, this.data = g && typeof g == "object" ? g : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function C(p) {
      if (process.env.NODE_ENV !== "production")
        var g = {}, l = 0;
      function i(A, D, O, k, R, M, L) {
        if (k = k || w, M = M || O, L !== n) {
          if (f) {
            var I = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw I.name = "Invariant Violation", I;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var T = k + ":" + O;
            !g[T] && // Avoid spamming the console because they are often not actionable except for lib authors
            l < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + M + "` prop on `" + k + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), g[T] = !0, l++);
          }
        }
        return D[O] == null ? A ? D[O] === null ? new m("The " + R + " `" + M + "` is marked as required " + ("in `" + k + "`, but its value is `null`.")) : new m("The " + R + " `" + M + "` is marked as required in " + ("`" + k + "`, but its value is `undefined`.")) : null : p(D, O, k, R, M);
      }
      var E = i.bind(null, !1);
      return E.isRequired = i.bind(null, !0), E;
    }
    function $(p) {
      function g(l, i, E, A, D, O) {
        var k = l[i], R = ie(k);
        if (R !== p) {
          var M = te(k);
          return new m(
            "Invalid " + A + " `" + D + "` of type " + ("`" + M + "` supplied to `" + E + "`, expected ") + ("`" + p + "`."),
            { expectedType: p }
          );
        }
        return null;
      }
      return C(g);
    }
    function _() {
      return C(c);
    }
    function N(p) {
      function g(l, i, E, A, D) {
        if (typeof p != "function")
          return new m("Property `" + D + "` of component `" + E + "` has invalid PropType notation inside arrayOf.");
        var O = l[i];
        if (!Array.isArray(O)) {
          var k = ie(O);
          return new m("Invalid " + A + " `" + D + "` of type " + ("`" + k + "` supplied to `" + E + "`, expected an array."));
        }
        for (var R = 0; R < O.length; R++) {
          var M = p(O, R, E, A, D + "[" + R + "]", n);
          if (M instanceof Error)
            return M;
        }
        return null;
      }
      return C(g);
    }
    function P() {
      function p(g, l, i, E, A) {
        var D = g[l];
        if (!s(D)) {
          var O = ie(D);
          return new m("Invalid " + E + " `" + A + "` of type " + ("`" + O + "` supplied to `" + i + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(p);
    }
    function x() {
      function p(g, l, i, E, A) {
        var D = g[l];
        if (!e.isValidElementType(D)) {
          var O = ie(D);
          return new m("Invalid " + E + " `" + A + "` of type " + ("`" + O + "` supplied to `" + i + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(p);
    }
    function j(p) {
      function g(l, i, E, A, D) {
        if (!(l[i] instanceof p)) {
          var O = p.name || w, k = d(l[i]);
          return new m("Invalid " + A + " `" + D + "` of type " + ("`" + k + "` supplied to `" + E + "`, expected ") + ("instance of `" + O + "`."));
        }
        return null;
      }
      return C(g);
    }
    function q(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), c;
      function g(l, i, E, A, D) {
        for (var O = l[i], k = 0; k < p.length; k++)
          if (S(O, p[k]))
            return null;
        var R = JSON.stringify(p, function(L, I) {
          var T = te(I);
          return T === "symbol" ? String(I) : I;
        });
        return new m("Invalid " + A + " `" + D + "` of value `" + String(O) + "` " + ("supplied to `" + E + "`, expected one of " + R + "."));
      }
      return C(g);
    }
    function K(p) {
      function g(l, i, E, A, D) {
        if (typeof p != "function")
          return new m("Property `" + D + "` of component `" + E + "` has invalid PropType notation inside objectOf.");
        var O = l[i], k = ie(O);
        if (k !== "object")
          return new m("Invalid " + A + " `" + D + "` of type " + ("`" + k + "` supplied to `" + E + "`, expected an object."));
        for (var R in O)
          if (r(O, R)) {
            var M = p(O, R, E, A, D + "." + R, n);
            if (M instanceof Error)
              return M;
          }
        return null;
      }
      return C(g);
    }
    function Z(p) {
      if (!Array.isArray(p))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), c;
      for (var g = 0; g < p.length; g++) {
        var l = p[g];
        if (typeof l != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ue(l) + " at index " + g + "."
          ), c;
      }
      function i(E, A, D, O, k) {
        for (var R = [], M = 0; M < p.length; M++) {
          var L = p[M], I = L(E, A, D, O, k, n);
          if (I == null)
            return null;
          I.data && r(I.data, "expectedType") && R.push(I.data.expectedType);
        }
        var T = R.length > 0 ? ", expected one of type [" + R.join(", ") + "]" : "";
        return new m("Invalid " + O + " `" + k + "` supplied to " + ("`" + D + "`" + T + "."));
      }
      return C(i);
    }
    function se() {
      function p(g, l, i, E, A) {
        return ee(g[l]) ? null : new m("Invalid " + E + " `" + A + "` supplied to " + ("`" + i + "`, expected a ReactNode."));
      }
      return C(p);
    }
    function X(p, g, l, i, E) {
      return new m(
        (p || "React class") + ": " + g + " type `" + l + "." + i + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + E + "`."
      );
    }
    function H(p) {
      function g(l, i, E, A, D) {
        var O = l[i], k = ie(O);
        if (k !== "object")
          return new m("Invalid " + A + " `" + D + "` of type `" + k + "` " + ("supplied to `" + E + "`, expected `object`."));
        for (var R in p) {
          var M = p[R];
          if (typeof M != "function")
            return X(E, A, D, R, te(M));
          var L = M(O, R, E, A, D + "." + R, n);
          if (L)
            return L;
        }
        return null;
      }
      return C(g);
    }
    function Y(p) {
      function g(l, i, E, A, D) {
        var O = l[i], k = ie(O);
        if (k !== "object")
          return new m("Invalid " + A + " `" + D + "` of type `" + k + "` " + ("supplied to `" + E + "`, expected `object`."));
        var R = t({}, l[i], p);
        for (var M in R) {
          var L = p[M];
          if (r(p, M) && typeof L != "function")
            return X(E, A, D, M, te(L));
          if (!L)
            return new m(
              "Invalid " + A + " `" + D + "` key `" + M + "` supplied to `" + E + "`.\nBad object: " + JSON.stringify(l[i], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(p), null, "  ")
            );
          var I = L(O, M, E, A, D + "." + M, n);
          if (I)
            return I;
        }
        return null;
      }
      return C(g);
    }
    function ee(p) {
      switch (typeof p) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !p;
        case "object":
          if (Array.isArray(p))
            return p.every(ee);
          if (p === null || s(p))
            return !0;
          var g = v(p);
          if (g) {
            var l = g.call(p), i;
            if (g !== p.entries) {
              for (; !(i = l.next()).done; )
                if (!ee(i.value))
                  return !1;
            } else
              for (; !(i = l.next()).done; ) {
                var E = i.value;
                if (E && !ee(E[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function re(p, g) {
      return p === "symbol" ? !0 : g ? g["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && g instanceof Symbol : !1;
    }
    function ie(p) {
      var g = typeof p;
      return Array.isArray(p) ? "array" : p instanceof RegExp ? "object" : re(g, p) ? "symbol" : g;
    }
    function te(p) {
      if (typeof p > "u" || p === null)
        return "" + p;
      var g = ie(p);
      if (g === "object") {
        if (p instanceof Date)
          return "date";
        if (p instanceof RegExp)
          return "regexp";
      }
      return g;
    }
    function ue(p) {
      var g = te(p);
      switch (g) {
        case "array":
        case "object":
          return "an " + g;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + g;
        default:
          return g;
      }
    }
    function d(p) {
      return !p.constructor || !p.constructor.name ? w : p.constructor.name;
    }
    return y.checkPropTypes = o, y.resetWarningCache = o.resetWarningCache, y.PropTypes = y, y;
  }, On;
}
var Tn, qr;
function zi() {
  if (qr)
    return Tn;
  qr = 1;
  var e = or();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Tn = function() {
    function r(c, s, f, u, h, v) {
      if (v !== e) {
        var w = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw w.name = "Invariant Violation", w;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, Tn;
}
if (process.env.NODE_ENV !== "production") {
  var Ki = Co(), Hi = !0;
  Bn.exports = qi()(Ki.isElement, Hi);
} else
  Bn.exports = zi()();
var Xi = Bn.exports;
const V = /* @__PURE__ */ $o(Xi);
/**
 * @preserve
 * Represents a colorful country flag component.
 *
 * @param {object} props - The props for the CountryFlag component.
 * @param {'us' | 'ca' | 'uk'} props.countryCode - The country code. Should match one of the flag svg files in mds-assets/country-flags folder.
 * @param {number} props.size - The size of country flag. Size is optional and only set the css variables(see styles.css).
 *
 * @returns {JSX.Element} The country flag component.
 */
function gt({ countryCode: e, size: t }) {
  const n = {};
  return e && (n["--country-flag-url"] = `url(${Gi(e)})`), t && (n["--country-flag-size"] = t + "px"), /* @__PURE__ */ W.jsx(
    "i",
    {
      className: `mds-country-flag country-flag-${e}`,
      style: n
    }
  );
}
gt.propTypes = {
  countryCode: V.oneOf(["us", "ca", "uk"]).isRequired,
  size: V.number
};
gt.defaultProps = {
  countryCode: null
  // size: 24, // do not set default size, to make it easier for other components to override the --country-flag-size css variable
};
function Gi(e) {
  var n, r;
  return `${((r = (n = window.mileiq) == null ? void 0 : n.designsystem) == null ? void 0 : r.flagsPath) || "/mds-assets/country-flags/"}${e}.svg`;
}
/**
 * @preserve
 * Represents an icon component.
 *
 * @param {object} props - The props for the Icon component.
 * @param {string} props.name - The name of the icon. Name should match one of the icon files in mds-assets/icons folder.
 * @param {string} props.color - The color of the icon. Color is optional and only set the css variables(see styles.css).
 * @param {number} props.size - The size of the icon. Size is optional and only set the css variables(see styles.css).
 *
 * @returns {JSX.Element} The Icon component.
 */
function Ee({ name: e, color: t, size: n }) {
  const r = {};
  return e && (r["--icon-url"] = `url(${Zi(e)})`), t && (r["--icon-color"] = t), n && (r["--icon-size"] = n + "px"), /* @__PURE__ */ W.jsx("i", { className: `mds-icon icon-${e}`, style: r });
}
Ee.propTypes = {
  name: V.string,
  color: V.string,
  size: V.number
};
Ee.defaultProps = {
  name: "",
  color: ""
  // size: 24, // do not set default size, to make it easier for other components to override the --icon-size css variable
};
/**
 * @preserve
 *
 * Dynamically generates the URL for an icon based on the provided name.
 * This function checks if a custom icon URL path is defined
 * in the global `window.mileiq.designsystem.iconsPath` object. If so, it uses this path to construct the icon URL.
 * Otherwise, it defaults to using the path within the `/mds-assets/icons` directory.
 *
 * @param {string} name - The name of the icon for which to generate the URL.
 * @returns {string} The URL to the icon.
 */
function Zi(e) {
  var n, r;
  return `${((r = (n = window.mileiq) == null ? void 0 : n.designsystem) == null ? void 0 : r.iconsPath) || "/mds-assets/icons/"}${e}.svg`;
}
const Ue = () => {
}, cl = Ie.forwardRef(ir);
/**
 * @preserve
 *
 * FilterButton component
 *
 * @param {Object} props - Props for FilterButton
 * @param {boolean} [props.showArrow] - Determines if the arrow icon is shown
 * @param {number} [props.count] - Count to display
 * @param {string} [props.label] - Text label for the button
 * @param {string} [props.iconLeft] - Left icon name
 * @param {function} [props.onClear] - Function to call when the clear icon is clicked
 * @param {Object} ref - Ref forwarding for the button
 * @returns {React.ReactElement} A FilterButton component
 */
function ir({ showArrow: e, count: t, label: n, iconLeft: r, onClear: o, ...a }, c) {
  function s(h) {
    h.preventDefault(), o();
  }
  let f = ["mds-button", "mds-filter-button"], u = [];
  return r && (u.push(/* @__PURE__ */ W.jsx(Ee, { name: r }, r)), f.push("with-icon-left")), u.push(
    /* @__PURE__ */ W.jsx("span", { className: "mds-button-label", children: n }, n)
  ), t && (u.push(
    /* @__PURE__ */ W.jsx("span", { className: "mds-filter-button-count", children: t }, "count")
  ), u.push(/* @__PURE__ */ W.jsx(Ee, { name: "close", onClick: s }, "close")), f.push("with-value", "with-icon-right")), !t && e && (u.push(/* @__PURE__ */ W.jsx(Ee, { name: "arrow-down" }, "arrow-down")), f.push("with-icon-right")), /* @__PURE__ */ W.jsx("button", { ref: c, className: f.join(" "), ...a, children: /* @__PURE__ */ W.jsx("span", { className: "mds-button-content", children: u }) });
}
ir.propTypes = {
  showArrow: V.bool,
  count: V.number,
  label: V.string,
  iconLeft: V.string,
  onClear: V.func
};
ir.defaultProps = {
  showArrow: !1,
  count: null,
  label: "",
  iconLeft: null,
  onClear: Ue
};
const ul = fe(ar);
/**
 * @preserve
 *
 * Button component
 *
 * @param {Object} props - Props for Button component
 * @param {string} props.variant - Determines the button style variant (primary, secondary, tertiary, destructive)
 * @param {string} props.label - Text label for the button
 * @param {string} [props.iconLeft] - Optional icon displayed on the left side of the label
 * @param {string} [props.iconRight] - Optional icon displayed on the right side of the label
 * @param {boolean} [props.loading=false] - If true, the button displays in a loading state
 * @param {Object} ref - Ref forwarding for the button
 * @returns {React.ReactElement} A Button component
 */
function ar({ variant: e, label: t, iconLeft: n, iconRight: r, loading: o, ...a }, c) {
  let s = ["mds-button"];
  switch (e) {
    case "primary":
      s.push("primary");
      break;
    case "secondary":
      s.push("secondary");
      break;
    case "tertiary":
      s.push("tertiary");
      break;
    case "destructive":
      s.push("destructive");
      break;
    default:
      s.push("primary");
      break;
  }
  let f = [
    /* @__PURE__ */ W.jsx("span", { className: "mds-button-label", children: t }, t)
  ];
  return n && (f.unshift(/* @__PURE__ */ W.jsx(Ee, { name: n }, n)), s.push("with-icon-left")), r && (f.push(/* @__PURE__ */ W.jsx(Ee, { name: r }, r)), s.push("with-icon-right")), o && s.push("loading"), /* @__PURE__ */ W.jsx("button", { ref: c, className: s.join(" "), ...a, children: /* @__PURE__ */ W.jsx("span", { className: "mds-button-content", children: f }) });
}
ar.propTypes = {
  variant: V.oneOf(["primary", "secondary", "tertiary", "destructive"]),
  loading: V.bool,
  label: V.string,
  iconLeft: V.string,
  iconRight: V.string
};
ar.defaultProps = {
  variant: "primary",
  loading: !1,
  label: "",
  iconLeft: "",
  iconRight: ""
};
const ll = fe(sr);
/**
 * @preserve
 * @component
 *
 * IconButton component to render a button with an icon.
 *
 * @param {Object} props - Props for IconButton
 * @param {string} props.icon - The icon name to display in the button.
 * @param {string} props.variant - Determines the button style variant (primary, secondary, tertiary, destructive).
 * @param {boolean} props.loading - If true, the button displays in a loading state.
 * @param {Object} ref - Ref forwarded to the button element.
 */
function sr({ icon: e, variant: t, loading: n, ...r }, o) {
  const a = ["mds-icon-button"];
  switch (t) {
    case "primary":
      a.push("primary");
      break;
    case "secondary":
      a.push("secondary");
      break;
    case "tertiary":
      a.push("tertiary");
      break;
    case "destructive":
      a.push("destructive");
      break;
    default:
      a.push("primary");
      break;
  }
  return n && a.push("loading"), /* @__PURE__ */ W.jsx("button", { ref: o, className: a.join(" "), ...r, children: /* @__PURE__ */ W.jsx(Ee, { name: e }) });
}
sr.propTypes = {
  variant: V.oneOf(["primary", "secondary", "tertiary", "destructive"]),
  icon: V.string,
  loading: V.bool
};
sr.defaultProps = {
  variant: "primary",
  icon: "",
  loading: !1
};
const fl = fe(cr);
/**
 * @preserve
 *
 * ClassificationButton
 *
 * @param {Object} props - Props for ClassificationButton
 * @param {string} props.variant - Determines the button variant (personal or business)
 * @param {boolean} [props.iconOnly=false] - Determines if the button should display icon only
 * @param {string} props.label - Button label
 * @param {string} [props.iconRight] - Optional right icon name
 * @param {boolean} [props.loading=false] - Determines if the button is in loading state
 * @param {Object} ref - Ref forwarding for the button
 * @returns {React.ReactElement} A ClassificationButton component
 */
function cr({ variant: e, iconOnly: t, label: n, iconRight: r, loading: o, ...a }, c) {
  let s = null, f, u = ["mds-classification-button"];
  switch (e) {
    case "personal":
      u.push("personal"), f = "personal", n = n ?? "Personal";
      break;
    case "business":
    default:
      u.push("business"), f = "business", n = n ?? "Business";
      break;
  }
  return t ? (u.push("mds-icon-button"), s = /* @__PURE__ */ W.jsx(Ee, { name: f })) : (u.push("mds-button", "with-icon-left"), s = [
    /* @__PURE__ */ W.jsx(Ee, { name: f }, f),
    /* @__PURE__ */ W.jsx("span", { className: "mds-button-label", children: n }, n)
  ], r && (s.push(/* @__PURE__ */ W.jsx(Ee, { name: r }, r)), u.push("with-icon-right"))), o && u.push("loading"), /* @__PURE__ */ W.jsx("button", { ref: c, className: u.join(" "), ...a, children: /* @__PURE__ */ W.jsx("span", { className: "mds-button-content", children: s }) });
}
cr.propTypes = {
  variant: V.oneOf(["business", "personal"]),
  iconOnly: V.bool,
  loading: V.bool,
  label: V.string,
  iconRight: V.string
};
cr.defaultProps = {
  variant: "business",
  iconOnly: !1,
  loading: !1,
  label: "",
  iconRight: ""
};
const dl = fe(ur);
/**
 * @preserve
 * @component
 *
 * NavbarButton component to render a button specifically designed for the navbar.
 *
 * @param {Object} props - Props for NavbarButton
 * @param {string} props.icon - The icon name to display in the button.
 * @param {string} props.label - The label text for the button.
 * @param {boolean} props.isActive - Flag to indicate if the button is active.
 * @param {Object} ref - Ref forwarded to the button element.
 */
function ur({ icon: e, label: t, isActive: n, ...r }, o) {
  let a = ["mds-button", "mds-navbar-button"], c = [];
  return e && (c.push(/* @__PURE__ */ W.jsx(Ee, { name: e }, e)), a.push("with-icon-left")), c.push(
    /* @__PURE__ */ W.jsx("span", { className: "mds-button-label", children: t }, t)
  ), n && a.push("active"), /* @__PURE__ */ W.jsx("button", { ref: o, className: a.join(" "), ...r, children: /* @__PURE__ */ W.jsx("span", { className: "mds-button-content", children: c }) });
}
ur.propTypes = {
  icon: V.string,
  label: V.string.isRequired,
  isActive: V.bool
};
ur.defaultProps = {
  icon: "",
  isActive: !1
};
const pl = fe(lr);
/**
 * @preserve
 * @component
 *
 * PurposeButton component
 *
 * @param {Object} props - Props for PurposeButton
 * @param {string} props.icon - The icon name to display in the button.
 * @param {string} props.label - The label text for the button.
 * @param {Object} ref - Ref forwarded to the button element.
 */
function lr({ icon: e, label: t, ...n }, r) {
  let o = ["mds-purpose-button"];
  return e && o.push("with-icon-left"), /* @__PURE__ */ W.jsxs("button", { ref: r, className: o.join(" "), ...n, children: [
    /* @__PURE__ */ W.jsx(Ee, { name: e }),
    /* @__PURE__ */ W.jsx("span", { className: "mds-button-label", children: t }),
    /* @__PURE__ */ W.jsx(Ee, { name: "arrow-down" })
  ] });
}
lr.propTypes = {
  icon: V.string,
  label: V.string.isRequired
};
lr.defaultProps = {
  icon: "",
  label: ""
};
function ye() {
  return ye = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ye.apply(this, arguments);
}
function Se(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Ji(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function fr(...e) {
  return (t) => e.forEach(
    (n) => Ji(n, t)
  );
}
function Le(...e) {
  return _e(fr(...e), e);
}
function It(e, t = []) {
  let n = [];
  function r(a, c) {
    const s = /* @__PURE__ */ Kt(c), f = n.length;
    n = [
      ...n,
      c
    ];
    function u(v) {
      const { scope: w, children: y, ...S } = v, m = (w == null ? void 0 : w[e][f]) || s, C = Pt(
        () => S,
        Object.values(S)
      );
      return /* @__PURE__ */ ne(m.Provider, {
        value: C
      }, y);
    }
    function h(v, w) {
      const y = (w == null ? void 0 : w[e][f]) || s, S = tr(y);
      if (S)
        return S;
      if (c !== void 0)
        return c;
      throw new Error(`\`${v}\` must be used within \`${a}\``);
    }
    return u.displayName = a + "Provider", [
      u,
      h
    ];
  }
  const o = () => {
    const a = n.map((c) => /* @__PURE__ */ Kt(c));
    return function(s) {
      const f = (s == null ? void 0 : s[e]) || a;
      return Pt(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: f
          }
        }),
        [
          s,
          f
        ]
      );
    };
  };
  return o.scopeName = e, [
    r,
    Qi(o, ...t)
  ];
}
function Qi(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(a) {
      const c = r.reduce((s, { useScope: f, scopeName: u }) => {
        const v = f(a)[`__scope${u}`];
        return {
          ...s,
          ...v
        };
      }, {});
      return Pt(
        () => ({
          [`__scope${t.scopeName}`]: c
        }),
        [
          c
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function We(e) {
  const t = pe(e);
  return $e(() => {
    t.current = e;
  }), Pt(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function Oo({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, o] = ea({
    defaultProp: t,
    onChange: n
  }), a = e !== void 0, c = a ? e : r, s = We(n), f = _e((u) => {
    if (a) {
      const v = typeof u == "function" ? u(e) : u;
      v !== e && s(v);
    } else
      o(u);
  }, [
    a,
    e,
    o,
    s
  ]);
  return [
    c,
    f
  ];
}
function ea({ defaultProp: e, onChange: t }) {
  const n = xe(e), [r] = n, o = pe(r), a = We(t);
  return $e(() => {
    o.current !== r && (a(r), o.current = r);
  }, [
    r,
    o,
    a
  ]), n;
}
const _t = /* @__PURE__ */ fe((e, t) => {
  const { children: n, ...r } = e, o = bt.toArray(n), a = o.find(na);
  if (a) {
    const c = a.props.children, s = o.map((f) => f === a ? bt.count(c) > 1 ? bt.only(null) : /* @__PURE__ */ Ht(c) ? c.props.children : null : f);
    return /* @__PURE__ */ ne(Un, ye({}, r, {
      ref: t
    }), /* @__PURE__ */ Ht(c) ? /* @__PURE__ */ nr(c, void 0, s) : null);
  }
  return /* @__PURE__ */ ne(Un, ye({}, r, {
    ref: t
  }), n);
});
_t.displayName = "Slot";
const Un = /* @__PURE__ */ fe((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Ht(n) ? /* @__PURE__ */ nr(n, {
    ...ra(r, n.props),
    ref: t ? fr(t, n.ref) : n.ref
  }) : bt.count(n) > 1 ? bt.only(null) : null;
});
Un.displayName = "SlotClone";
const ta = ({ children: e }) => /* @__PURE__ */ ne(wo, null, e);
function na(e) {
  return /* @__PURE__ */ Ht(e) && e.type === ta;
}
function ra(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...s) => {
      a(...s), o(...s);
    } : o && (n[r] = o) : r === "style" ? n[r] = {
      ...o,
      ...a
    } : r === "className" && (n[r] = [
      o,
      a
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const oa = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Ze = oa.reduce((e, t) => {
  const n = /* @__PURE__ */ fe((r, o) => {
    const { asChild: a, ...c } = r, s = a ? _t : t;
    return $e(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ ne(s, ye({}, c, {
      ref: o
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function To(e, t) {
  e && So(
    () => e.dispatchEvent(t)
  );
}
function Po(e) {
  const t = e + "CollectionProvider", [n, r] = It(t), [o, a] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), c = (y) => {
    const { scope: S, children: m } = y, C = Ie.useRef(null), $ = Ie.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ Ie.createElement(o, {
      scope: S,
      itemMap: $,
      collectionRef: C
    }, m);
  }, s = e + "CollectionSlot", f = /* @__PURE__ */ Ie.forwardRef((y, S) => {
    const { scope: m, children: C } = y, $ = a(s, m), _ = Le(S, $.collectionRef);
    return /* @__PURE__ */ Ie.createElement(_t, {
      ref: _
    }, C);
  }), u = e + "CollectionItemSlot", h = "data-radix-collection-item", v = /* @__PURE__ */ Ie.forwardRef((y, S) => {
    const { scope: m, children: C, ...$ } = y, _ = Ie.useRef(null), N = Le(S, _), P = a(u, m);
    return Ie.useEffect(() => (P.itemMap.set(_, {
      ref: _,
      ...$
    }), () => void P.itemMap.delete(_))), /* @__PURE__ */ Ie.createElement(_t, {
      [h]: "",
      ref: N
    }, C);
  });
  function w(y) {
    const S = a(e + "CollectionConsumer", y);
    return Ie.useCallback(() => {
      const C = S.collectionRef.current;
      if (!C)
        return [];
      const $ = Array.from(C.querySelectorAll(`[${h}]`));
      return Array.from(S.itemMap.values()).sort(
        (P, x) => $.indexOf(P.ref.current) - $.indexOf(x.ref.current)
      );
    }, [
      S.collectionRef,
      S.itemMap
    ]);
  }
  return [
    {
      Provider: c,
      Slot: f,
      ItemSlot: v
    },
    w,
    r
  ];
}
const ia = /* @__PURE__ */ Kt(void 0);
function _o(e) {
  const t = tr(ia);
  return e || t || "ltr";
}
function aa(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = We(e);
  $e(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Wn = "dismissableLayer.update", sa = "dismissableLayer.pointerDownOutside", ca = "dismissableLayer.focusOutside";
let zr;
const ua = /* @__PURE__ */ Kt({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), la = /* @__PURE__ */ fe((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: o, onPointerDownOutside: a, onFocusOutside: c, onInteractOutside: s, onDismiss: f, ...u } = e, h = tr(ua), [v, w] = xe(null), y = (n = v == null ? void 0 : v.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, S] = xe({}), m = Le(
    t,
    (K) => w(K)
  ), C = Array.from(h.layers), [$] = [
    ...h.layersWithOutsidePointerEventsDisabled
  ].slice(-1), _ = C.indexOf($), N = v ? C.indexOf(v) : -1, P = h.layersWithOutsidePointerEventsDisabled.size > 0, x = N >= _, j = fa((K) => {
    const Z = K.target, se = [
      ...h.branches
    ].some(
      (X) => X.contains(Z)
    );
    !x || se || (a == null || a(K), s == null || s(K), K.defaultPrevented || f == null || f());
  }, y), q = da((K) => {
    const Z = K.target;
    [
      ...h.branches
    ].some(
      (X) => X.contains(Z)
    ) || (c == null || c(K), s == null || s(K), K.defaultPrevented || f == null || f());
  }, y);
  return aa((K) => {
    N === h.layers.size - 1 && (o == null || o(K), !K.defaultPrevented && f && (K.preventDefault(), f()));
  }, y), $e(() => {
    if (v)
      return r && (h.layersWithOutsidePointerEventsDisabled.size === 0 && (zr = y.body.style.pointerEvents, y.body.style.pointerEvents = "none"), h.layersWithOutsidePointerEventsDisabled.add(v)), h.layers.add(v), Kr(), () => {
        r && h.layersWithOutsidePointerEventsDisabled.size === 1 && (y.body.style.pointerEvents = zr);
      };
  }, [
    v,
    y,
    r,
    h
  ]), $e(() => () => {
    v && (h.layers.delete(v), h.layersWithOutsidePointerEventsDisabled.delete(v), Kr());
  }, [
    v,
    h
  ]), $e(() => {
    const K = () => S({});
    return document.addEventListener(Wn, K), () => document.removeEventListener(Wn, K);
  }, []), /* @__PURE__ */ ne(Ze.div, ye({}, u, {
    ref: m,
    style: {
      pointerEvents: P ? x ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Se(e.onFocusCapture, q.onFocusCapture),
    onBlurCapture: Se(e.onBlurCapture, q.onBlurCapture),
    onPointerDownCapture: Se(e.onPointerDownCapture, j.onPointerDownCapture)
  }));
});
function fa(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = We(e), r = pe(!1), o = pe(() => {
  });
  return $e(() => {
    const a = (s) => {
      if (s.target && !r.current) {
        let u = function() {
          Ro(sa, n, f, {
            discrete: !0
          });
        };
        const f = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = u, t.addEventListener("click", o.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, c = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(c), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function da(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = We(e), r = pe(!1);
  return $e(() => {
    const o = (a) => {
      a.target && !r.current && Ro(ca, n, {
        originalEvent: a
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Kr() {
  const e = new CustomEvent(Wn);
  document.dispatchEvent(e);
}
function Ro(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), r ? To(o, a) : o.dispatchEvent(a);
}
let Pn = 0;
function pa() {
  $e(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Hr()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Hr()), Pn++, () => {
      Pn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Pn--;
    };
  }, []);
}
function Hr() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const _n = "focusScope.autoFocusOnMount", Rn = "focusScope.autoFocusOnUnmount", Xr = {
  bubbles: !1,
  cancelable: !0
}, va = /* @__PURE__ */ fe((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: o, onUnmountAutoFocus: a, ...c } = e, [s, f] = xe(null), u = We(o), h = We(a), v = pe(null), w = Le(
    t,
    (m) => f(m)
  ), y = pe({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  $e(() => {
    if (r) {
      let m = function(N) {
        if (y.paused || !s)
          return;
        const P = N.target;
        s.contains(P) ? v.current = P : et(v.current, {
          select: !0
        });
      }, C = function(N) {
        if (y.paused || !s)
          return;
        const P = N.relatedTarget;
        P !== null && (s.contains(P) || et(v.current, {
          select: !0
        }));
      }, $ = function(N) {
        if (document.activeElement === document.body)
          for (const x of N)
            x.removedNodes.length > 0 && et(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", C);
      const _ = new MutationObserver($);
      return s && _.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", C), _.disconnect();
      };
    }
  }, [
    r,
    s,
    y.paused
  ]), $e(() => {
    if (s) {
      Zr.add(y);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const $ = new CustomEvent(_n, Xr);
        s.addEventListener(_n, u), s.dispatchEvent($), $.defaultPrevented || (ha(wa(ko(s)), {
          select: !0
        }), document.activeElement === m && et(s));
      }
      return () => {
        s.removeEventListener(_n, u), setTimeout(() => {
          const $ = new CustomEvent(Rn, Xr);
          s.addEventListener(Rn, h), s.dispatchEvent($), $.defaultPrevented || et(m ?? document.body, {
            select: !0
          }), s.removeEventListener(Rn, h), Zr.remove(y);
        }, 0);
      };
    }
  }, [
    s,
    u,
    h,
    y
  ]);
  const S = _e((m) => {
    if (!n && !r || y.paused)
      return;
    const C = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, $ = document.activeElement;
    if (C && $) {
      const _ = m.currentTarget, [N, P] = ma(_);
      N && P ? !m.shiftKey && $ === P ? (m.preventDefault(), n && et(N, {
        select: !0
      })) : m.shiftKey && $ === N && (m.preventDefault(), n && et(P, {
        select: !0
      })) : $ === _ && m.preventDefault();
    }
  }, [
    n,
    r,
    y.paused
  ]);
  return /* @__PURE__ */ ne(Ze.div, ye({
    tabIndex: -1
  }, c, {
    ref: w,
    onKeyDown: S
  }));
});
function ha(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (et(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function ma(e) {
  const t = ko(e), n = Gr(t, e), r = Gr(t.reverse(), e);
  return [
    n,
    r
  ];
}
function ko(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Gr(e, t) {
  for (const n of e)
    if (!ga(n, {
      upTo: t
    }))
      return n;
}
function ga(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function ba(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function et(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && ba(e) && t && e.select();
  }
}
const Zr = ya();
function ya() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Jr(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Jr(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Jr(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function wa(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Et = globalThis != null && globalThis.document ? Eo : () => {
}, Ea = Q.useId || (() => {
});
let Sa = 0;
function Yn(e) {
  const [t, n] = Q.useState(Ea());
  return Et(() => {
    e || n(
      (r) => r ?? String(Sa++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const $a = ["top", "right", "bottom", "left"], rt = Math.min, Me = Math.max, Xt = Math.round, Ft = Math.floor, ot = (e) => ({
  x: e,
  y: e
}), Ca = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, xa = {
  start: "end",
  end: "start"
};
function qn(e, t, n) {
  return Me(e, rt(t, n));
}
function He(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Xe(e) {
  return e.split("-")[0];
}
function $t(e) {
  return e.split("-")[1];
}
function dr(e) {
  return e === "x" ? "y" : "x";
}
function pr(e) {
  return e === "y" ? "height" : "width";
}
function Ct(e) {
  return ["top", "bottom"].includes(Xe(e)) ? "y" : "x";
}
function vr(e) {
  return dr(Ct(e));
}
function Oa(e, t, n) {
  n === void 0 && (n = !1);
  const r = $t(e), o = vr(e), a = pr(o);
  let c = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (c = Gt(c)), [c, Gt(c)];
}
function Ta(e) {
  const t = Gt(e);
  return [zn(e), t, zn(t)];
}
function zn(e) {
  return e.replace(/start|end/g, (t) => xa[t]);
}
function Pa(e, t, n) {
  const r = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], c = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? o : r : t ? r : o;
    case "left":
    case "right":
      return t ? a : c;
    default:
      return [];
  }
}
function _a(e, t, n, r) {
  const o = $t(e);
  let a = Pa(Xe(e), n === "start", r);
  return o && (a = a.map((c) => c + "-" + o), t && (a = a.concat(a.map(zn)))), a;
}
function Gt(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ca[t]);
}
function Ra(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Io(e) {
  return typeof e != "number" ? Ra(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Zt(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Qr(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = Ct(t), c = vr(t), s = pr(c), f = Xe(t), u = a === "y", h = r.x + r.width / 2 - o.width / 2, v = r.y + r.height / 2 - o.height / 2, w = r[s] / 2 - o[s] / 2;
  let y;
  switch (f) {
    case "top":
      y = {
        x: h,
        y: r.y - o.height
      };
      break;
    case "bottom":
      y = {
        x: h,
        y: r.y + r.height
      };
      break;
    case "right":
      y = {
        x: r.x + r.width,
        y: v
      };
      break;
    case "left":
      y = {
        x: r.x - o.width,
        y: v
      };
      break;
    default:
      y = {
        x: r.x,
        y: r.y
      };
  }
  switch ($t(t)) {
    case "start":
      y[c] -= w * (n && u ? -1 : 1);
      break;
    case "end":
      y[c] += w * (n && u ? -1 : 1);
      break;
  }
  return y;
}
const ka = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: c
  } = n, s = a.filter(Boolean), f = await (c.isRTL == null ? void 0 : c.isRTL(t));
  let u = await c.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: h,
    y: v
  } = Qr(u, r, f), w = r, y = {}, S = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: C,
      fn: $
    } = s[m], {
      x: _,
      y: N,
      data: P,
      reset: x
    } = await $({
      x: h,
      y: v,
      initialPlacement: r,
      placement: w,
      strategy: o,
      middlewareData: y,
      rects: u,
      platform: c,
      elements: {
        reference: e,
        floating: t
      }
    });
    h = _ ?? h, v = N ?? v, y = {
      ...y,
      [C]: {
        ...y[C],
        ...P
      }
    }, x && S <= 50 && (S++, typeof x == "object" && (x.placement && (w = x.placement), x.rects && (u = x.rects === !0 ? await c.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : x.rects), {
      x: h,
      y: v
    } = Qr(u, w, f)), m = -1);
  }
  return {
    x: h,
    y: v,
    placement: w,
    strategy: o,
    middlewareData: y
  };
};
async function Rt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: c,
    elements: s,
    strategy: f
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: h = "viewport",
    elementContext: v = "floating",
    altBoundary: w = !1,
    padding: y = 0
  } = He(t, e), S = Io(y), C = s[w ? v === "floating" ? "reference" : "floating" : v], $ = Zt(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(C))) == null || n ? C : C.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: h,
    strategy: f
  })), _ = v === "floating" ? {
    ...c.floating,
    x: r,
    y: o
  } : c.reference, N = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), P = await (a.isElement == null ? void 0 : a.isElement(N)) ? await (a.getScale == null ? void 0 : a.getScale(N)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = Zt(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: _,
    offsetParent: N,
    strategy: f
  }) : _);
  return {
    top: ($.top - x.top + S.top) / P.y,
    bottom: (x.bottom - $.bottom + S.bottom) / P.y,
    left: ($.left - x.left + S.left) / P.x,
    right: (x.right - $.right + S.right) / P.x
  };
}
const Ia = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: c,
      elements: s,
      middlewareData: f
    } = t, {
      element: u,
      padding: h = 0
    } = He(e, t) || {};
    if (u == null)
      return {};
    const v = Io(h), w = {
      x: n,
      y: r
    }, y = vr(o), S = pr(y), m = await c.getDimensions(u), C = y === "y", $ = C ? "top" : "left", _ = C ? "bottom" : "right", N = C ? "clientHeight" : "clientWidth", P = a.reference[S] + a.reference[y] - w[y] - a.floating[S], x = w[y] - a.reference[y], j = await (c.getOffsetParent == null ? void 0 : c.getOffsetParent(u));
    let q = j ? j[N] : 0;
    (!q || !await (c.isElement == null ? void 0 : c.isElement(j))) && (q = s.floating[N] || a.floating[S]);
    const K = P / 2 - x / 2, Z = q / 2 - m[S] / 2 - 1, se = rt(v[$], Z), X = rt(v[_], Z), H = se, Y = q - m[S] - X, ee = q / 2 - m[S] / 2 + K, re = qn(H, ee, Y), ie = !f.arrow && $t(o) != null && ee !== re && a.reference[S] / 2 - (ee < H ? se : X) - m[S] / 2 < 0, te = ie ? ee < H ? ee - H : ee - Y : 0;
    return {
      [y]: w[y] + te,
      data: {
        [y]: re,
        centerOffset: ee - re - te,
        ...ie && {
          alignmentOffset: te
        }
      },
      reset: ie
    };
  }
}), Aa = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: c,
        initialPlacement: s,
        platform: f,
        elements: u
      } = t, {
        mainAxis: h = !0,
        crossAxis: v = !0,
        fallbackPlacements: w,
        fallbackStrategy: y = "bestFit",
        fallbackAxisSideDirection: S = "none",
        flipAlignment: m = !0,
        ...C
      } = He(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const $ = Xe(o), _ = Xe(s) === s, N = await (f.isRTL == null ? void 0 : f.isRTL(u.floating)), P = w || (_ || !m ? [Gt(s)] : Ta(s));
      !w && S !== "none" && P.push(..._a(s, m, S, N));
      const x = [s, ...P], j = await Rt(t, C), q = [];
      let K = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (h && q.push(j[$]), v) {
        const H = Oa(o, c, N);
        q.push(j[H[0]], j[H[1]]);
      }
      if (K = [...K, {
        placement: o,
        overflows: q
      }], !q.every((H) => H <= 0)) {
        var Z, se;
        const H = (((Z = a.flip) == null ? void 0 : Z.index) || 0) + 1, Y = x[H];
        if (Y)
          return {
            data: {
              index: H,
              overflows: K
            },
            reset: {
              placement: Y
            }
          };
        let ee = (se = K.filter((re) => re.overflows[0] <= 0).sort((re, ie) => re.overflows[1] - ie.overflows[1])[0]) == null ? void 0 : se.placement;
        if (!ee)
          switch (y) {
            case "bestFit": {
              var X;
              const re = (X = K.map((ie) => [ie.placement, ie.overflows.filter((te) => te > 0).reduce((te, ue) => te + ue, 0)]).sort((ie, te) => ie[1] - te[1])[0]) == null ? void 0 : X[0];
              re && (ee = re);
              break;
            }
            case "initialPlacement":
              ee = s;
              break;
          }
        if (o !== ee)
          return {
            reset: {
              placement: ee
            }
          };
      }
      return {};
    }
  };
};
function eo(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function to(e) {
  return $a.some((t) => e[t] >= 0);
}
const Ma = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = He(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await Rt(t, {
            ...o,
            elementContext: "reference"
          }), c = eo(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: c,
              referenceHidden: to(c)
            }
          };
        }
        case "escaped": {
          const a = await Rt(t, {
            ...o,
            altBoundary: !0
          }), c = eo(a, n.floating);
          return {
            data: {
              escapedOffsets: c,
              escaped: to(c)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Da(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), c = Xe(n), s = $t(n), f = Ct(n) === "y", u = ["left", "top"].includes(c) ? -1 : 1, h = a && f ? -1 : 1, v = He(t, e);
  let {
    mainAxis: w,
    crossAxis: y,
    alignmentAxis: S
  } = typeof v == "number" ? {
    mainAxis: v,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...v
  };
  return s && typeof S == "number" && (y = s === "end" ? S * -1 : S), f ? {
    x: y * h,
    y: w * u
  } : {
    x: w * u,
    y: y * h
  };
}
const ja = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: c,
        middlewareData: s
      } = t, f = await Da(t, e);
      return c === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: o + f.x,
        y: a + f.y,
        data: {
          ...f,
          placement: c
        }
      };
    }
  };
}, Na = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: c = !1,
        limiter: s = {
          fn: (C) => {
            let {
              x: $,
              y: _
            } = C;
            return {
              x: $,
              y: _
            };
          }
        },
        ...f
      } = He(e, t), u = {
        x: n,
        y: r
      }, h = await Rt(t, f), v = Ct(Xe(o)), w = dr(v);
      let y = u[w], S = u[v];
      if (a) {
        const C = w === "y" ? "top" : "left", $ = w === "y" ? "bottom" : "right", _ = y + h[C], N = y - h[$];
        y = qn(_, y, N);
      }
      if (c) {
        const C = v === "y" ? "top" : "left", $ = v === "y" ? "bottom" : "right", _ = S + h[C], N = S - h[$];
        S = qn(_, S, N);
      }
      const m = s.fn({
        ...t,
        [w]: y,
        [v]: S
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - r
        }
      };
    }
  };
}, Fa = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: c
      } = t, {
        offset: s = 0,
        mainAxis: f = !0,
        crossAxis: u = !0
      } = He(e, t), h = {
        x: n,
        y: r
      }, v = Ct(o), w = dr(v);
      let y = h[w], S = h[v];
      const m = He(s, t), C = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (f) {
        const N = w === "y" ? "height" : "width", P = a.reference[w] - a.floating[N] + C.mainAxis, x = a.reference[w] + a.reference[N] - C.mainAxis;
        y < P ? y = P : y > x && (y = x);
      }
      if (u) {
        var $, _;
        const N = w === "y" ? "width" : "height", P = ["top", "left"].includes(Xe(o)), x = a.reference[v] - a.floating[N] + (P && (($ = c.offset) == null ? void 0 : $[v]) || 0) + (P ? 0 : C.crossAxis), j = a.reference[v] + a.reference[N] + (P ? 0 : ((_ = c.offset) == null ? void 0 : _[v]) || 0) - (P ? C.crossAxis : 0);
        S < x ? S = x : S > j && (S = j);
      }
      return {
        [w]: y,
        [v]: S
      };
    }
  };
}, La = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: o,
        elements: a
      } = t, {
        apply: c = () => {
        },
        ...s
      } = He(e, t), f = await Rt(t, s), u = Xe(n), h = $t(n), v = Ct(n) === "y", {
        width: w,
        height: y
      } = r.floating;
      let S, m;
      u === "top" || u === "bottom" ? (S = u, m = h === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (m = u, S = h === "end" ? "top" : "bottom");
      const C = y - f[S], $ = w - f[m], _ = !t.middlewareData.shift;
      let N = C, P = $;
      if (v) {
        const j = w - f.left - f.right;
        P = h || _ ? rt($, j) : j;
      } else {
        const j = y - f.top - f.bottom;
        N = h || _ ? rt(C, j) : j;
      }
      if (_ && !h) {
        const j = Me(f.left, 0), q = Me(f.right, 0), K = Me(f.top, 0), Z = Me(f.bottom, 0);
        v ? P = w - 2 * (j !== 0 || q !== 0 ? j + q : Me(f.left, f.right)) : N = y - 2 * (K !== 0 || Z !== 0 ? K + Z : Me(f.top, f.bottom));
      }
      await c({
        ...t,
        availableWidth: P,
        availableHeight: N
      });
      const x = await o.getDimensions(a.floating);
      return w !== x.width || y !== x.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function it(e) {
  return Ao(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function De(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Je(e) {
  var t;
  return (t = (Ao(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Ao(e) {
  return e instanceof Node || e instanceof De(e).Node;
}
function Ge(e) {
  return e instanceof Element || e instanceof De(e).Element;
}
function Ye(e) {
  return e instanceof HTMLElement || e instanceof De(e).HTMLElement;
}
function no(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof De(e).ShadowRoot;
}
function At(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = Ve(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(o);
}
function Va(e) {
  return ["table", "td", "th"].includes(it(e));
}
function hr(e) {
  const t = mr(), n = Ve(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function Ba(e) {
  let t = St(e);
  for (; Ye(t) && !en(t); ) {
    if (hr(t))
      return t;
    t = St(t);
  }
  return null;
}
function mr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function en(e) {
  return ["html", "body", "#document"].includes(it(e));
}
function Ve(e) {
  return De(e).getComputedStyle(e);
}
function tn(e) {
  return Ge(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function St(e) {
  if (it(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    no(e) && e.host || // Fallback.
    Je(e)
  );
  return no(t) ? t.host : t;
}
function Mo(e) {
  const t = St(e);
  return en(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ye(t) && At(t) ? t : Mo(t);
}
function kt(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Mo(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), c = De(o);
  return a ? t.concat(c, c.visualViewport || [], At(o) ? o : [], c.frameElement && n ? kt(c.frameElement) : []) : t.concat(o, kt(o, [], n));
}
function Do(e) {
  const t = Ve(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = Ye(e), a = o ? e.offsetWidth : n, c = o ? e.offsetHeight : r, s = Xt(n) !== a || Xt(r) !== c;
  return s && (n = a, r = c), {
    width: n,
    height: r,
    $: s
  };
}
function gr(e) {
  return Ge(e) ? e : e.contextElement;
}
function yt(e) {
  const t = gr(e);
  if (!Ye(t))
    return ot(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = Do(t);
  let c = (a ? Xt(n.width) : n.width) / r, s = (a ? Xt(n.height) : n.height) / o;
  return (!c || !Number.isFinite(c)) && (c = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: c,
    y: s
  };
}
const Ua = /* @__PURE__ */ ot(0);
function jo(e) {
  const t = De(e);
  return !mr() || !t.visualViewport ? Ua : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Wa(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== De(e) ? !1 : t;
}
function at(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = gr(e);
  let c = ot(1);
  t && (r ? Ge(r) && (c = yt(r)) : c = yt(e));
  const s = Wa(a, n, r) ? jo(a) : ot(0);
  let f = (o.left + s.x) / c.x, u = (o.top + s.y) / c.y, h = o.width / c.x, v = o.height / c.y;
  if (a) {
    const w = De(a), y = r && Ge(r) ? De(r) : r;
    let S = w, m = S.frameElement;
    for (; m && r && y !== S; ) {
      const C = yt(m), $ = m.getBoundingClientRect(), _ = Ve(m), N = $.left + (m.clientLeft + parseFloat(_.paddingLeft)) * C.x, P = $.top + (m.clientTop + parseFloat(_.paddingTop)) * C.y;
      f *= C.x, u *= C.y, h *= C.x, v *= C.y, f += N, u += P, S = De(m), m = S.frameElement;
    }
  }
  return Zt({
    width: h,
    height: v,
    x: f,
    y: u
  });
}
const Ya = [":popover-open", ":modal"];
function No(e) {
  return Ya.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function qa(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", c = Je(r), s = t ? No(t.floating) : !1;
  if (r === c || s && a)
    return n;
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = ot(1);
  const h = ot(0), v = Ye(r);
  if ((v || !v && !a) && ((it(r) !== "body" || At(c)) && (f = tn(r)), Ye(r))) {
    const w = at(r);
    u = yt(r), h.x = w.x + r.clientLeft, h.y = w.y + r.clientTop;
  }
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - f.scrollLeft * u.x + h.x,
    y: n.y * u.y - f.scrollTop * u.y + h.y
  };
}
function za(e) {
  return Array.from(e.getClientRects());
}
function Fo(e) {
  return at(Je(e)).left + tn(e).scrollLeft;
}
function Ka(e) {
  const t = Je(e), n = tn(e), r = e.ownerDocument.body, o = Me(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Me(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let c = -n.scrollLeft + Fo(e);
  const s = -n.scrollTop;
  return Ve(r).direction === "rtl" && (c += Me(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: c,
    y: s
  };
}
function Ha(e, t) {
  const n = De(e), r = Je(e), o = n.visualViewport;
  let a = r.clientWidth, c = r.clientHeight, s = 0, f = 0;
  if (o) {
    a = o.width, c = o.height;
    const u = mr();
    (!u || u && t === "fixed") && (s = o.offsetLeft, f = o.offsetTop);
  }
  return {
    width: a,
    height: c,
    x: s,
    y: f
  };
}
function Xa(e, t) {
  const n = at(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = Ye(e) ? yt(e) : ot(1), c = e.clientWidth * a.x, s = e.clientHeight * a.y, f = o * a.x, u = r * a.y;
  return {
    width: c,
    height: s,
    x: f,
    y: u
  };
}
function ro(e, t, n) {
  let r;
  if (t === "viewport")
    r = Ha(e, n);
  else if (t === "document")
    r = Ka(Je(e));
  else if (Ge(t))
    r = Xa(t, n);
  else {
    const o = jo(e);
    r = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Zt(r);
}
function Lo(e, t) {
  const n = St(e);
  return n === t || !Ge(n) || en(n) ? !1 : Ve(n).position === "fixed" || Lo(n, t);
}
function Ga(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = kt(e, [], !1).filter((s) => Ge(s) && it(s) !== "body"), o = null;
  const a = Ve(e).position === "fixed";
  let c = a ? St(e) : e;
  for (; Ge(c) && !en(c); ) {
    const s = Ve(c), f = hr(c);
    !f && s.position === "fixed" && (o = null), (a ? !f && !o : !f && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || At(c) && !f && Lo(e, c)) ? r = r.filter((h) => h !== c) : o = s, c = St(c);
  }
  return t.set(e, r), r;
}
function Za(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const c = [...n === "clippingAncestors" ? Ga(t, this._c) : [].concat(n), r], s = c[0], f = c.reduce((u, h) => {
    const v = ro(t, h, o);
    return u.top = Me(v.top, u.top), u.right = rt(v.right, u.right), u.bottom = rt(v.bottom, u.bottom), u.left = Me(v.left, u.left), u;
  }, ro(t, s, o));
  return {
    width: f.right - f.left,
    height: f.bottom - f.top,
    x: f.left,
    y: f.top
  };
}
function Ja(e) {
  const {
    width: t,
    height: n
  } = Do(e);
  return {
    width: t,
    height: n
  };
}
function Qa(e, t, n) {
  const r = Ye(t), o = Je(t), a = n === "fixed", c = at(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const f = ot(0);
  if (r || !r && !a)
    if ((it(t) !== "body" || At(o)) && (s = tn(t)), r) {
      const v = at(t, !0, a, t);
      f.x = v.x + t.clientLeft, f.y = v.y + t.clientTop;
    } else
      o && (f.x = Fo(o));
  const u = c.left + s.scrollLeft - f.x, h = c.top + s.scrollTop - f.y;
  return {
    x: u,
    y: h,
    width: c.width,
    height: c.height
  };
}
function oo(e, t) {
  return !Ye(e) || Ve(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Vo(e, t) {
  const n = De(e);
  if (!Ye(e) || No(e))
    return n;
  let r = oo(e, t);
  for (; r && Va(r) && Ve(r).position === "static"; )
    r = oo(r, t);
  return r && (it(r) === "html" || it(r) === "body" && Ve(r).position === "static" && !hr(r)) ? n : r || Ba(e) || n;
}
const es = async function(e) {
  const t = this.getOffsetParent || Vo, n = this.getDimensions;
  return {
    reference: Qa(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await n(e.floating)
    }
  };
};
function ts(e) {
  return Ve(e).direction === "rtl";
}
const ns = {
  convertOffsetParentRelativeRectToViewportRelativeRect: qa,
  getDocumentElement: Je,
  getClippingRect: Za,
  getOffsetParent: Vo,
  getElementRects: es,
  getClientRects: za,
  getDimensions: Ja,
  getScale: yt,
  isElement: Ge,
  isRTL: ts
};
function rs(e, t) {
  let n = null, r;
  const o = Je(e);
  function a() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function c(s, f) {
    s === void 0 && (s = !1), f === void 0 && (f = 1), a();
    const {
      left: u,
      top: h,
      width: v,
      height: w
    } = e.getBoundingClientRect();
    if (s || t(), !v || !w)
      return;
    const y = Ft(h), S = Ft(o.clientWidth - (u + v)), m = Ft(o.clientHeight - (h + w)), C = Ft(u), _ = {
      rootMargin: -y + "px " + -S + "px " + -m + "px " + -C + "px",
      threshold: Me(0, rt(1, f)) || 1
    };
    let N = !0;
    function P(x) {
      const j = x[0].intersectionRatio;
      if (j !== f) {
        if (!N)
          return c();
        j ? c(!1, j) : r = setTimeout(() => {
          c(!1, 1e-7);
        }, 100);
      }
      N = !1;
    }
    try {
      n = new IntersectionObserver(P, {
        ..._,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(P, _);
    }
    n.observe(e);
  }
  return c(!0), a;
}
function os(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: c = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: f = !1
  } = r, u = gr(e), h = o || a ? [...u ? kt(u) : [], ...kt(t)] : [];
  h.forEach(($) => {
    o && $.addEventListener("scroll", n, {
      passive: !0
    }), a && $.addEventListener("resize", n);
  });
  const v = u && s ? rs(u, n) : null;
  let w = -1, y = null;
  c && (y = new ResizeObserver(($) => {
    let [_] = $;
    _ && _.target === u && y && (y.unobserve(t), cancelAnimationFrame(w), w = requestAnimationFrame(() => {
      var N;
      (N = y) == null || N.observe(t);
    })), n();
  }), u && !f && y.observe(u), y.observe(t));
  let S, m = f ? at(e) : null;
  f && C();
  function C() {
    const $ = at(e);
    m && ($.x !== m.x || $.y !== m.y || $.width !== m.width || $.height !== m.height) && n(), m = $, S = requestAnimationFrame(C);
  }
  return n(), () => {
    var $;
    h.forEach((_) => {
      o && _.removeEventListener("scroll", n), a && _.removeEventListener("resize", n);
    }), v == null || v(), ($ = y) == null || $.disconnect(), y = null, f && cancelAnimationFrame(S);
  };
}
const is = Na, as = Aa, ss = La, cs = Ma, io = Ia, us = Fa, ls = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: ns,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return ka(e, t, {
    ...o,
    platform: a
  });
}, fs = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? io({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? io({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
};
var Yt = typeof document < "u" ? Eo : $e;
function Jt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Jt(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !Jt(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Bo(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ao(e, t) {
  const n = Bo(e);
  return Math.round(t * n) / n;
}
function so(e) {
  const t = Q.useRef(e);
  return Yt(() => {
    t.current = e;
  }), t;
}
function ds(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: c
    } = {},
    transform: s = !0,
    whileElementsMounted: f,
    open: u
  } = e, [h, v] = Q.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [w, y] = Q.useState(r);
  Jt(w, r) || y(r);
  const [S, m] = Q.useState(null), [C, $] = Q.useState(null), _ = Q.useCallback((te) => {
    te !== j.current && (j.current = te, m(te));
  }, []), N = Q.useCallback((te) => {
    te !== q.current && (q.current = te, $(te));
  }, []), P = a || S, x = c || C, j = Q.useRef(null), q = Q.useRef(null), K = Q.useRef(h), Z = f != null, se = so(f), X = so(o), H = Q.useCallback(() => {
    if (!j.current || !q.current)
      return;
    const te = {
      placement: t,
      strategy: n,
      middleware: w
    };
    X.current && (te.platform = X.current), ls(j.current, q.current, te).then((ue) => {
      const d = {
        ...ue,
        isPositioned: !0
      };
      Y.current && !Jt(K.current, d) && (K.current = d, Fi.flushSync(() => {
        v(d);
      }));
    });
  }, [w, t, n, X]);
  Yt(() => {
    u === !1 && K.current.isPositioned && (K.current.isPositioned = !1, v((te) => ({
      ...te,
      isPositioned: !1
    })));
  }, [u]);
  const Y = Q.useRef(!1);
  Yt(() => (Y.current = !0, () => {
    Y.current = !1;
  }), []), Yt(() => {
    if (P && (j.current = P), x && (q.current = x), P && x) {
      if (se.current)
        return se.current(P, x, H);
      H();
    }
  }, [P, x, H, se, Z]);
  const ee = Q.useMemo(() => ({
    reference: j,
    floating: q,
    setReference: _,
    setFloating: N
  }), [_, N]), re = Q.useMemo(() => ({
    reference: P,
    floating: x
  }), [P, x]), ie = Q.useMemo(() => {
    const te = {
      position: n,
      left: 0,
      top: 0
    };
    if (!re.floating)
      return te;
    const ue = ao(re.floating, h.x), d = ao(re.floating, h.y);
    return s ? {
      ...te,
      transform: "translate(" + ue + "px, " + d + "px)",
      ...Bo(re.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: ue,
      top: d
    };
  }, [n, s, re.floating, h.x, h.y]);
  return Q.useMemo(() => ({
    ...h,
    update: H,
    refs: ee,
    elements: re,
    floatingStyles: ie
  }), [h, H, ee, re, ie]);
}
function ps(e) {
  const [t, n] = xe(void 0);
  return Et(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let c, s;
        if ("borderBoxSize" in a) {
          const f = a.borderBoxSize, u = Array.isArray(f) ? f[0] : f;
          c = u.inlineSize, s = u.blockSize;
        } else
          c = e.offsetWidth, s = e.offsetHeight;
        n({
          width: c,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Uo = "Popper", [Wo, Yo] = It(Uo), [vs, qo] = Wo(Uo), hs = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = xe(null);
  return /* @__PURE__ */ ne(vs, {
    scope: t,
    anchor: r,
    onAnchorChange: o
  }, n);
}, ms = "PopperAnchor", gs = /* @__PURE__ */ fe((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...o } = e, a = qo(ms, n), c = pe(null), s = Le(t, c);
  return $e(() => {
    a.onAnchorChange((r == null ? void 0 : r.current) || c.current);
  }), r ? null : /* @__PURE__ */ ne(Ze.div, ye({}, o, {
    ref: s
  }));
}), zo = "PopperContent", [bs, vl] = Wo(zo), ys = /* @__PURE__ */ fe((e, t) => {
  var n, r, o, a, c, s, f, u;
  const { __scopePopper: h, side: v = "bottom", sideOffset: w = 0, align: y = "center", alignOffset: S = 0, arrowPadding: m = 0, avoidCollisions: C = !0, collisionBoundary: $ = [], collisionPadding: _ = 0, sticky: N = "partial", hideWhenDetached: P = !1, updatePositionStrategy: x = "optimized", onPlaced: j, ...q } = e, K = qo(zo, h), [Z, se] = xe(null), X = Le(
    t,
    (U) => se(U)
  ), [H, Y] = xe(null), ee = ps(H), re = (n = ee == null ? void 0 : ee.width) !== null && n !== void 0 ? n : 0, ie = (r = ee == null ? void 0 : ee.height) !== null && r !== void 0 ? r : 0, te = v + (y !== "center" ? "-" + y : ""), ue = typeof _ == "number" ? _ : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ..._
  }, d = Array.isArray($) ? $ : [
    $
  ], p = d.length > 0, g = {
    padding: ue,
    boundary: d.filter(ws),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: p
  }, { refs: l, floatingStyles: i, placement: E, isPositioned: A, middlewareData: D } = ds({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: te,
    whileElementsMounted: (...U) => os(...U, {
      animationFrame: x === "always"
    }),
    elements: {
      reference: K.anchor
    },
    middleware: [
      ja({
        mainAxis: w + ie,
        alignmentAxis: S
      }),
      C && is({
        mainAxis: !0,
        crossAxis: !1,
        limiter: N === "partial" ? us() : void 0,
        ...g
      }),
      C && as({
        ...g
      }),
      ss({
        ...g,
        apply: ({ elements: U, rects: G, availableWidth: J, availableHeight: ae }) => {
          const { width: ce, height: ve } = G.reference, Ce = U.floating.style;
          Ce.setProperty("--radix-popper-available-width", `${J}px`), Ce.setProperty("--radix-popper-available-height", `${ae}px`), Ce.setProperty("--radix-popper-anchor-width", `${ce}px`), Ce.setProperty("--radix-popper-anchor-height", `${ve}px`);
        }
      }),
      H && fs({
        element: H,
        padding: m
      }),
      Es({
        arrowWidth: re,
        arrowHeight: ie
      }),
      P && cs({
        strategy: "referenceHidden",
        ...g
      })
    ]
  }), [O, k] = Ko(E), R = We(j);
  Et(() => {
    A && (R == null || R());
  }, [
    A,
    R
  ]);
  const M = (o = D.arrow) === null || o === void 0 ? void 0 : o.x, L = (a = D.arrow) === null || a === void 0 ? void 0 : a.y, I = ((c = D.arrow) === null || c === void 0 ? void 0 : c.centerOffset) !== 0, [T, F] = xe();
  return Et(() => {
    Z && F(window.getComputedStyle(Z).zIndex);
  }, [
    Z
  ]), /* @__PURE__ */ ne("div", {
    ref: l.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...i,
      transform: A ? i.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: T,
      "--radix-popper-transform-origin": [
        (s = D.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (f = D.transformOrigin) === null || f === void 0 ? void 0 : f.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ ne(bs, {
    scope: h,
    placedSide: O,
    onArrowChange: Y,
    arrowX: M,
    arrowY: L,
    shouldHideArrow: I
  }, /* @__PURE__ */ ne(Ze.div, ye({
    "data-side": O,
    "data-align": k
  }, q, {
    ref: X,
    style: {
      ...q.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: A ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = D.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
});
function ws(e) {
  return e !== null;
}
const Es = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, o, a, c;
    const { placement: s, rects: f, middlewareData: u } = t, v = ((n = u.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, w = v ? 0 : e.arrowWidth, y = v ? 0 : e.arrowHeight, [S, m] = Ko(s), C = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[m], $ = ((r = (o = u.arrow) === null || o === void 0 ? void 0 : o.x) !== null && r !== void 0 ? r : 0) + w / 2, _ = ((a = (c = u.arrow) === null || c === void 0 ? void 0 : c.y) !== null && a !== void 0 ? a : 0) + y / 2;
    let N = "", P = "";
    return S === "bottom" ? (N = v ? C : `${$}px`, P = `${-y}px`) : S === "top" ? (N = v ? C : `${$}px`, P = `${f.floating.height + y}px`) : S === "right" ? (N = `${-y}px`, P = v ? C : `${_}px`) : S === "left" && (N = `${f.floating.width + y}px`, P = v ? C : `${_}px`), {
      data: {
        x: N,
        y: P
      }
    };
  }
});
function Ko(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const Ss = hs, $s = gs, Cs = ys, xs = /* @__PURE__ */ fe((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...o } = e;
  return r ? /* @__PURE__ */ rr.createPortal(/* @__PURE__ */ ne(Ze.div, ye({}, o, {
    ref: t
  })), r) : null;
});
function Os(e, t) {
  return Ni((n, r) => {
    const o = t[n][r];
    return o ?? n;
  }, e);
}
const br = (e) => {
  const { present: t, children: n } = e, r = Ts(t), o = typeof n == "function" ? n({
    present: r.isPresent
  }) : bt.only(n), a = Le(r.ref, o.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ nr(o, {
    ref: a
  }) : null;
};
br.displayName = "Presence";
function Ts(e) {
  const [t, n] = xe(), r = pe({}), o = pe(e), a = pe("none"), c = e ? "mounted" : "unmounted", [s, f] = Os(c, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return $e(() => {
    const u = Lt(r.current);
    a.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), Et(() => {
    const u = r.current, h = o.current;
    if (h !== e) {
      const w = a.current, y = Lt(u);
      e ? f("MOUNT") : y === "none" || (u == null ? void 0 : u.display) === "none" ? f("UNMOUNT") : f(h && w !== y ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    f
  ]), Et(() => {
    if (t) {
      const u = (v) => {
        const y = Lt(r.current).includes(v.animationName);
        v.target === t && y && So(
          () => f("ANIMATION_END")
        );
      }, h = (v) => {
        v.target === t && (a.current = Lt(r.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      f("ANIMATION_END");
  }, [
    t,
    f
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: _e((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Lt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const kn = "rovingFocusGroup.onEntryFocus", Ps = {
  bubbles: !1,
  cancelable: !0
}, yr = "RovingFocusGroup", [Kn, Ho, _s] = Po(yr), [Rs, Xo] = It(yr, [
  _s
]), [ks, Is] = Rs(yr), As = /* @__PURE__ */ fe((e, t) => /* @__PURE__ */ ne(Kn.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ ne(Kn.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ ne(Ms, ye({}, e, {
  ref: t
}))))), Ms = /* @__PURE__ */ fe((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: o = !1, dir: a, currentTabStopId: c, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: f, onEntryFocus: u, ...h } = e, v = pe(null), w = Le(t, v), y = _o(a), [S = null, m] = Oo({
    prop: c,
    defaultProp: s,
    onChange: f
  }), [C, $] = xe(!1), _ = We(u), N = Ho(n), P = pe(!1), [x, j] = xe(0);
  return $e(() => {
    const q = v.current;
    if (q)
      return q.addEventListener(kn, _), () => q.removeEventListener(kn, _);
  }, [
    _
  ]), /* @__PURE__ */ ne(ks, {
    scope: n,
    orientation: r,
    dir: y,
    loop: o,
    currentTabStopId: S,
    onItemFocus: _e(
      (q) => m(q),
      [
        m
      ]
    ),
    onItemShiftTab: _e(
      () => $(!0),
      []
    ),
    onFocusableItemAdd: _e(
      () => j(
        (q) => q + 1
      ),
      []
    ),
    onFocusableItemRemove: _e(
      () => j(
        (q) => q - 1
      ),
      []
    )
  }, /* @__PURE__ */ ne(Ze.div, ye({
    tabIndex: C || x === 0 ? -1 : 0,
    "data-orientation": r
  }, h, {
    ref: w,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: Se(e.onMouseDown, () => {
      P.current = !0;
    }),
    onFocus: Se(e.onFocus, (q) => {
      const K = !P.current;
      if (q.target === q.currentTarget && K && !C) {
        const Z = new CustomEvent(kn, Ps);
        if (q.currentTarget.dispatchEvent(Z), !Z.defaultPrevented) {
          const se = N().filter(
            (re) => re.focusable
          ), X = se.find(
            (re) => re.active
          ), H = se.find(
            (re) => re.id === S
          ), ee = [
            X,
            H,
            ...se
          ].filter(Boolean).map(
            (re) => re.ref.current
          );
          Go(ee);
        }
      }
      P.current = !1;
    }),
    onBlur: Se(
      e.onBlur,
      () => $(!1)
    )
  })));
}), Ds = "RovingFocusGroupItem", js = /* @__PURE__ */ fe((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: o = !1, tabStopId: a, ...c } = e, s = Yn(), f = a || s, u = Is(Ds, n), h = u.currentTabStopId === f, v = Ho(n), { onFocusableItemAdd: w, onFocusableItemRemove: y } = u;
  return $e(() => {
    if (r)
      return w(), () => y();
  }, [
    r,
    w,
    y
  ]), /* @__PURE__ */ ne(Kn.ItemSlot, {
    scope: n,
    id: f,
    focusable: r,
    active: o
  }, /* @__PURE__ */ ne(Ze.span, ye({
    tabIndex: h ? 0 : -1,
    "data-orientation": u.orientation
  }, c, {
    ref: t,
    onMouseDown: Se(e.onMouseDown, (S) => {
      r ? u.onItemFocus(f) : S.preventDefault();
    }),
    onFocus: Se(
      e.onFocus,
      () => u.onItemFocus(f)
    ),
    onKeyDown: Se(e.onKeyDown, (S) => {
      if (S.key === "Tab" && S.shiftKey) {
        u.onItemShiftTab();
        return;
      }
      if (S.target !== S.currentTarget)
        return;
      const m = Ls(S, u.orientation, u.dir);
      if (m !== void 0) {
        S.preventDefault();
        let $ = v().filter(
          (_) => _.focusable
        ).map(
          (_) => _.ref.current
        );
        if (m === "last")
          $.reverse();
        else if (m === "prev" || m === "next") {
          m === "prev" && $.reverse();
          const _ = $.indexOf(S.currentTarget);
          $ = u.loop ? Vs($, _ + 1) : $.slice(_ + 1);
        }
        setTimeout(
          () => Go($)
        );
      }
    })
  })));
}), Ns = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Fs(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Ls(e, t, n) {
  const r = Fs(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return Ns[r];
}
function Go(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Vs(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const Bs = As, Us = js;
var Ws = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, vt = /* @__PURE__ */ new WeakMap(), Vt = /* @__PURE__ */ new WeakMap(), Bt = {}, In = 0, Zo = function(e) {
  return e && (e.host || Zo(e.parentNode));
}, Ys = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = Zo(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, qs = function(e, t, n, r) {
  var o = Ys(t, Array.isArray(e) ? e : [e]);
  Bt[n] || (Bt[n] = /* @__PURE__ */ new WeakMap());
  var a = Bt[n], c = [], s = /* @__PURE__ */ new Set(), f = new Set(o), u = function(v) {
    !v || s.has(v) || (s.add(v), u(v.parentNode));
  };
  o.forEach(u);
  var h = function(v) {
    !v || f.has(v) || Array.prototype.forEach.call(v.children, function(w) {
      if (s.has(w))
        h(w);
      else
        try {
          var y = w.getAttribute(r), S = y !== null && y !== "false", m = (vt.get(w) || 0) + 1, C = (a.get(w) || 0) + 1;
          vt.set(w, m), a.set(w, C), c.push(w), m === 1 && S && Vt.set(w, !0), C === 1 && w.setAttribute(n, "true"), S || w.setAttribute(r, "true");
        } catch ($) {
          console.error("aria-hidden: cannot operate on ", w, $);
        }
    });
  };
  return h(t), s.clear(), In++, function() {
    c.forEach(function(v) {
      var w = vt.get(v) - 1, y = a.get(v) - 1;
      vt.set(v, w), a.set(v, y), w || (Vt.has(v) || v.removeAttribute(r), Vt.delete(v)), y || v.removeAttribute(n);
    }), In--, In || (vt = /* @__PURE__ */ new WeakMap(), vt = /* @__PURE__ */ new WeakMap(), Vt = /* @__PURE__ */ new WeakMap(), Bt = {});
  };
}, zs = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = t || Ws(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live]"))), qs(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, tt = function() {
  return tt = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, tt.apply(this, arguments);
};
function Ks(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function Hs(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, o = t.length, a; r < o; r++)
      (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var qt = "right-scroll-bar-position", zt = "width-before-scroll-bar", Xs = "with-scroll-bars-hidden", Gs = "--removed-body-scroll-bar-size";
function An(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Zs(e, t) {
  var n = xe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var Js = typeof window < "u" ? Q.useLayoutEffect : Q.useEffect, co = /* @__PURE__ */ new WeakMap();
function Qs(e, t) {
  var n = Zs(t || null, function(r) {
    return e.forEach(function(o) {
      return An(o, r);
    });
  });
  return Js(function() {
    var r = co.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), c = n.current;
      o.forEach(function(s) {
        a.has(s) || An(s, null);
      }), a.forEach(function(s) {
        o.has(s) || An(s, c);
      });
    }
    co.set(n, e);
  }, [e]), n;
}
var Qt = function() {
  return Qt = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n)
        Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, Qt.apply(this, arguments);
};
function ec(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function tc(e) {
  return e;
}
function nc(e, t) {
  t === void 0 && (t = tc);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var c = t(a, r);
      return n.push(c), function() {
        n = n.filter(function(s) {
          return s !== c;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var c = n;
        n = [], c.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var c = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), c = n;
      }
      var f = function() {
        var h = c;
        c = [], h.forEach(a);
      }, u = function() {
        return Promise.resolve().then(f);
      };
      u(), n = {
        push: function(h) {
          c.push(h), u();
        },
        filter: function(h) {
          return c = c.filter(h), n;
        }
      };
    }
  };
  return o;
}
function rc(e) {
  e === void 0 && (e = {});
  var t = nc(null);
  return t.options = Qt({ async: !0, ssr: !1 }, e), t;
}
var Jo = function(e) {
  var t = e.sideCar, n = ec(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return Q.createElement(r, Qt({}, n));
};
Jo.isSideCarExport = !0;
function oc(e, t) {
  return e.useMedium(t), Jo;
}
var Qo = rc(), Mn = function() {
}, nn = Q.forwardRef(function(e, t) {
  var n = Q.useRef(null), r = Q.useState({
    onScrollCapture: Mn,
    onWheelCapture: Mn,
    onTouchMoveCapture: Mn
  }), o = r[0], a = r[1], c = e.forwardProps, s = e.children, f = e.className, u = e.removeScrollBar, h = e.enabled, v = e.shards, w = e.sideCar, y = e.noIsolation, S = e.inert, m = e.allowPinchZoom, C = e.as, $ = C === void 0 ? "div" : C, _ = Ks(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), N = w, P = Qs([n, t]), x = tt(tt({}, _), o);
  return Q.createElement(
    Q.Fragment,
    null,
    h && Q.createElement(N, { sideCar: Qo, removeScrollBar: u, shards: v, noIsolation: y, inert: S, setCallbacks: a, allowPinchZoom: !!m, lockRef: n }),
    c ? Q.cloneElement(Q.Children.only(s), tt(tt({}, x), { ref: P })) : Q.createElement($, tt({}, x, { className: f, ref: P }), s)
  );
});
nn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
nn.classNames = {
  fullWidth: zt,
  zeroRight: qt
};
var ic = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function ac() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = ic();
  return t && e.setAttribute("nonce", t), e;
}
function sc(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function cc(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var uc = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = ac()) && (sc(t, n), cc(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, lc = function() {
  var e = uc();
  return function(t, n) {
    Q.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, ei = function() {
  var e = lc(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, fc = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Dn = function(e) {
  return parseInt(e || "", 10) || 0;
}, dc = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Dn(n), Dn(r), Dn(o)];
}, pc = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return fc;
  var t = dc(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, vc = ei(), wt = "data-scroll-locked", hc = function(e, t, n, r) {
  var o = e.left, a = e.top, c = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Xs, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(wt, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(c, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(qt, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(zt, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(qt, " .").concat(qt, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(zt, " .").concat(zt, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(wt, `] {
    `).concat(Gs, ": ").concat(s, `px;
  }
`);
}, uo = function() {
  var e = parseInt(document.body.getAttribute(wt) || "0", 10);
  return isFinite(e) ? e : 0;
}, mc = function() {
  Q.useEffect(function() {
    return document.body.setAttribute(wt, (uo() + 1).toString()), function() {
      var e = uo() - 1;
      e <= 0 ? document.body.removeAttribute(wt) : document.body.setAttribute(wt, e.toString());
    };
  }, []);
}, gc = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  mc();
  var a = Q.useMemo(function() {
    return pc(o);
  }, [o]);
  return Q.createElement(vc, { styles: hc(a, !t, o, n ? "" : "!important") });
}, Hn = !1;
if (typeof window < "u")
  try {
    var Ut = Object.defineProperty({}, "passive", {
      get: function() {
        return Hn = !0, !0;
      }
    });
    window.addEventListener("test", Ut, Ut), window.removeEventListener("test", Ut, Ut);
  } catch {
    Hn = !1;
  }
var ht = Hn ? { passive: !1 } : !1, bc = function(e) {
  return e.tagName === "TEXTAREA";
}, ti = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !bc(e) && n[t] === "visible")
  );
}, yc = function(e) {
  return ti(e, "overflowY");
}, wc = function(e) {
  return ti(e, "overflowX");
}, lo = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = ni(e, n);
    if (r) {
      var o = ri(e, n), a = o[1], c = o[2];
      if (a > c)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, Ec = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Sc = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, ni = function(e, t) {
  return e === "v" ? yc(t) : wc(t);
}, ri = function(e, t) {
  return e === "v" ? Ec(t) : Sc(t);
}, $c = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Cc = function(e, t, n, r, o) {
  var a = $c(e, window.getComputedStyle(t).direction), c = a * r, s = n.target, f = t.contains(s), u = !1, h = c > 0, v = 0, w = 0;
  do {
    var y = ri(e, s), S = y[0], m = y[1], C = y[2], $ = m - C - a * S;
    (S || $) && ni(e, s) && (v += $, w += S), s = s.parentNode;
  } while (
    // portaled content
    !f && s !== document.body || // self content
    f && (t.contains(s) || t === s)
  );
  return (h && (o && v === 0 || !o && c > v) || !h && (o && w === 0 || !o && -c > w)) && (u = !0), u;
}, Wt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, fo = function(e) {
  return [e.deltaX, e.deltaY];
}, po = function(e) {
  return e && "current" in e ? e.current : e;
}, xc = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Oc = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Tc = 0, mt = [];
function Pc(e) {
  var t = Q.useRef([]), n = Q.useRef([0, 0]), r = Q.useRef(), o = Q.useState(Tc++)[0], a = Q.useState(function() {
    return ei();
  })[0], c = Q.useRef(e);
  Q.useEffect(function() {
    c.current = e;
  }, [e]), Q.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var m = Hs([e.lockRef.current], (e.shards || []).map(po), !0).filter(Boolean);
      return m.forEach(function(C) {
        return C.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), m.forEach(function(C) {
          return C.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = Q.useCallback(function(m, C) {
    if ("touches" in m && m.touches.length === 2)
      return !c.current.allowPinchZoom;
    var $ = Wt(m), _ = n.current, N = "deltaX" in m ? m.deltaX : _[0] - $[0], P = "deltaY" in m ? m.deltaY : _[1] - $[1], x, j = m.target, q = Math.abs(N) > Math.abs(P) ? "h" : "v";
    if ("touches" in m && q === "h" && j.type === "range")
      return !1;
    var K = lo(q, j);
    if (!K)
      return !0;
    if (K ? x = q : (x = q === "v" ? "h" : "v", K = lo(q, j)), !K)
      return !1;
    if (!r.current && "changedTouches" in m && (N || P) && (r.current = x), !x)
      return !0;
    var Z = r.current || x;
    return Cc(Z, C, m, Z === "h" ? N : P, !0);
  }, []), f = Q.useCallback(function(m) {
    var C = m;
    if (!(!mt.length || mt[mt.length - 1] !== a)) {
      var $ = "deltaY" in C ? fo(C) : Wt(C), _ = t.current.filter(function(x) {
        return x.name === C.type && x.target === C.target && xc(x.delta, $);
      })[0];
      if (_ && _.should) {
        C.cancelable && C.preventDefault();
        return;
      }
      if (!_) {
        var N = (c.current.shards || []).map(po).filter(Boolean).filter(function(x) {
          return x.contains(C.target);
        }), P = N.length > 0 ? s(C, N[0]) : !c.current.noIsolation;
        P && C.cancelable && C.preventDefault();
      }
    }
  }, []), u = Q.useCallback(function(m, C, $, _) {
    var N = { name: m, delta: C, target: $, should: _ };
    t.current.push(N), setTimeout(function() {
      t.current = t.current.filter(function(P) {
        return P !== N;
      });
    }, 1);
  }, []), h = Q.useCallback(function(m) {
    n.current = Wt(m), r.current = void 0;
  }, []), v = Q.useCallback(function(m) {
    u(m.type, fo(m), m.target, s(m, e.lockRef.current));
  }, []), w = Q.useCallback(function(m) {
    u(m.type, Wt(m), m.target, s(m, e.lockRef.current));
  }, []);
  Q.useEffect(function() {
    return mt.push(a), e.setCallbacks({
      onScrollCapture: v,
      onWheelCapture: v,
      onTouchMoveCapture: w
    }), document.addEventListener("wheel", f, ht), document.addEventListener("touchmove", f, ht), document.addEventListener("touchstart", h, ht), function() {
      mt = mt.filter(function(m) {
        return m !== a;
      }), document.removeEventListener("wheel", f, ht), document.removeEventListener("touchmove", f, ht), document.removeEventListener("touchstart", h, ht);
    };
  }, []);
  var y = e.removeScrollBar, S = e.inert;
  return Q.createElement(
    Q.Fragment,
    null,
    S ? Q.createElement(a, { styles: Oc(o) }) : null,
    y ? Q.createElement(gc, { gapMode: "margin" }) : null
  );
}
const _c = oc(Qo, Pc);
var oi = Q.forwardRef(function(e, t) {
  return Q.createElement(nn, tt({}, e, { ref: t, sideCar: _c }));
});
oi.classNames = nn.classNames;
const Rc = oi, kc = [
  "Enter",
  " "
], Ic = [
  "ArrowDown",
  "PageUp",
  "Home"
], ii = [
  "ArrowUp",
  "PageDown",
  "End"
], Ac = [
  ...Ic,
  ...ii
], rn = "Menu", [Xn, Mc, Dc] = Po(rn), [ct, ai] = It(rn, [
  Dc,
  Yo,
  Xo
]), wr = Yo(), si = Xo(), [jc, Mt] = ct(rn), [Nc, Er] = ct(rn), Fc = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: c = !0 } = e, s = wr(t), [f, u] = xe(null), h = pe(!1), v = We(a), w = _o(o);
  return $e(() => {
    const y = () => {
      h.current = !0, document.addEventListener("pointerdown", S, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", S, {
        capture: !0,
        once: !0
      });
    }, S = () => h.current = !1;
    return document.addEventListener("keydown", y, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", y, {
        capture: !0
      }), document.removeEventListener("pointerdown", S, {
        capture: !0
      }), document.removeEventListener("pointermove", S, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ ne(Ss, s, /* @__PURE__ */ ne(jc, {
    scope: t,
    open: n,
    onOpenChange: v,
    content: f,
    onContentChange: u
  }, /* @__PURE__ */ ne(Nc, {
    scope: t,
    onClose: _e(
      () => v(!1),
      [
        v
      ]
    ),
    isUsingKeyboardRef: h,
    dir: w,
    modal: c
  }, r)));
}, Lc = /* @__PURE__ */ fe((e, t) => {
  const { __scopeMenu: n, ...r } = e, o = wr(n);
  return /* @__PURE__ */ ne($s, ye({}, o, r, {
    ref: t
  }));
}), ci = "MenuPortal", [Vc, Bc] = ct(ci, {
  forceMount: void 0
}), Uc = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = Mt(ci, t);
  return /* @__PURE__ */ ne(Vc, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ ne(br, {
    present: n || a.open
  }, /* @__PURE__ */ ne(xs, {
    asChild: !0,
    container: o
  }, r)));
}, nt = "MenuContent", [Wc, ui] = ct(nt), Yc = /* @__PURE__ */ fe((e, t) => {
  const n = Bc(nt, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Mt(nt, e.__scopeMenu), c = Er(nt, e.__scopeMenu);
  return /* @__PURE__ */ ne(Xn.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ ne(br, {
    present: r || a.open
  }, /* @__PURE__ */ ne(Xn.Slot, {
    scope: e.__scopeMenu
  }, c.modal ? /* @__PURE__ */ ne(qc, ye({}, o, {
    ref: t
  })) : /* @__PURE__ */ ne(zc, ye({}, o, {
    ref: t
  })))));
}), qc = /* @__PURE__ */ fe((e, t) => {
  const n = Mt(nt, e.__scopeMenu), r = pe(null), o = Le(t, r);
  return $e(() => {
    const a = r.current;
    if (a)
      return zs(a);
  }, []), /* @__PURE__ */ ne(li, ye({}, e, {
    ref: o,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: Se(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), zc = /* @__PURE__ */ fe((e, t) => {
  const n = Mt(nt, e.__scopeMenu);
  return /* @__PURE__ */ ne(li, ye({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), li = /* @__PURE__ */ fe((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: o, onOpenAutoFocus: a, onCloseAutoFocus: c, disableOutsidePointerEvents: s, onEntryFocus: f, onEscapeKeyDown: u, onPointerDownOutside: h, onFocusOutside: v, onInteractOutside: w, onDismiss: y, disableOutsideScroll: S, ...m } = e, C = Mt(nt, n), $ = Er(nt, n), _ = wr(n), N = si(n), P = Mc(n), [x, j] = xe(null), q = pe(null), K = Le(t, q, C.onContentChange), Z = pe(0), se = pe(""), X = pe(0), H = pe(null), Y = pe("right"), ee = pe(0), re = S ? Rc : wo, ie = S ? {
    as: _t,
    allowPinchZoom: !0
  } : void 0, te = (d) => {
    var p, g;
    const l = se.current + d, i = P().filter(
      (R) => !R.disabled
    ), E = document.activeElement, A = (p = i.find(
      (R) => R.ref.current === E
    )) === null || p === void 0 ? void 0 : p.textValue, D = i.map(
      (R) => R.textValue
    ), O = tu(D, l, A), k = (g = i.find(
      (R) => R.textValue === O
    )) === null || g === void 0 ? void 0 : g.ref.current;
    (function R(M) {
      se.current = M, window.clearTimeout(Z.current), M !== "" && (Z.current = window.setTimeout(
        () => R(""),
        1e3
      ));
    })(l), k && setTimeout(
      () => k.focus()
    );
  };
  $e(() => () => window.clearTimeout(Z.current), []), pa();
  const ue = _e((d) => {
    var p, g;
    return Y.current === ((p = H.current) === null || p === void 0 ? void 0 : p.side) && ru(d, (g = H.current) === null || g === void 0 ? void 0 : g.area);
  }, []);
  return /* @__PURE__ */ ne(Wc, {
    scope: n,
    searchRef: se,
    onItemEnter: _e((d) => {
      ue(d) && d.preventDefault();
    }, [
      ue
    ]),
    onItemLeave: _e((d) => {
      var p;
      ue(d) || ((p = q.current) === null || p === void 0 || p.focus(), j(null));
    }, [
      ue
    ]),
    onTriggerLeave: _e((d) => {
      ue(d) && d.preventDefault();
    }, [
      ue
    ]),
    pointerGraceTimerRef: X,
    onPointerGraceIntentChange: _e((d) => {
      H.current = d;
    }, [])
  }, /* @__PURE__ */ ne(re, ie, /* @__PURE__ */ ne(va, {
    asChild: !0,
    trapped: o,
    onMountAutoFocus: Se(a, (d) => {
      var p;
      d.preventDefault(), (p = q.current) === null || p === void 0 || p.focus();
    }),
    onUnmountAutoFocus: c
  }, /* @__PURE__ */ ne(la, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: u,
    onPointerDownOutside: h,
    onFocusOutside: v,
    onInteractOutside: w,
    onDismiss: y
  }, /* @__PURE__ */ ne(Bs, ye({
    asChild: !0
  }, N, {
    dir: $.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: x,
    onCurrentTabStopIdChange: j,
    onEntryFocus: Se(f, (d) => {
      $.isUsingKeyboardRef.current || d.preventDefault();
    })
  }), /* @__PURE__ */ ne(Cs, ye({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": Jc(C.open),
    "data-radix-menu-content": "",
    dir: $.dir
  }, _, m, {
    ref: K,
    style: {
      outline: "none",
      ...m.style
    },
    onKeyDown: Se(m.onKeyDown, (d) => {
      const g = d.target.closest("[data-radix-menu-content]") === d.currentTarget, l = d.ctrlKey || d.altKey || d.metaKey, i = d.key.length === 1;
      g && (d.key === "Tab" && d.preventDefault(), !l && i && te(d.key));
      const E = q.current;
      if (d.target !== E || !Ac.includes(d.key))
        return;
      d.preventDefault();
      const D = P().filter(
        (O) => !O.disabled
      ).map(
        (O) => O.ref.current
      );
      ii.includes(d.key) && D.reverse(), Qc(D);
    }),
    onBlur: Se(e.onBlur, (d) => {
      d.currentTarget.contains(d.target) || (window.clearTimeout(Z.current), se.current = "");
    }),
    onPointerMove: Se(e.onPointerMove, Zn((d) => {
      const p = d.target, g = ee.current !== d.clientX;
      if (d.currentTarget.contains(p) && g) {
        const l = d.clientX > ee.current ? "right" : "left";
        Y.current = l, ee.current = d.clientX;
      }
    }))
  })))))));
}), Gn = "MenuItem", vo = "menu.itemSelect", Kc = /* @__PURE__ */ fe((e, t) => {
  const { disabled: n = !1, onSelect: r, ...o } = e, a = pe(null), c = Er(Gn, e.__scopeMenu), s = ui(Gn, e.__scopeMenu), f = Le(t, a), u = pe(!1), h = () => {
    const v = a.current;
    if (!n && v) {
      const w = new CustomEvent(vo, {
        bubbles: !0,
        cancelable: !0
      });
      v.addEventListener(
        vo,
        (y) => r == null ? void 0 : r(y),
        {
          once: !0
        }
      ), To(v, w), w.defaultPrevented ? u.current = !1 : c.onClose();
    }
  };
  return /* @__PURE__ */ ne(Hc, ye({}, o, {
    ref: f,
    disabled: n,
    onClick: Se(e.onClick, h),
    onPointerDown: (v) => {
      var w;
      (w = e.onPointerDown) === null || w === void 0 || w.call(e, v), u.current = !0;
    },
    onPointerUp: Se(e.onPointerUp, (v) => {
      var w;
      u.current || (w = v.currentTarget) === null || w === void 0 || w.click();
    }),
    onKeyDown: Se(e.onKeyDown, (v) => {
      const w = s.searchRef.current !== "";
      n || w && v.key === " " || kc.includes(v.key) && (v.currentTarget.click(), v.preventDefault());
    })
  }));
}), Hc = /* @__PURE__ */ fe((e, t) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, c = ui(Gn, n), s = si(n), f = pe(null), u = Le(t, f), [h, v] = xe(!1), [w, y] = xe("");
  return $e(() => {
    const S = f.current;
    if (S) {
      var m;
      y(((m = S.textContent) !== null && m !== void 0 ? m : "").trim());
    }
  }, [
    a.children
  ]), /* @__PURE__ */ ne(Xn.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: o ?? w
  }, /* @__PURE__ */ ne(Us, ye({
    asChild: !0
  }, s, {
    focusable: !r
  }), /* @__PURE__ */ ne(Ze.div, ye({
    role: "menuitem",
    "data-highlighted": h ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, a, {
    ref: u,
    onPointerMove: Se(e.onPointerMove, Zn((S) => {
      r ? c.onItemLeave(S) : (c.onItemEnter(S), S.defaultPrevented || S.currentTarget.focus());
    })),
    onPointerLeave: Se(e.onPointerLeave, Zn(
      (S) => c.onItemLeave(S)
    )),
    onFocus: Se(
      e.onFocus,
      () => v(!0)
    ),
    onBlur: Se(
      e.onBlur,
      () => v(!1)
    )
  }))));
}), Xc = "MenuRadioGroup";
ct(Xc, {
  value: void 0,
  onValueChange: () => {
  }
});
const Gc = "MenuItemIndicator";
ct(Gc, {
  checked: !1
});
const Zc = "MenuSub";
ct(Zc);
function Jc(e) {
  return e ? "open" : "closed";
}
function Qc(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function eu(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function tu(e, t, n) {
  const o = t.length > 1 && Array.from(t).every(
    (u) => u === t[0]
  ) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let c = eu(e, Math.max(a, 0));
  o.length === 1 && (c = c.filter(
    (u) => u !== n
  ));
  const f = c.find(
    (u) => u.toLowerCase().startsWith(o.toLowerCase())
  );
  return f !== n ? f : void 0;
}
function nu(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, c = t.length - 1; a < t.length; c = a++) {
    const s = t[a].x, f = t[a].y, u = t[c].x, h = t[c].y;
    f > r != h > r && n < (u - s) * (r - f) / (h - f) + s && (o = !o);
  }
  return o;
}
function ru(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return nu(n, t);
}
function Zn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const ou = Fc, iu = Lc, au = Uc, su = Yc, cu = Kc, fi = "DropdownMenu", [uu, hl] = It(fi, [
  ai
]), Dt = ai(), [lu, di] = uu(fi), fu = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: o, defaultOpen: a, onOpenChange: c, modal: s = !0 } = e, f = Dt(t), u = pe(null), [h = !1, v] = Oo({
    prop: o,
    defaultProp: a,
    onChange: c
  });
  return /* @__PURE__ */ ne(lu, {
    scope: t,
    triggerId: Yn(),
    triggerRef: u,
    contentId: Yn(),
    open: h,
    onOpenChange: v,
    onOpenToggle: _e(
      () => v(
        (w) => !w
      ),
      [
        v
      ]
    ),
    modal: s
  }, /* @__PURE__ */ ne(ou, ye({}, f, {
    open: h,
    onOpenChange: v,
    dir: r,
    modal: s
  }), n));
}, du = "DropdownMenuTrigger", pu = /* @__PURE__ */ fe((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = di(du, n), c = Dt(n);
  return /* @__PURE__ */ ne(iu, ye({
    asChild: !0
  }, c), /* @__PURE__ */ ne(Ze.button, ye({
    type: "button",
    id: a.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": a.open,
    "aria-controls": a.open ? a.contentId : void 0,
    "data-state": a.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, o, {
    ref: fr(t, a.triggerRef),
    onPointerDown: Se(e.onPointerDown, (s) => {
      !r && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
    }),
    onKeyDown: Se(e.onKeyDown, (s) => {
      r || ([
        "Enter",
        " "
      ].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), vu = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Dt(t);
  return /* @__PURE__ */ ne(au, ye({}, r, n));
}, hu = "DropdownMenuContent", mu = /* @__PURE__ */ fe((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = di(hu, n), a = Dt(n), c = pe(!1);
  return /* @__PURE__ */ ne(su, ye({
    id: o.contentId,
    "aria-labelledby": o.triggerId
  }, a, r, {
    ref: t,
    onCloseAutoFocus: Se(e.onCloseAutoFocus, (s) => {
      var f;
      c.current || (f = o.triggerRef.current) === null || f === void 0 || f.focus(), c.current = !1, s.preventDefault();
    }),
    onInteractOutside: Se(e.onInteractOutside, (s) => {
      const f = s.detail.originalEvent, u = f.button === 0 && f.ctrlKey === !0, h = f.button === 2 || u;
      (!o.modal || h) && (c.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), gu = /* @__PURE__ */ fe((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = Dt(n);
  return /* @__PURE__ */ ne(cu, ye({}, o, r, {
    ref: t
  }));
}), bu = fu, yu = pu, wu = vu, Eu = mu, Su = gu;
function pi({ trigger: e, items: t }) {
  return /* @__PURE__ */ W.jsxs(bu, { children: [
    /* @__PURE__ */ W.jsx(yu, { asChild: !0, children: e }),
    /* @__PURE__ */ W.jsx(wu, { children: /* @__PURE__ */ W.jsx(Eu, { className: "mds-dropdown-content", children: t.map((n, r) => /* @__PURE__ */ W.jsx(
      Su,
      {
        className: "mds-dropdown-item",
        onSelect: n.onSelect,
        textValue: n.text,
        children: n.render ? n.render() : n.text
      },
      n.key || r
    )) }) })
  ] });
}
const $u = (e, t = 300) => {
  let n, r = Date.now() - t;
  return (...o) => {
    r || a(Date.now()), clearTimeout(n), n = setTimeout(
      () => {
        const c = Date.now();
        c - r >= t && a(c);
      },
      t - (Date.now() - r)
    );
    function a(c) {
      e(...o), r = c;
    }
  };
};
var Jn = { exports: {} }, jn, ho;
function Cu() {
  if (ho)
    return jn;
  ho = 1;
  function e(d) {
    return d && typeof d == "object" && "default" in d ? d.default : d;
  }
  var t = e(Ie), n = rr;
  function r(d, p) {
    for (var g = Object.getOwnPropertyNames(p), l = 0; l < g.length; l++) {
      var i = g[l], E = Object.getOwnPropertyDescriptor(p, i);
      E && E.configurable && d[i] === void 0 && Object.defineProperty(d, i, E);
    }
    return d;
  }
  function o() {
    return (o = Object.assign || function(d) {
      for (var p = 1; p < arguments.length; p++) {
        var g = arguments[p];
        for (var l in g)
          Object.prototype.hasOwnProperty.call(g, l) && (d[l] = g[l]);
      }
      return d;
    }).apply(this, arguments);
  }
  function a(d, p) {
    d.prototype = Object.create(p.prototype), r(d.prototype.constructor = d, p);
  }
  function c(d, p) {
    if (d == null)
      return {};
    var g, l, i = {}, E = Object.keys(d);
    for (l = 0; l < E.length; l++)
      g = E[l], 0 <= p.indexOf(g) || (i[g] = d[g]);
    return i;
  }
  function s(d) {
    if (d === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return d;
  }
  var f = function(d, p, g, l, i, E, A, D) {
    if (!d) {
      var O;
      if (p === void 0)
        O = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var k = [g, l, i, E, A, D], R = 0;
        (O = new Error(p.replace(/%s/g, function() {
          return k[R++];
        }))).name = "Invariant Violation";
      }
      throw O.framesToPop = 1, O;
    }
  }, u = f;
  function h(d, p, g) {
    if ("selectionStart" in d && "selectionEnd" in d)
      d.selectionStart = p, d.selectionEnd = g;
    else {
      var l = d.createTextRange();
      l.collapse(!0), l.moveStart("character", p), l.moveEnd("character", g - p), l.select();
    }
  }
  function v(d) {
    var p = 0, g = 0;
    if ("selectionStart" in d && "selectionEnd" in d)
      p = d.selectionStart, g = d.selectionEnd;
    else {
      var l = document.selection.createRange();
      l.parentElement() === d && (p = -l.moveStart("character", -d.value.length), g = -l.moveEnd("character", -d.value.length));
    }
    return { start: p, end: g, length: g - p };
  }
  var w = { 9: "[0-9]", a: "[A-Za-z]", "*": "[A-Za-z0-9]" }, y = "_";
  function S(d, p, g) {
    var l = "", i = "", E = null, A = [];
    if (p === void 0 && (p = y), g == null && (g = w), !d || typeof d != "string")
      return { maskChar: p, formatChars: g, mask: null, prefix: null, lastEditablePosition: null, permanents: [] };
    var D = !1;
    return d.split("").forEach(function(O) {
      D = !D && O === "\\" || (D || !g[O] ? (A.push(l.length), l.length === A.length - 1 && (i += O)) : E = l.length + 1, l += O, !1);
    }), { maskChar: p, formatChars: g, prefix: i, mask: l, lastEditablePosition: E, permanents: A };
  }
  function m(d, p) {
    return d.permanents.indexOf(p) !== -1;
  }
  function C(d, p, g) {
    var l = d.mask, i = d.formatChars;
    if (!g)
      return !1;
    if (m(d, p))
      return l[p] === g;
    var E = i[l[p]];
    return new RegExp(E).test(g);
  }
  function $(d, p) {
    return p.split("").every(function(g, l) {
      return m(d, l) || !C(d, l, g);
    });
  }
  function _(d, p) {
    var g = d.maskChar, l = d.prefix;
    if (!g) {
      for (; p.length > l.length && m(d, p.length - 1); )
        p = p.slice(0, p.length - 1);
      return p.length;
    }
    for (var i = l.length, E = p.length; E >= l.length; E--) {
      var A = p[E];
      if (!m(d, E) && C(d, E, A)) {
        i = E + 1;
        break;
      }
    }
    return i;
  }
  function N(d, p) {
    return _(d, p) === d.mask.length;
  }
  function P(d, p) {
    var g = d.maskChar, l = d.mask, i = d.prefix;
    if (!g) {
      for ((p = j(d, "", p, 0)).length < i.length && (p = i); p.length < l.length && m(d, p.length); )
        p += l[p.length];
      return p;
    }
    if (p)
      return j(d, P(d, ""), p, 0);
    for (var E = 0; E < l.length; E++)
      m(d, E) ? p += l[E] : p += g;
    return p;
  }
  function x(d, p, g, l) {
    var i = g + l, E = d.maskChar, A = d.mask, D = d.prefix, O = p.split("");
    if (E)
      return O.map(function(R, M) {
        return M < g || i <= M ? R : m(d, M) ? A[M] : E;
      }).join("");
    for (var k = i; k < O.length; k++)
      m(d, k) && (O[k] = "");
    return g = Math.max(D.length, g), O.splice(g, i - g), p = O.join(""), P(d, p);
  }
  function j(d, p, g, l) {
    var i = d.mask, E = d.maskChar, A = d.prefix, D = g.split(""), O = N(d, p);
    return !E && l > p.length && (p += i.slice(p.length, l)), D.every(function(k) {
      for (; I = k, m(d, L = l) && I !== i[L]; ) {
        if (l >= p.length && (p += i[l]), R = k, M = l, E && m(d, M) && R === E)
          return !0;
        if (++l >= i.length)
          return !1;
      }
      var R, M, L, I;
      return !C(d, l, k) && k !== E || (l < p.length ? p = E || O || l < A.length ? p.slice(0, l) + k + p.slice(l + 1) : (p = p.slice(0, l) + k + p.slice(l), P(d, p)) : E || (p += k), ++l < i.length);
    }), p;
  }
  function q(d, p, g, l) {
    var i = d.mask, E = d.maskChar, A = g.split(""), D = l;
    return A.every(function(O) {
      for (; R = O, m(d, k = l) && R !== i[k]; )
        if (++l >= i.length)
          return !1;
      var k, R;
      return (C(d, l, O) || O === E) && l++, l < i.length;
    }), l - D;
  }
  function K(d, p) {
    for (var g = p; 0 <= g; --g)
      if (!m(d, g))
        return g;
    return null;
  }
  function Z(d, p) {
    for (var g = d.mask, l = p; l < g.length; ++l)
      if (!m(d, l))
        return l;
    return null;
  }
  function se(d) {
    return d || d === 0 ? d + "" : "";
  }
  function X(d, p, g, l, i) {
    var E = d.mask, A = d.prefix, D = d.lastEditablePosition, O = p, k = "", R = 0, M = 0, L = Math.min(i.start, g.start);
    return g.end > i.start ? M = (R = q(d, l, k = O.slice(i.start, g.end), L)) ? i.length : 0 : O.length < l.length && (M = l.length - O.length), O = l, M && (M === 1 && !i.length && (L = i.start === g.start ? Z(d, g.start) : K(d, g.start)), O = x(d, O, L, M)), O = j(d, O, k, L), (L += R) >= E.length ? L = E.length : L < A.length && !R ? L = A.length : L >= A.length && L < D && R && (L = Z(d, L)), k || (k = null), { value: O = P(d, O), enteredString: k, selection: { start: L, end: L } };
  }
  function H() {
    var d = new RegExp("windows", "i"), p = new RegExp("phone", "i"), g = navigator.userAgent;
    return d.test(g) && p.test(g);
  }
  function Y(d) {
    return typeof d == "function";
  }
  function ee() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function re() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function ie(d) {
    return (re() ? ee() : function() {
      return setTimeout(d, 1e3 / 60);
    })(d);
  }
  function te(d) {
    (re() || clearTimeout)(d);
  }
  var ue = function(d) {
    function p(l) {
      var i = d.call(this, l) || this;
      i.focused = !1, i.mounted = !1, i.previousSelection = null, i.selectionDeferId = null, i.saveSelectionLoopDeferId = null, i.saveSelectionLoop = function() {
        i.previousSelection = i.getSelection(), i.saveSelectionLoopDeferId = ie(i.saveSelectionLoop);
      }, i.runSaveSelectionLoop = function() {
        i.saveSelectionLoopDeferId === null && i.saveSelectionLoop();
      }, i.stopSaveSelectionLoop = function() {
        i.saveSelectionLoopDeferId !== null && (te(i.saveSelectionLoopDeferId), i.saveSelectionLoopDeferId = null, i.previousSelection = null);
      }, i.getInputDOMNode = function() {
        if (!i.mounted)
          return null;
        var T = n.findDOMNode(s(s(i))), F = typeof window < "u" && T instanceof window.Element;
        if (T && !F)
          return null;
        if (T.nodeName !== "INPUT" && (T = T.querySelector("input")), !T)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return T;
      }, i.getInputValue = function() {
        var T = i.getInputDOMNode();
        return T ? T.value : null;
      }, i.setInputValue = function(T) {
        var F = i.getInputDOMNode();
        F && (i.value = T, F.value = T);
      }, i.setCursorToEnd = function() {
        var T = _(i.maskOptions, i.value), F = Z(i.maskOptions, T);
        F !== null && i.setCursorPosition(F);
      }, i.setSelection = function(T, F, U) {
        U === void 0 && (U = {});
        var G = i.getInputDOMNode(), J = i.isFocused();
        G && J && (U.deferred || h(G, T, F), i.selectionDeferId !== null && te(i.selectionDeferId), i.selectionDeferId = ie(function() {
          i.selectionDeferId = null, h(G, T, F);
        }), i.previousSelection = { start: T, end: F, length: Math.abs(F - T) });
      }, i.getSelection = function() {
        return v(i.getInputDOMNode());
      }, i.getCursorPosition = function() {
        return i.getSelection().start;
      }, i.setCursorPosition = function(T) {
        i.setSelection(T, T);
      }, i.isFocused = function() {
        return i.focused;
      }, i.getBeforeMaskedValueChangeConfig = function() {
        var T = i.maskOptions, F = T.mask, U = T.maskChar, G = T.permanents, J = T.formatChars;
        return { mask: F, maskChar: U, permanents: G, alwaysShowMask: !!i.props.alwaysShowMask, formatChars: J };
      }, i.isInputAutofilled = function(T, F, U, G) {
        var J = i.getInputDOMNode();
        try {
          if (J.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return !i.focused || G.end < U.length && F.end === T.length;
      }, i.onChange = function(T) {
        var F = s(s(i)).beforePasteState, U = s(s(i)).previousSelection, G = i.props.beforeMaskedValueChange, J = i.getInputValue(), ae = i.value, ce = i.getSelection();
        i.isInputAutofilled(J, ce, ae, U) && (ae = P(i.maskOptions, ""), U = { start: 0, end: 0, length: 0 }), F && (U = F.selection, ae = F.value, ce = { start: U.start + J.length, end: U.start + J.length, length: 0 }, J = ae.slice(0, U.start) + J + ae.slice(U.end), i.beforePasteState = null);
        var ve = X(i.maskOptions, J, ce, ae, U), Ce = ve.enteredString, Oe = ve.selection, ke = ve.value;
        if (Y(G)) {
          var je = G({ value: ke, selection: Oe }, { value: ae, selection: U }, Ce, i.getBeforeMaskedValueChangeConfig());
          ke = je.value, Oe = je.selection;
        }
        i.setInputValue(ke), Y(i.props.onChange) && i.props.onChange(T), i.isWindowsPhoneBrowser ? i.setSelection(Oe.start, Oe.end, { deferred: !0 }) : i.setSelection(Oe.start, Oe.end);
      }, i.onFocus = function(T) {
        var F = i.props.beforeMaskedValueChange, U = i.maskOptions, G = U.mask, J = U.prefix;
        if (i.focused = !0, i.mounted = !0, G) {
          if (i.value)
            _(i.maskOptions, i.value) < i.maskOptions.mask.length && i.setCursorToEnd();
          else {
            var ae = P(i.maskOptions, J), ce = P(i.maskOptions, ae), ve = _(i.maskOptions, ce), Ce = Z(i.maskOptions, ve), Oe = { start: Ce, end: Ce };
            if (Y(F)) {
              var ke = F({ value: ce, selection: Oe }, { value: i.value, selection: null }, null, i.getBeforeMaskedValueChangeConfig());
              ce = ke.value, Oe = ke.selection;
            }
            var je = ce !== i.getInputValue();
            je && i.setInputValue(ce), je && Y(i.props.onChange) && i.props.onChange(T), i.setSelection(Oe.start, Oe.end);
          }
          i.runSaveSelectionLoop();
        }
        Y(i.props.onFocus) && i.props.onFocus(T);
      }, i.onBlur = function(T) {
        var F = i.props.beforeMaskedValueChange, U = i.maskOptions.mask;
        if (i.stopSaveSelectionLoop(), i.focused = !1, U && !i.props.alwaysShowMask && $(i.maskOptions, i.value)) {
          var G = "";
          Y(F) && (G = F({ value: G, selection: null }, { value: i.value, selection: i.previousSelection }, null, i.getBeforeMaskedValueChangeConfig()).value);
          var J = G !== i.getInputValue();
          J && i.setInputValue(G), J && Y(i.props.onChange) && i.props.onChange(T);
        }
        Y(i.props.onBlur) && i.props.onBlur(T);
      }, i.onMouseDown = function(T) {
        if (!i.focused && document.addEventListener) {
          i.mouseDownX = T.clientX, i.mouseDownY = T.clientY, i.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var F = function U(G) {
            if (document.removeEventListener("mouseup", U), i.focused) {
              var J = Math.abs(G.clientX - i.mouseDownX), ae = Math.abs(G.clientY - i.mouseDownY), ce = Math.max(J, ae), ve = (/* @__PURE__ */ new Date()).getTime() - i.mouseDownTime;
              (ce <= 10 && ve <= 200 || ce <= 5 && ve <= 300) && i.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", F);
        }
        Y(i.props.onMouseDown) && i.props.onMouseDown(T);
      }, i.onPaste = function(T) {
        Y(i.props.onPaste) && i.props.onPaste(T), T.defaultPrevented || (i.beforePasteState = { value: i.getInputValue(), selection: i.getSelection() }, i.setInputValue(""));
      }, i.handleRef = function(T) {
        i.props.children == null && Y(i.props.inputRef) && i.props.inputRef(T);
      };
      var E = l.mask, A = l.maskChar, D = l.formatChars, O = l.alwaysShowMask, k = l.beforeMaskedValueChange, R = l.defaultValue, M = l.value;
      i.maskOptions = S(E, A, D), R == null && (R = ""), M == null && (M = R);
      var L = se(M);
      if (i.maskOptions.mask && (O || L) && (L = P(i.maskOptions, L), Y(k))) {
        var I = l.value;
        l.value == null && (I = R), L = k({ value: L, selection: null }, { value: I = se(I), selection: null }, null, i.getBeforeMaskedValueChangeConfig()).value;
      }
      return i.value = L, i;
    }
    a(p, d);
    var g = p.prototype;
    return g.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = H(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, g.componentDidUpdate = function() {
      var l = this.previousSelection, i = this.props, E = i.beforeMaskedValueChange, A = i.alwaysShowMask, D = i.mask, O = i.maskChar, k = i.formatChars, R = this.maskOptions, M = A || this.isFocused(), L = this.props.value != null, I = L ? se(this.props.value) : this.value, T = l ? l.start : null;
      if (this.maskOptions = S(D, O, k), this.maskOptions.mask) {
        !R.mask && this.isFocused() && this.runSaveSelectionLoop();
        var F = this.maskOptions.mask && this.maskOptions.mask !== R.mask;
        if (R.mask || L || (I = this.getInputValue()), (F || this.maskOptions.mask && (I || M)) && (I = P(this.maskOptions, I)), F) {
          var U = _(this.maskOptions, I);
          (T === null || U < T) && (T = N(this.maskOptions, I) ? U : Z(this.maskOptions, U));
        }
        !this.maskOptions.mask || !$(this.maskOptions, I) || M || L && this.props.value || (I = "");
        var G = { start: T, end: T };
        if (Y(E)) {
          var J = E({ value: I, selection: G }, { value: this.value, selection: this.previousSelection }, null, this.getBeforeMaskedValueChangeConfig());
          I = J.value, G = J.selection;
        }
        this.value = I;
        var ae = this.getInputValue() !== this.value;
        ae ? (this.setInputValue(this.value), this.forceUpdate()) : F && this.forceUpdate();
        var ce = !1;
        G.start != null && G.end != null && (ce = !l || l.start !== G.start || l.end !== G.end), (ce || ae) && this.setSelection(G.start, G.end);
      } else
        R.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
    }, g.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && te(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, g.render = function() {
      var l, i = this.props, E = (i.mask, i.alwaysShowMask, i.maskChar, i.formatChars, i.inputRef, i.beforeMaskedValueChange, i.children), A = c(i, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);
      if (E) {
        Y(E) || u(!1);
        var D = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], O = o({}, A);
        D.forEach(function(R) {
          return delete O[R];
        }), l = E(O), D.filter(function(R) {
          return l.props[R] != null && l.props[R] !== A[R];
        }).length && u(!1);
      } else
        l = t.createElement("input", o({ ref: this.handleRef }, A));
      var k = { onFocus: this.onFocus, onBlur: this.onBlur };
      return this.maskOptions.mask && (A.disabled || A.readOnly || (k.onChange = this.onChange, k.onPaste = this.onPaste, k.onMouseDown = this.onMouseDown), A.value != null && (k.value = this.value)), l = t.cloneElement(l, k);
    }, p;
  }(t.Component);
  return jn = ue, jn;
}
var Nn, mo;
function xu() {
  if (mo)
    return Nn;
  mo = 1;
  var e = function(t, n, r, o, a, c, s, f) {
    if (process.env.NODE_ENV !== "production" && n === void 0)
      throw new Error("invariant requires an error message argument");
    if (!t) {
      var u;
      if (n === void 0)
        u = new Error(
          "Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings."
        );
      else {
        var h = [r, o, a, c, s, f], v = 0;
        u = new Error(
          n.replace(/%s/g, function() {
            return h[v++];
          })
        ), u.name = "Invariant Violation";
      }
      throw u.framesToPop = 1, u;
    }
  };
  return Nn = e, Nn;
}
var Fn, go;
function Ou() {
  if (go)
    return Fn;
  go = 1;
  var e = process.env.NODE_ENV !== "production", t = function() {
  };
  if (e) {
    var n = function(o, a) {
      var c = arguments.length;
      a = new Array(c > 1 ? c - 1 : 0);
      for (var s = 1; s < c; s++)
        a[s - 1] = arguments[s];
      var f = 0, u = "Warning: " + o.replace(/%s/g, function() {
        return a[f++];
      });
      typeof console < "u" && console.error(u);
      try {
        throw new Error(u);
      } catch {
      }
    };
    t = function(r, o, a) {
      var c = arguments.length;
      a = new Array(c > 2 ? c - 2 : 0);
      for (var s = 2; s < c; s++)
        a[s - 2] = arguments[s];
      if (o === void 0)
        throw new Error(
          "`warning(condition, format, ...args)` requires a warning message argument"
        );
      r || n.apply(null, [o].concat(a));
    };
  }
  return Fn = t, Fn;
}
var Ln, bo;
function Tu() {
  if (bo)
    return Ln;
  bo = 1;
  function e(d) {
    return d && typeof d == "object" && "default" in d ? d.default : d;
  }
  var t = e(Ie), n = rr, r = e(xu()), o = e(Ou());
  function a(d, p) {
    for (var g = Object.getOwnPropertyNames(p), l = 0; l < g.length; l++) {
      var i = g[l], E = Object.getOwnPropertyDescriptor(p, i);
      E && E.configurable && d[i] === void 0 && Object.defineProperty(d, i, E);
    }
    return d;
  }
  function c() {
    return c = Object.assign || function(d) {
      for (var p = 1; p < arguments.length; p++) {
        var g = arguments[p];
        for (var l in g)
          Object.prototype.hasOwnProperty.call(g, l) && (d[l] = g[l]);
      }
      return d;
    }, c.apply(this, arguments);
  }
  function s(d, p) {
    d.prototype = Object.create(p.prototype), d.prototype.constructor = d, a(d, p);
  }
  function f(d, p) {
    if (d == null)
      return {};
    var g = {}, l = Object.keys(d), i, E;
    for (E = 0; E < l.length; E++)
      i = l[E], !(p.indexOf(i) >= 0) && (g[i] = d[i]);
    return g;
  }
  function u(d) {
    if (d === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return d;
  }
  function h(d, p, g) {
    if ("selectionStart" in d && "selectionEnd" in d)
      d.selectionStart = p, d.selectionEnd = g;
    else {
      var l = d.createTextRange();
      l.collapse(!0), l.moveStart("character", p), l.moveEnd("character", g - p), l.select();
    }
  }
  function v(d) {
    var p = 0, g = 0;
    if ("selectionStart" in d && "selectionEnd" in d)
      p = d.selectionStart, g = d.selectionEnd;
    else {
      var l = document.selection.createRange();
      l.parentElement() === d && (p = -l.moveStart("character", -d.value.length), g = -l.moveEnd("character", -d.value.length));
    }
    return {
      start: p,
      end: g,
      length: g - p
    };
  }
  var w = {
    9: "[0-9]",
    a: "[A-Za-z]",
    "*": "[A-Za-z0-9]"
  }, y = "_";
  function S(d, p, g) {
    var l = "", i = "", E = null, A = [];
    if (p === void 0 && (p = y), g == null && (g = w), !d || typeof d != "string")
      return {
        maskChar: p,
        formatChars: g,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    var D = !1;
    return d.split("").forEach(function(O) {
      !D && O === "\\" ? D = !0 : (D || !g[O] ? (A.push(l.length), l.length === A.length - 1 && (i += O)) : E = l.length + 1, l += O, D = !1);
    }), {
      maskChar: p,
      formatChars: g,
      prefix: i,
      mask: l,
      lastEditablePosition: E,
      permanents: A
    };
  }
  function m(d, p) {
    return d.permanents.indexOf(p) !== -1;
  }
  function C(d, p, g) {
    var l = d.mask, i = d.formatChars;
    if (!g)
      return !1;
    if (m(d, p))
      return l[p] === g;
    var E = l[p], A = i[E];
    return new RegExp(A).test(g);
  }
  function $(d, p) {
    return p.split("").every(function(g, l) {
      return m(d, l) || !C(d, l, g);
    });
  }
  function _(d, p) {
    var g = d.maskChar, l = d.prefix;
    if (!g) {
      for (; p.length > l.length && m(d, p.length - 1); )
        p = p.slice(0, p.length - 1);
      return p.length;
    }
    for (var i = l.length, E = p.length; E >= l.length; E--) {
      var A = p[E], D = !m(d, E) && C(d, E, A);
      if (D) {
        i = E + 1;
        break;
      }
    }
    return i;
  }
  function N(d, p) {
    return _(d, p) === d.mask.length;
  }
  function P(d, p) {
    var g = d.maskChar, l = d.mask, i = d.prefix;
    if (!g) {
      for (p = j(d, "", p, 0), p.length < i.length && (p = i); p.length < l.length && m(d, p.length); )
        p += l[p.length];
      return p;
    }
    if (p) {
      var E = P(d, "");
      return j(d, E, p, 0);
    }
    for (var A = 0; A < l.length; A++)
      m(d, A) ? p += l[A] : p += g;
    return p;
  }
  function x(d, p, g, l) {
    var i = g + l, E = d.maskChar, A = d.mask, D = d.prefix, O = p.split("");
    if (!E) {
      for (var k = i; k < O.length; k++)
        m(d, k) && (O[k] = "");
      return g = Math.max(D.length, g), O.splice(g, i - g), p = O.join(""), P(d, p);
    }
    return O.map(function(R, M) {
      return M < g || M >= i ? R : m(d, M) ? A[M] : E;
    }).join("");
  }
  function j(d, p, g, l) {
    var i = d.mask, E = d.maskChar, A = d.prefix, D = g.split(""), O = N(d, p), k = function(L, I) {
      return !m(d, L) || I === i[L];
    }, R = function(L, I) {
      return !E || !m(d, I) || L !== E;
    };
    return !E && l > p.length && (p += i.slice(p.length, l)), D.every(function(M) {
      for (; !k(l, M); ) {
        if (l >= p.length && (p += i[l]), !R(M, l))
          return !0;
        if (l++, l >= i.length)
          return !1;
      }
      var L = C(d, l, M) || M === E;
      return L ? (l < p.length ? E || O || l < A.length ? p = p.slice(0, l) + M + p.slice(l + 1) : (p = p.slice(0, l) + M + p.slice(l), p = P(d, p)) : E || (p += M), l++, l < i.length) : !0;
    }), p;
  }
  function q(d, p, g, l) {
    var i = d.mask, E = d.maskChar, A = g.split(""), D = l, O = function(R, M) {
      return !m(d, R) || M === i[R];
    };
    return A.every(function(k) {
      for (; !O(l, k); )
        if (l++, l >= i.length)
          return !1;
      var R = C(d, l, k) || k === E;
      return R && l++, l < i.length;
    }), l - D;
  }
  function K(d, p) {
    for (var g = p; g >= 0; --g)
      if (!m(d, g))
        return g;
    return null;
  }
  function Z(d, p) {
    for (var g = d.mask, l = p; l < g.length; ++l)
      if (!m(d, l))
        return l;
    return null;
  }
  function se(d) {
    return !d && d !== 0 ? "" : d + "";
  }
  function X(d, p, g, l, i) {
    var E = d.mask, A = d.prefix, D = d.lastEditablePosition, O = p, k = "", R = 0, M = 0, L = Math.min(i.start, g.start);
    if (g.end > i.start ? (k = O.slice(i.start, g.end), R = q(d, l, k, L), R ? M = i.length : M = 0) : O.length < l.length && (M = l.length - O.length), O = l, M) {
      if (M === 1 && !i.length) {
        var I = i.start === g.start;
        L = I ? Z(d, g.start) : K(d, g.start);
      }
      O = x(d, O, L, M);
    }
    return O = j(d, O, k, L), L = L + R, L >= E.length ? L = E.length : L < A.length && !R ? L = A.length : L >= A.length && L < D && R && (L = Z(d, L)), O = P(d, O), k || (k = null), {
      value: O,
      enteredString: k,
      selection: {
        start: L,
        end: L
      }
    };
  }
  function H() {
    var d = new RegExp("windows", "i"), p = new RegExp("phone", "i"), g = navigator.userAgent;
    return d.test(g) && p.test(g);
  }
  function Y(d) {
    return typeof d == "function";
  }
  function ee() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }
  function re() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }
  function ie(d) {
    var p = !!re(), g;
    return p ? g = ee() : g = function() {
      return setTimeout(d, 1e3 / 60);
    }, g(d);
  }
  function te(d) {
    var p = re() || clearTimeout;
    p(d);
  }
  var ue = /* @__PURE__ */ function(d) {
    s(p, d);
    function p(l) {
      var i;
      i = d.call(this, l) || this, i.focused = !1, i.mounted = !1, i.previousSelection = null, i.selectionDeferId = null, i.saveSelectionLoopDeferId = null, i.saveSelectionLoop = function() {
        i.previousSelection = i.getSelection(), i.saveSelectionLoopDeferId = ie(i.saveSelectionLoop);
      }, i.runSaveSelectionLoop = function() {
        i.saveSelectionLoopDeferId === null && i.saveSelectionLoop();
      }, i.stopSaveSelectionLoop = function() {
        i.saveSelectionLoopDeferId !== null && (te(i.saveSelectionLoopDeferId), i.saveSelectionLoopDeferId = null, i.previousSelection = null);
      }, i.getInputDOMNode = function() {
        if (!i.mounted)
          return null;
        var F = n.findDOMNode(u(u(i))), U = typeof window < "u" && F instanceof window.Element;
        if (F && !U)
          return null;
        if (F.nodeName !== "INPUT" && (F = F.querySelector("input")), !F)
          throw new Error("react-input-mask: inputComponent doesn't contain input node");
        return F;
      }, i.getInputValue = function() {
        var F = i.getInputDOMNode();
        return F ? F.value : null;
      }, i.setInputValue = function(F) {
        var U = i.getInputDOMNode();
        U && (i.value = F, U.value = F);
      }, i.setCursorToEnd = function() {
        var F = _(i.maskOptions, i.value), U = Z(i.maskOptions, F);
        U !== null && i.setCursorPosition(U);
      }, i.setSelection = function(F, U, G) {
        G === void 0 && (G = {});
        var J = i.getInputDOMNode(), ae = i.isFocused();
        if (!(!J || !ae)) {
          var ce = G, ve = ce.deferred;
          ve || h(J, F, U), i.selectionDeferId !== null && te(i.selectionDeferId), i.selectionDeferId = ie(function() {
            i.selectionDeferId = null, h(J, F, U);
          }), i.previousSelection = {
            start: F,
            end: U,
            length: Math.abs(U - F)
          };
        }
      }, i.getSelection = function() {
        var F = i.getInputDOMNode();
        return v(F);
      }, i.getCursorPosition = function() {
        return i.getSelection().start;
      }, i.setCursorPosition = function(F) {
        i.setSelection(F, F);
      }, i.isFocused = function() {
        return i.focused;
      }, i.getBeforeMaskedValueChangeConfig = function() {
        var F = i.maskOptions, U = F.mask, G = F.maskChar, J = F.permanents, ae = F.formatChars, ce = i.props.alwaysShowMask;
        return {
          mask: U,
          maskChar: G,
          permanents: J,
          alwaysShowMask: !!ce,
          formatChars: ae
        };
      }, i.isInputAutofilled = function(F, U, G, J) {
        var ae = i.getInputDOMNode();
        try {
          if (ae.matches(":-webkit-autofill"))
            return !0;
        } catch {
        }
        return i.focused ? J.end < G.length && U.end === F.length : !0;
      }, i.onChange = function(F) {
        var U = u(u(i)), G = U.beforePasteState, J = u(u(i)), ae = J.previousSelection, ce = i.props.beforeMaskedValueChange, ve = i.getInputValue(), Ce = i.value, Oe = i.getSelection();
        i.isInputAutofilled(ve, Oe, Ce, ae) && (Ce = P(i.maskOptions, ""), ae = {
          start: 0,
          end: 0,
          length: 0
        }), G && (ae = G.selection, Ce = G.value, Oe = {
          start: ae.start + ve.length,
          end: ae.start + ve.length,
          length: 0
        }, ve = Ce.slice(0, ae.start) + ve + Ce.slice(ae.end), i.beforePasteState = null);
        var ke = X(i.maskOptions, ve, Oe, Ce, ae), je = ke.enteredString, Ne = ke.selection, ft = ke.value;
        if (Y(ce)) {
          var Qe = ce({
            value: ft,
            selection: Ne
          }, {
            value: Ce,
            selection: ae
          }, je, i.getBeforeMaskedValueChangeConfig());
          ft = Qe.value, Ne = Qe.selection;
        }
        i.setInputValue(ft), Y(i.props.onChange) && i.props.onChange(F), i.isWindowsPhoneBrowser ? i.setSelection(Ne.start, Ne.end, {
          deferred: !0
        }) : i.setSelection(Ne.start, Ne.end);
      }, i.onFocus = function(F) {
        var U = i.props.beforeMaskedValueChange, G = i.maskOptions, J = G.mask, ae = G.prefix;
        if (i.focused = !0, i.mounted = !0, J) {
          if (i.value)
            _(i.maskOptions, i.value) < i.maskOptions.mask.length && i.setCursorToEnd();
          else {
            var ce = P(i.maskOptions, ae), ve = P(i.maskOptions, ce), Ce = _(i.maskOptions, ve), Oe = Z(i.maskOptions, Ce), ke = {
              start: Oe,
              end: Oe
            };
            if (Y(U)) {
              var je = U({
                value: ve,
                selection: ke
              }, {
                value: i.value,
                selection: null
              }, null, i.getBeforeMaskedValueChangeConfig());
              ve = je.value, ke = je.selection;
            }
            var Ne = ve !== i.getInputValue();
            Ne && i.setInputValue(ve), Ne && Y(i.props.onChange) && i.props.onChange(F), i.setSelection(ke.start, ke.end);
          }
          i.runSaveSelectionLoop();
        }
        Y(i.props.onFocus) && i.props.onFocus(F);
      }, i.onBlur = function(F) {
        var U = i.props.beforeMaskedValueChange, G = i.maskOptions.mask;
        if (i.stopSaveSelectionLoop(), i.focused = !1, G && !i.props.alwaysShowMask && $(i.maskOptions, i.value)) {
          var J = "";
          if (Y(U)) {
            var ae = U({
              value: J,
              selection: null
            }, {
              value: i.value,
              selection: i.previousSelection
            }, null, i.getBeforeMaskedValueChangeConfig());
            J = ae.value;
          }
          var ce = J !== i.getInputValue();
          ce && i.setInputValue(J), ce && Y(i.props.onChange) && i.props.onChange(F);
        }
        Y(i.props.onBlur) && i.props.onBlur(F);
      }, i.onMouseDown = function(F) {
        if (!i.focused && document.addEventListener) {
          i.mouseDownX = F.clientX, i.mouseDownY = F.clientY, i.mouseDownTime = (/* @__PURE__ */ new Date()).getTime();
          var U = function G(J) {
            if (document.removeEventListener("mouseup", G), !!i.focused) {
              var ae = Math.abs(J.clientX - i.mouseDownX), ce = Math.abs(J.clientY - i.mouseDownY), ve = Math.max(ae, ce), Ce = (/* @__PURE__ */ new Date()).getTime() - i.mouseDownTime;
              (ve <= 10 && Ce <= 200 || ve <= 5 && Ce <= 300) && i.setCursorToEnd();
            }
          };
          document.addEventListener("mouseup", U);
        }
        Y(i.props.onMouseDown) && i.props.onMouseDown(F);
      }, i.onPaste = function(F) {
        Y(i.props.onPaste) && i.props.onPaste(F), F.defaultPrevented || (i.beforePasteState = {
          value: i.getInputValue(),
          selection: i.getSelection()
        }, i.setInputValue(""));
      }, i.handleRef = function(F) {
        i.props.children == null && Y(i.props.inputRef) && i.props.inputRef(F);
      };
      var E = l.mask, A = l.maskChar, D = l.formatChars, O = l.alwaysShowMask, k = l.beforeMaskedValueChange, R = l.defaultValue, M = l.value;
      i.maskOptions = S(E, A, D), R == null && (R = ""), M == null && (M = R);
      var L = se(M);
      if (i.maskOptions.mask && (O || L) && (L = P(i.maskOptions, L), Y(k))) {
        var I = l.value;
        l.value == null && (I = R), I = se(I);
        var T = k({
          value: L,
          selection: null
        }, {
          value: I,
          selection: null
        }, null, i.getBeforeMaskedValueChangeConfig());
        L = T.value;
      }
      return i.value = L, i;
    }
    var g = p.prototype;
    return g.componentDidMount = function() {
      this.mounted = !0, this.getInputDOMNode() && (this.isWindowsPhoneBrowser = H(), this.maskOptions.mask && this.getInputValue() !== this.value && this.setInputValue(this.value));
    }, g.componentDidUpdate = function() {
      var i = this.previousSelection, E = this.props, A = E.beforeMaskedValueChange, D = E.alwaysShowMask, O = E.mask, k = E.maskChar, R = E.formatChars, M = this.maskOptions, L = D || this.isFocused(), I = this.props.value != null, T = I ? se(this.props.value) : this.value, F = i ? i.start : null;
      if (this.maskOptions = S(O, k, R), this.maskOptions.mask)
        !M.mask && this.isFocused() && this.runSaveSelectionLoop();
      else {
        M.mask && (this.stopSaveSelectionLoop(), this.forceUpdate());
        return;
      }
      var U = this.maskOptions.mask && this.maskOptions.mask !== M.mask;
      if (!M.mask && !I && (T = this.getInputValue()), (U || this.maskOptions.mask && (T || L)) && (T = P(this.maskOptions, T)), U) {
        var G = _(this.maskOptions, T);
        (F === null || G < F) && (N(this.maskOptions, T) ? F = G : F = Z(this.maskOptions, G));
      }
      this.maskOptions.mask && $(this.maskOptions, T) && !L && (!I || !this.props.value) && (T = "");
      var J = {
        start: F,
        end: F
      };
      if (Y(A)) {
        var ae = A({
          value: T,
          selection: J
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        T = ae.value, J = ae.selection;
      }
      this.value = T;
      var ce = this.getInputValue() !== this.value;
      ce ? (this.setInputValue(this.value), this.forceUpdate()) : U && this.forceUpdate();
      var ve = !1;
      J.start != null && J.end != null && (ve = !i || i.start !== J.start || i.end !== J.end), (ve || ce) && this.setSelection(J.start, J.end);
    }, g.componentWillUnmount = function() {
      this.mounted = !1, this.selectionDeferId !== null && te(this.selectionDeferId), this.stopSaveSelectionLoop();
    }, g.render = function() {
      var i = this.props, E = i.mask;
      i.alwaysShowMask;
      var A = i.maskChar, D = i.formatChars, O = i.inputRef;
      i.beforeMaskedValueChange;
      var k = i.children, R = f(i, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]), M;
      if (process.env.NODE_ENV !== "production" && o(
        // parse mask to test against actual mask prop as this.maskOptions
        // will be updated later in componentDidUpdate
        !R.maxLength || !S(E, A, D).mask,
        "react-input-mask: maxLength property shouldn't be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length."
      ), k) {
        Y(k) || (process.env.NODE_ENV !== "production" ? r(!1, "react-input-mask: children must be a function") : r(!1));
        var L = ["onChange", "onPaste", "onMouseDown", "onFocus", "onBlur", "value", "disabled", "readOnly"], I = c({}, R);
        L.forEach(function(U) {
          return delete I[U];
        }), M = k(I);
        var T = L.filter(function(U) {
          return M.props[U] != null && M.props[U] !== R[U];
        });
        T.length && (process.env.NODE_ENV !== "production" ? r(!1, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + T.join(", ")) : r(!1)), process.env.NODE_ENV !== "production" && o(!O, "react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead");
      } else
        M = t.createElement("input", c({
          ref: this.handleRef
        }, R));
      var F = {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };
      return this.maskOptions.mask && (!R.disabled && !R.readOnly && (F.onChange = this.onChange, F.onPaste = this.onPaste, F.onMouseDown = this.onMouseDown), R.value != null && (F.value = this.value)), M = t.cloneElement(M, F), M;
    }, p;
  }(t.Component);
  return Ln = ue, Ln;
}
process.env.NODE_ENV === "production" ? Jn.exports = Cu() : Jn.exports = Tu();
var Pu = Jn.exports;
const _u = /* @__PURE__ */ $o(Pu), qe = Ie.forwardRef(Sr);
function Sr({
  id: e,
  name: t,
  as: n,
  value: r,
  placeholder: o,
  disabled: a,
  invalid: c,
  small: s,
  mask: f,
  leftSlot: u,
  rightSlot: h,
  disableThrottle: v,
  throttleTimeout: w,
  onChange: y,
  onBlur: S,
  ...m
}, C) {
  const $ = ["mds-input"], [_, N] = xe(r), P = _e(
    $u((K, Z) => y == null ? void 0 : y(K, Z), w),
    [w, y]
  ), x = (K) => {
    const Z = K.target.value;
    N(Z), v ? y == null || y(Z, K) : P(Z, K);
  };
  $e(() => {
    N(r);
  }, [r]);
  const j = n || (f ? _u : "input");
  f && !m.maskChar && (m.maskChar = null), s && $.push("mds-input-small");
  let q = [
    /* @__PURE__ */ W.jsx("div", { className: "mds-input-wrapper", children: /* @__PURE__ */ W.jsx(
      j,
      {
        lang: "en",
        ref: C,
        id: e,
        name: t,
        placeholder: o || " ",
        value: _,
        disabled: a,
        onChange: x,
        onBlur: S,
        "aria-invalid": c,
        mask: f,
        ...m
      }
    ) }, o)
  ];
  return u && q.unshift(u), h && q.push(h), /* @__PURE__ */ W.jsx("label", { className: $.join(" "), children: /* @__PURE__ */ W.jsx("div", { className: "mds-input-content", children: q }) });
}
Sr.propTypes = {
  id: V.string,
  as: V.oneOfType([V.arrayOf(V.node), V.node]),
  name: V.string,
  placeholder: V.string,
  value: V.string,
  mask: V.string,
  markChar: V.string,
  leftSlot: V.oneOfType([
    V.arrayOf(V.node),
    V.node
  ]),
  rightSlot: V.oneOfType([
    V.arrayOf(V.node),
    V.node
  ]),
  small: V.bool,
  disabled: V.bool,
  invalid: V.bool,
  onChange: V.func,
  onBlur: V.func,
  disableThrottle: V.bool,
  throttleTimeout: V.number
};
const Ru = {
  id: "",
  name: "",
  placeholder: " ",
  value: "",
  mask: "",
  leftSlot: null,
  rightSlot: null,
  small: !1,
  disabled: !1,
  invalid: !1,
  disableThrottle: !1,
  throttleTimeout: 500,
  onChange: Ue,
  onBlur: Ue
};
Sr.defaultProps = Ru;
const ml = fe(on);
/**
 * @preserve
 * A credit card numbers masked input field component.
 *
 * @component
 * @param {object} props - The properties for the CreditCardNumberInput component.
 * @param {string} [props.placeholder="1234 1234 1234 1234"] - The placeholder text for the input field.
 * @returns {JSX.Element} The rendered CreditCardNumberInput component.
 */
function on({ ...e }, t) {
  const n = pe(t);
  return /* @__PURE__ */ W.jsx(
    qe,
    {
      leftSlot: /* @__PURE__ */ W.jsx(Ee, { name: "subscription" }, "subscription"),
      mask: "9999 9999 9999 9999",
      ...e,
      ref: n
    }
  );
}
on.displayName = "CreditCardNumberInput";
on.propTypes = {
  placeholder: V.string
};
on.defaultProps = {
  placeholder: "1234 1234 1234 1234"
};
var ku = Object.create, vi = Object.defineProperty, Iu = Object.getOwnPropertyDescriptor, hi = Object.getOwnPropertyNames, Au = Object.getPrototypeOf, Mu = Object.prototype.hasOwnProperty, ze = (e, t) => function() {
  return t || (0, e[hi(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, Du = (e, t, n, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let o of hi(t))
      !Mu.call(e, o) && o !== n && vi(e, o, { get: () => t[o], enumerable: !(r = Iu(t, o)) || r.enumerable });
  return e;
}, ju = (e, t, n) => (n = e != null ? ku(Au(e)) : {}, Du(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  t || !e || !e.__esModule ? vi(n, "default", { value: e, enumerable: !0 }) : n,
  e
)), Nu = ze({
  "node_modules/react-is/cjs/react-is.production.min.js"(e) {
    var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, o = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, c = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, f = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, h = t ? Symbol.for("react.concurrent_mode") : 60111, v = t ? Symbol.for("react.forward_ref") : 60112, w = t ? Symbol.for("react.suspense") : 60113, y = t ? Symbol.for("react.suspense_list") : 60120, S = t ? Symbol.for("react.memo") : 60115, m = t ? Symbol.for("react.lazy") : 60116, C = t ? Symbol.for("react.block") : 60121, $ = t ? Symbol.for("react.fundamental") : 60117, _ = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
    function P(j) {
      if (typeof j == "object" && j !== null) {
        var q = j.$$typeof;
        switch (q) {
          case n:
            switch (j = j.type, j) {
              case u:
              case h:
              case o:
              case c:
              case a:
              case w:
                return j;
              default:
                switch (j = j && j.$$typeof, j) {
                  case f:
                  case v:
                  case m:
                  case S:
                  case s:
                    return j;
                  default:
                    return q;
                }
            }
          case r:
            return q;
        }
      }
    }
    function x(j) {
      return P(j) === h;
    }
    e.AsyncMode = u, e.ConcurrentMode = h, e.ContextConsumer = f, e.ContextProvider = s, e.Element = n, e.ForwardRef = v, e.Fragment = o, e.Lazy = m, e.Memo = S, e.Portal = r, e.Profiler = c, e.StrictMode = a, e.Suspense = w, e.isAsyncMode = function(j) {
      return x(j) || P(j) === u;
    }, e.isConcurrentMode = x, e.isContextConsumer = function(j) {
      return P(j) === f;
    }, e.isContextProvider = function(j) {
      return P(j) === s;
    }, e.isElement = function(j) {
      return typeof j == "object" && j !== null && j.$$typeof === n;
    }, e.isForwardRef = function(j) {
      return P(j) === v;
    }, e.isFragment = function(j) {
      return P(j) === o;
    }, e.isLazy = function(j) {
      return P(j) === m;
    }, e.isMemo = function(j) {
      return P(j) === S;
    }, e.isPortal = function(j) {
      return P(j) === r;
    }, e.isProfiler = function(j) {
      return P(j) === c;
    }, e.isStrictMode = function(j) {
      return P(j) === a;
    }, e.isSuspense = function(j) {
      return P(j) === w;
    }, e.isValidElementType = function(j) {
      return typeof j == "string" || typeof j == "function" || j === o || j === h || j === c || j === a || j === w || j === y || typeof j == "object" && j !== null && (j.$$typeof === m || j.$$typeof === S || j.$$typeof === s || j.$$typeof === f || j.$$typeof === v || j.$$typeof === $ || j.$$typeof === _ || j.$$typeof === N || j.$$typeof === C);
    }, e.typeOf = P;
  }
}), Fu = ze({
  "node_modules/react-is/cjs/react-is.development.js"(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, o = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, c = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, f = t ? Symbol.for("react.context") : 60110, u = t ? Symbol.for("react.async_mode") : 60111, h = t ? Symbol.for("react.concurrent_mode") : 60111, v = t ? Symbol.for("react.forward_ref") : 60112, w = t ? Symbol.for("react.suspense") : 60113, y = t ? Symbol.for("react.suspense_list") : 60120, S = t ? Symbol.for("react.memo") : 60115, m = t ? Symbol.for("react.lazy") : 60116, C = t ? Symbol.for("react.block") : 60121, $ = t ? Symbol.for("react.fundamental") : 60117, _ = t ? Symbol.for("react.responder") : 60118, N = t ? Symbol.for("react.scope") : 60119;
      function P(T) {
        return typeof T == "string" || typeof T == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        T === o || T === h || T === c || T === a || T === w || T === y || typeof T == "object" && T !== null && (T.$$typeof === m || T.$$typeof === S || T.$$typeof === s || T.$$typeof === f || T.$$typeof === v || T.$$typeof === $ || T.$$typeof === _ || T.$$typeof === N || T.$$typeof === C);
      }
      function x(T) {
        if (typeof T == "object" && T !== null) {
          var F = T.$$typeof;
          switch (F) {
            case n:
              var U = T.type;
              switch (U) {
                case u:
                case h:
                case o:
                case c:
                case a:
                case w:
                  return U;
                default:
                  var G = U && U.$$typeof;
                  switch (G) {
                    case f:
                    case v:
                    case m:
                    case S:
                    case s:
                      return G;
                    default:
                      return F;
                  }
              }
            case r:
              return F;
          }
        }
      }
      var j = u, q = h, K = f, Z = s, se = n, X = v, H = o, Y = m, ee = S, re = r, ie = c, te = a, ue = w, d = !1;
      function p(T) {
        return d || (d = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), g(T) || x(T) === u;
      }
      function g(T) {
        return x(T) === h;
      }
      function l(T) {
        return x(T) === f;
      }
      function i(T) {
        return x(T) === s;
      }
      function E(T) {
        return typeof T == "object" && T !== null && T.$$typeof === n;
      }
      function A(T) {
        return x(T) === v;
      }
      function D(T) {
        return x(T) === o;
      }
      function O(T) {
        return x(T) === m;
      }
      function k(T) {
        return x(T) === S;
      }
      function R(T) {
        return x(T) === r;
      }
      function M(T) {
        return x(T) === c;
      }
      function L(T) {
        return x(T) === a;
      }
      function I(T) {
        return x(T) === w;
      }
      e.AsyncMode = j, e.ConcurrentMode = q, e.ContextConsumer = K, e.ContextProvider = Z, e.Element = se, e.ForwardRef = X, e.Fragment = H, e.Lazy = Y, e.Memo = ee, e.Portal = re, e.Profiler = ie, e.StrictMode = te, e.Suspense = ue, e.isAsyncMode = p, e.isConcurrentMode = g, e.isContextConsumer = l, e.isContextProvider = i, e.isElement = E, e.isForwardRef = A, e.isFragment = D, e.isLazy = O, e.isMemo = k, e.isPortal = R, e.isProfiler = M, e.isStrictMode = L, e.isSuspense = I, e.isValidElementType = P, e.typeOf = x;
    }();
  }
}), mi = ze({
  "node_modules/react-is/index.js"(e, t) {
    process.env.NODE_ENV === "production" ? t.exports = Nu() : t.exports = Fu();
  }
}), Lu = ze({
  "node_modules/object-assign/index.js"(e, t) {
    var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, o = Object.prototype.propertyIsEnumerable;
    function a(s) {
      if (s == null)
        throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(s);
    }
    function c() {
      try {
        if (!Object.assign)
          return !1;
        var s = new String("abc");
        if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
          return !1;
        for (var f = {}, u = 0; u < 10; u++)
          f["_" + String.fromCharCode(u)] = u;
        var h = Object.getOwnPropertyNames(f).map(function(w) {
          return f[w];
        });
        if (h.join("") !== "0123456789")
          return !1;
        var v = {};
        return "abcdefghijklmnopqrst".split("").forEach(function(w) {
          v[w] = w;
        }), Object.keys(Object.assign({}, v)).join("") === "abcdefghijklmnopqrst";
      } catch {
        return !1;
      }
    }
    t.exports = c() ? Object.assign : function(s, f) {
      for (var u, h = a(s), v, w = 1; w < arguments.length; w++) {
        u = Object(arguments[w]);
        for (var y in u)
          r.call(u, y) && (h[y] = u[y]);
        if (n) {
          v = n(u);
          for (var S = 0; S < v.length; S++)
            o.call(u, v[S]) && (h[v[S]] = u[v[S]]);
        }
      }
      return h;
    };
  }
}), $r = ze({
  "node_modules/prop-types/lib/ReactPropTypesSecret.js"(e, t) {
    var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    t.exports = n;
  }
}), gi = ze({
  "node_modules/prop-types/lib/has.js"(e, t) {
    t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
  }
}), Vu = ze({
  "node_modules/prop-types/checkPropTypes.js"(e, t) {
    var n = function() {
    };
    process.env.NODE_ENV !== "production" && (r = $r(), o = {}, a = gi(), n = function(s) {
      var f = "Warning: " + s;
      typeof console < "u" && console.error(f);
      try {
        throw new Error(f);
      } catch {
      }
    });
    var r, o, a;
    function c(s, f, u, h, v) {
      if (process.env.NODE_ENV !== "production") {
        for (var w in s)
          if (a(s, w)) {
            var y;
            try {
              if (typeof s[w] != "function") {
                var S = Error(
                  (h || "React class") + ": " + u + " type `" + w + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[w] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                throw S.name = "Invariant Violation", S;
              }
              y = s[w](f, w, h, u, null, r);
            } catch (C) {
              y = C;
            }
            if (y && !(y instanceof Error) && n(
              (h || "React class") + ": type specification of " + u + " `" + w + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof y + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            ), y instanceof Error && !(y.message in o)) {
              o[y.message] = !0;
              var m = v ? v() : "";
              n(
                "Failed " + u + " type: " + y.message + (m ?? "")
              );
            }
          }
      }
    }
    c.resetWarningCache = function() {
      process.env.NODE_ENV !== "production" && (o = {});
    }, t.exports = c;
  }
}), Bu = ze({
  "node_modules/prop-types/factoryWithTypeCheckers.js"(e, t) {
    var n = mi(), r = Lu(), o = $r(), a = gi(), c = Vu(), s = function() {
    };
    process.env.NODE_ENV !== "production" && (s = function(u) {
      var h = "Warning: " + u;
      typeof console < "u" && console.error(h);
      try {
        throw new Error(h);
      } catch {
      }
    });
    function f() {
      return null;
    }
    t.exports = function(u, h) {
      var v = typeof Symbol == "function" && Symbol.iterator, w = "@@iterator";
      function y(l) {
        var i = l && (v && l[v] || l[w]);
        if (typeof i == "function")
          return i;
      }
      var S = "<<anonymous>>", m = {
        array: N("array"),
        bigint: N("bigint"),
        bool: N("boolean"),
        func: N("function"),
        number: N("number"),
        object: N("object"),
        string: N("string"),
        symbol: N("symbol"),
        any: P(),
        arrayOf: x,
        element: j(),
        elementType: q(),
        instanceOf: K,
        node: H(),
        objectOf: se,
        oneOf: Z,
        oneOfType: X,
        shape: ee,
        exact: re
      };
      function C(l, i) {
        return l === i ? l !== 0 || 1 / l === 1 / i : l !== l && i !== i;
      }
      function $(l, i) {
        this.message = l, this.data = i && typeof i == "object" ? i : {}, this.stack = "";
      }
      $.prototype = Error.prototype;
      function _(l) {
        if (process.env.NODE_ENV !== "production")
          var i = {}, E = 0;
        function A(O, k, R, M, L, I, T) {
          if (M = M || S, I = I || R, T !== o) {
            if (h) {
              var F = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              throw F.name = "Invariant Violation", F;
            } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
              var U = M + ":" + R;
              !i[U] && // Avoid spamming the console because they are often not actionable except for lib authors
              E < 3 && (s(
                "You are manually calling a React.PropTypes validation function for the `" + I + "` prop on `" + M + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              ), i[U] = !0, E++);
            }
          }
          return k[R] == null ? O ? k[R] === null ? new $("The " + L + " `" + I + "` is marked as required " + ("in `" + M + "`, but its value is `null`.")) : new $("The " + L + " `" + I + "` is marked as required in " + ("`" + M + "`, but its value is `undefined`.")) : null : l(k, R, M, L, I);
        }
        var D = A.bind(null, !1);
        return D.isRequired = A.bind(null, !0), D;
      }
      function N(l) {
        function i(E, A, D, O, k, R) {
          var M = E[A], L = ue(M);
          if (L !== l) {
            var I = d(M);
            return new $(
              "Invalid " + O + " `" + k + "` of type " + ("`" + I + "` supplied to `" + D + "`, expected ") + ("`" + l + "`."),
              { expectedType: l }
            );
          }
          return null;
        }
        return _(i);
      }
      function P() {
        return _(f);
      }
      function x(l) {
        function i(E, A, D, O, k) {
          if (typeof l != "function")
            return new $("Property `" + k + "` of component `" + D + "` has invalid PropType notation inside arrayOf.");
          var R = E[A];
          if (!Array.isArray(R)) {
            var M = ue(R);
            return new $("Invalid " + O + " `" + k + "` of type " + ("`" + M + "` supplied to `" + D + "`, expected an array."));
          }
          for (var L = 0; L < R.length; L++) {
            var I = l(R, L, D, O, k + "[" + L + "]", o);
            if (I instanceof Error)
              return I;
          }
          return null;
        }
        return _(i);
      }
      function j() {
        function l(i, E, A, D, O) {
          var k = i[E];
          if (!u(k)) {
            var R = ue(k);
            return new $("Invalid " + D + " `" + O + "` of type " + ("`" + R + "` supplied to `" + A + "`, expected a single ReactElement."));
          }
          return null;
        }
        return _(l);
      }
      function q() {
        function l(i, E, A, D, O) {
          var k = i[E];
          if (!n.isValidElementType(k)) {
            var R = ue(k);
            return new $("Invalid " + D + " `" + O + "` of type " + ("`" + R + "` supplied to `" + A + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return _(l);
      }
      function K(l) {
        function i(E, A, D, O, k) {
          if (!(E[A] instanceof l)) {
            var R = l.name || S, M = g(E[A]);
            return new $("Invalid " + O + " `" + k + "` of type " + ("`" + M + "` supplied to `" + D + "`, expected ") + ("instance of `" + R + "`."));
          }
          return null;
        }
        return _(i);
      }
      function Z(l) {
        if (!Array.isArray(l))
          return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
            "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
          ) : s("Invalid argument supplied to oneOf, expected an array.")), f;
        function i(E, A, D, O, k) {
          for (var R = E[A], M = 0; M < l.length; M++)
            if (C(R, l[M]))
              return null;
          var L = JSON.stringify(l, function(T, F) {
            var U = d(F);
            return U === "symbol" ? String(F) : F;
          });
          return new $("Invalid " + O + " `" + k + "` of value `" + String(R) + "` " + ("supplied to `" + D + "`, expected one of " + L + "."));
        }
        return _(i);
      }
      function se(l) {
        function i(E, A, D, O, k) {
          if (typeof l != "function")
            return new $("Property `" + k + "` of component `" + D + "` has invalid PropType notation inside objectOf.");
          var R = E[A], M = ue(R);
          if (M !== "object")
            return new $("Invalid " + O + " `" + k + "` of type " + ("`" + M + "` supplied to `" + D + "`, expected an object."));
          for (var L in R)
            if (a(R, L)) {
              var I = l(R, L, D, O, k + "." + L, o);
              if (I instanceof Error)
                return I;
            }
          return null;
        }
        return _(i);
      }
      function X(l) {
        if (!Array.isArray(l))
          return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), f;
        for (var i = 0; i < l.length; i++) {
          var E = l[i];
          if (typeof E != "function")
            return s(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + p(E) + " at index " + i + "."
            ), f;
        }
        function A(D, O, k, R, M) {
          for (var L = [], I = 0; I < l.length; I++) {
            var T = l[I], F = T(D, O, k, R, M, o);
            if (F == null)
              return null;
            F.data && a(F.data, "expectedType") && L.push(F.data.expectedType);
          }
          var U = L.length > 0 ? ", expected one of type [" + L.join(", ") + "]" : "";
          return new $("Invalid " + R + " `" + M + "` supplied to " + ("`" + k + "`" + U + "."));
        }
        return _(A);
      }
      function H() {
        function l(i, E, A, D, O) {
          return ie(i[E]) ? null : new $("Invalid " + D + " `" + O + "` supplied to " + ("`" + A + "`, expected a ReactNode."));
        }
        return _(l);
      }
      function Y(l, i, E, A, D) {
        return new $(
          (l || "React class") + ": " + i + " type `" + E + "." + A + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + D + "`."
        );
      }
      function ee(l) {
        function i(E, A, D, O, k) {
          var R = E[A], M = ue(R);
          if (M !== "object")
            return new $("Invalid " + O + " `" + k + "` of type `" + M + "` " + ("supplied to `" + D + "`, expected `object`."));
          for (var L in l) {
            var I = l[L];
            if (typeof I != "function")
              return Y(D, O, k, L, d(I));
            var T = I(R, L, D, O, k + "." + L, o);
            if (T)
              return T;
          }
          return null;
        }
        return _(i);
      }
      function re(l) {
        function i(E, A, D, O, k) {
          var R = E[A], M = ue(R);
          if (M !== "object")
            return new $("Invalid " + O + " `" + k + "` of type `" + M + "` " + ("supplied to `" + D + "`, expected `object`."));
          var L = r({}, E[A], l);
          for (var I in L) {
            var T = l[I];
            if (a(l, I) && typeof T != "function")
              return Y(D, O, k, I, d(T));
            if (!T)
              return new $(
                "Invalid " + O + " `" + k + "` key `" + I + "` supplied to `" + D + "`.\nBad object: " + JSON.stringify(E[A], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(l), null, "  ")
              );
            var F = T(R, I, D, O, k + "." + I, o);
            if (F)
              return F;
          }
          return null;
        }
        return _(i);
      }
      function ie(l) {
        switch (typeof l) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !l;
          case "object":
            if (Array.isArray(l))
              return l.every(ie);
            if (l === null || u(l))
              return !0;
            var i = y(l);
            if (i) {
              var E = i.call(l), A;
              if (i !== l.entries) {
                for (; !(A = E.next()).done; )
                  if (!ie(A.value))
                    return !1;
              } else
                for (; !(A = E.next()).done; ) {
                  var D = A.value;
                  if (D && !ie(D[1]))
                    return !1;
                }
            } else
              return !1;
            return !0;
          default:
            return !1;
        }
      }
      function te(l, i) {
        return l === "symbol" ? !0 : i ? i["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && i instanceof Symbol : !1;
      }
      function ue(l) {
        var i = typeof l;
        return Array.isArray(l) ? "array" : l instanceof RegExp ? "object" : te(i, l) ? "symbol" : i;
      }
      function d(l) {
        if (typeof l > "u" || l === null)
          return "" + l;
        var i = ue(l);
        if (i === "object") {
          if (l instanceof Date)
            return "date";
          if (l instanceof RegExp)
            return "regexp";
        }
        return i;
      }
      function p(l) {
        var i = d(l);
        switch (i) {
          case "array":
          case "object":
            return "an " + i;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + i;
          default:
            return i;
        }
      }
      function g(l) {
        return !l.constructor || !l.constructor.name ? S : l.constructor.name;
      }
      return m.checkPropTypes = c, m.resetWarningCache = c.resetWarningCache, m.PropTypes = m, m;
    };
  }
}), Uu = ze({
  "node_modules/prop-types/factoryWithThrowingShims.js"(e, t) {
    var n = $r();
    function r() {
    }
    function o() {
    }
    o.resetWarningCache = r, t.exports = function() {
      function a(f, u, h, v, w, y) {
        if (y !== n) {
          var S = new Error(
            "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
          );
          throw S.name = "Invariant Violation", S;
        }
      }
      a.isRequired = a;
      function c() {
        return a;
      }
      var s = {
        array: a,
        bigint: a,
        bool: a,
        func: a,
        number: a,
        object: a,
        string: a,
        symbol: a,
        any: a,
        arrayOf: c,
        element: a,
        elementType: a,
        instanceOf: c,
        node: a,
        objectOf: c,
        oneOf: c,
        oneOfType: c,
        shape: c,
        exact: c,
        checkPropTypes: o,
        resetWarningCache: r
      };
      return s.PropTypes = s, s;
    };
  }
}), Wu = ze({
  "node_modules/prop-types/index.js"(e, t) {
    process.env.NODE_ENV !== "production" ? (n = mi(), r = !0, t.exports = Bu()(n.isElement, r)) : t.exports = Uu()();
    var n, r;
  }
}), Re = ju(Wu(), 1), Yu = 20, qu = 1, st = 1e6, yo = 1e6, zu = -7, Ku = 21, Hu = !1, jt = "[big.js] ", ut = jt + "Invalid ", an = ut + "decimal places", Xu = ut + "rounding mode", bi = jt + "Division by zero", be = {}, Be = void 0, Gu = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
function yi() {
  function e(t) {
    var n = this;
    if (!(n instanceof e))
      return t === Be ? yi() : new e(t);
    if (t instanceof e)
      n.s = t.s, n.e = t.e, n.c = t.c.slice();
    else {
      if (typeof t != "string") {
        if (e.strict === !0 && typeof t != "bigint")
          throw TypeError(ut + "value");
        t = t === 0 && 1 / t < 0 ? "-0" : String(t);
      }
      Zu(n, t);
    }
    n.constructor = e;
  }
  return e.prototype = be, e.DP = Yu, e.RM = qu, e.NE = zu, e.PE = Ku, e.strict = Hu, e.roundDown = 0, e.roundHalfUp = 1, e.roundHalfEven = 2, e.roundUp = 3, e;
}
function Zu(e, t) {
  var n, r, o;
  if (!Gu.test(t))
    throw Error(ut + "number");
  for (e.s = t.charAt(0) == "-" ? (t = t.slice(1), -1) : 1, (n = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (r = t.search(/e/i)) > 0 ? (n < 0 && (n = r), n += +t.slice(r + 1), t = t.substring(0, r)) : n < 0 && (n = t.length), o = t.length, r = 0; r < o && t.charAt(r) == "0"; )
    ++r;
  if (r == o)
    e.c = [e.e = 0];
  else {
    for (; o > 0 && t.charAt(--o) == "0"; )
      ;
    for (e.e = n - r - 1, e.c = [], n = 0; r <= o; )
      e.c[n++] = +t.charAt(r++);
  }
  return e;
}
function lt(e, t, n, r) {
  var o = e.c;
  if (n === Be && (n = e.constructor.RM), n !== 0 && n !== 1 && n !== 2 && n !== 3)
    throw Error(Xu);
  if (t < 1)
    r = n === 3 && (r || !!o[0]) || t === 0 && (n === 1 && o[0] >= 5 || n === 2 && (o[0] > 5 || o[0] === 5 && (r || o[1] !== Be))), o.length = 1, r ? (e.e = e.e - t + 1, o[0] = 1) : o[0] = e.e = 0;
  else if (t < o.length) {
    if (r = n === 1 && o[t] >= 5 || n === 2 && (o[t] > 5 || o[t] === 5 && (r || o[t + 1] !== Be || o[t - 1] & 1)) || n === 3 && (r || !!o[0]), o.length = t, r) {
      for (; ++o[--t] > 9; )
        if (o[t] = 0, t === 0) {
          ++e.e, o.unshift(1);
          break;
        }
    }
    for (t = o.length; !o[--t]; )
      o.pop();
  }
  return e;
}
function xt(e, t, n) {
  var r = e.e, o = e.c.join(""), a = o.length;
  if (t)
    o = o.charAt(0) + (a > 1 ? "." + o.slice(1) : "") + (r < 0 ? "e" : "e+") + r;
  else if (r < 0) {
    for (; ++r; )
      o = "0" + o;
    o = "0." + o;
  } else if (r > 0)
    if (++r > a)
      for (r -= a; r--; )
        o += "0";
    else
      r < a && (o = o.slice(0, r) + "." + o.slice(r));
  else
    a > 1 && (o = o.charAt(0) + "." + o.slice(1));
  return e.s < 0 && n ? "-" + o : o;
}
be.abs = function() {
  var e = new this.constructor(this);
  return e.s = 1, e;
};
be.cmp = function(e) {
  var t, n = this, r = n.c, o = (e = new n.constructor(e)).c, a = n.s, c = e.s, s = n.e, f = e.e;
  if (!r[0] || !o[0])
    return r[0] ? a : o[0] ? -c : 0;
  if (a != c)
    return a;
  if (t = a < 0, s != f)
    return s > f ^ t ? 1 : -1;
  for (c = (s = r.length) < (f = o.length) ? s : f, a = -1; ++a < c; )
    if (r[a] != o[a])
      return r[a] > o[a] ^ t ? 1 : -1;
  return s == f ? 0 : s > f ^ t ? 1 : -1;
};
be.div = function(e) {
  var t = this, n = t.constructor, r = t.c, o = (e = new n(e)).c, a = t.s == e.s ? 1 : -1, c = n.DP;
  if (c !== ~~c || c < 0 || c > st)
    throw Error(an);
  if (!o[0])
    throw Error(bi);
  if (!r[0])
    return e.s = a, e.c = [e.e = 0], e;
  var s, f, u, h, v, w = o.slice(), y = s = o.length, S = r.length, m = r.slice(0, s), C = m.length, $ = e, _ = $.c = [], N = 0, P = c + ($.e = t.e - e.e) + 1;
  for ($.s = a, a = P < 0 ? 0 : P, w.unshift(0); C++ < s; )
    m.push(0);
  do {
    for (u = 0; u < 10; u++) {
      if (s != (C = m.length))
        h = s > C ? 1 : -1;
      else
        for (v = -1, h = 0; ++v < s; )
          if (o[v] != m[v]) {
            h = o[v] > m[v] ? 1 : -1;
            break;
          }
      if (h < 0) {
        for (f = C == s ? o : w; C; ) {
          if (m[--C] < f[C]) {
            for (v = C; v && !m[--v]; )
              m[v] = 9;
            --m[v], m[C] += 10;
          }
          m[C] -= f[C];
        }
        for (; !m[0]; )
          m.shift();
      } else
        break;
    }
    _[N++] = h ? u : ++u, m[0] && h ? m[C] = r[y] || 0 : m = [r[y]];
  } while ((y++ < S || m[0] !== Be) && a--);
  return !_[0] && N != 1 && (_.shift(), $.e--, P--), N > P && lt($, P, n.RM, m[0] !== Be), $;
};
be.eq = function(e) {
  return this.cmp(e) === 0;
};
be.gt = function(e) {
  return this.cmp(e) > 0;
};
be.gte = function(e) {
  return this.cmp(e) > -1;
};
be.lt = function(e) {
  return this.cmp(e) < 0;
};
be.lte = function(e) {
  return this.cmp(e) < 1;
};
be.minus = be.sub = function(e) {
  var t, n, r, o, a = this, c = a.constructor, s = a.s, f = (e = new c(e)).s;
  if (s != f)
    return e.s = -f, a.plus(e);
  var u = a.c.slice(), h = a.e, v = e.c, w = e.e;
  if (!u[0] || !v[0])
    return v[0] ? e.s = -f : u[0] ? e = new c(a) : e.s = 1, e;
  if (s = h - w) {
    for ((o = s < 0) ? (s = -s, r = u) : (w = h, r = v), r.reverse(), f = s; f--; )
      r.push(0);
    r.reverse();
  } else
    for (n = ((o = u.length < v.length) ? u : v).length, s = f = 0; f < n; f++)
      if (u[f] != v[f]) {
        o = u[f] < v[f];
        break;
      }
  if (o && (r = u, u = v, v = r, e.s = -e.s), (f = (n = v.length) - (t = u.length)) > 0)
    for (; f--; )
      u[t++] = 0;
  for (f = t; n > s; ) {
    if (u[--n] < v[n]) {
      for (t = n; t && !u[--t]; )
        u[t] = 9;
      --u[t], u[n] += 10;
    }
    u[n] -= v[n];
  }
  for (; u[--f] === 0; )
    u.pop();
  for (; u[0] === 0; )
    u.shift(), --w;
  return u[0] || (e.s = 1, u = [w = 0]), e.c = u, e.e = w, e;
};
be.mod = function(e) {
  var t, n = this, r = n.constructor, o = n.s, a = (e = new r(e)).s;
  if (!e.c[0])
    throw Error(bi);
  return n.s = e.s = 1, t = e.cmp(n) == 1, n.s = o, e.s = a, t ? new r(n) : (o = r.DP, a = r.RM, r.DP = r.RM = 0, n = n.div(e), r.DP = o, r.RM = a, this.minus(n.times(e)));
};
be.neg = function() {
  var e = new this.constructor(this);
  return e.s = -e.s, e;
};
be.plus = be.add = function(e) {
  var t, n, r, o = this, a = o.constructor;
  if (e = new a(e), o.s != e.s)
    return e.s = -e.s, o.minus(e);
  var c = o.e, s = o.c, f = e.e, u = e.c;
  if (!s[0] || !u[0])
    return u[0] || (s[0] ? e = new a(o) : e.s = o.s), e;
  if (s = s.slice(), t = c - f) {
    for (t > 0 ? (f = c, r = u) : (t = -t, r = s), r.reverse(); t--; )
      r.push(0);
    r.reverse();
  }
  for (s.length - u.length < 0 && (r = u, u = s, s = r), t = u.length, n = 0; t; s[t] %= 10)
    n = (s[--t] = s[t] + u[t] + n) / 10 | 0;
  for (n && (s.unshift(n), ++f), t = s.length; s[--t] === 0; )
    s.pop();
  return e.c = s, e.e = f, e;
};
be.pow = function(e) {
  var t = this, n = new t.constructor("1"), r = n, o = e < 0;
  if (e !== ~~e || e < -yo || e > yo)
    throw Error(ut + "exponent");
  for (o && (e = -e); e & 1 && (r = r.times(t)), e >>= 1, !!e; )
    t = t.times(t);
  return o ? n.div(r) : r;
};
be.prec = function(e, t) {
  if (e !== ~~e || e < 1 || e > st)
    throw Error(ut + "precision");
  return lt(new this.constructor(this), e, t);
};
be.round = function(e, t) {
  if (e === Be)
    e = 0;
  else if (e !== ~~e || e < -st || e > st)
    throw Error(an);
  return lt(new this.constructor(this), e + this.e + 1, t);
};
be.sqrt = function() {
  var e, t, n, r = this, o = r.constructor, a = r.s, c = r.e, s = new o("0.5");
  if (!r.c[0])
    return new o(r);
  if (a < 0)
    throw Error(jt + "No square root");
  a = Math.sqrt(r + ""), a === 0 || a === 1 / 0 ? (t = r.c.join(""), t.length + c & 1 || (t += "0"), a = Math.sqrt(t), c = ((c + 1) / 2 | 0) - (c < 0 || c & 1), e = new o((a == 1 / 0 ? "5e" : (a = a.toExponential()).slice(0, a.indexOf("e") + 1)) + c)) : e = new o(a + ""), c = e.e + (o.DP += 4);
  do
    n = e, e = s.times(n.plus(r.div(n)));
  while (n.c.slice(0, c).join("") !== e.c.slice(0, c).join(""));
  return lt(e, (o.DP -= 4) + e.e + 1, o.RM);
};
be.times = be.mul = function(e) {
  var t, n = this, r = n.constructor, o = n.c, a = (e = new r(e)).c, c = o.length, s = a.length, f = n.e, u = e.e;
  if (e.s = n.s == e.s ? 1 : -1, !o[0] || !a[0])
    return e.c = [e.e = 0], e;
  for (e.e = f + u, c < s && (t = o, o = a, a = t, u = c, c = s, s = u), t = new Array(u = c + s); u--; )
    t[u] = 0;
  for (f = s; f--; ) {
    for (s = 0, u = c + f; u > f; )
      s = t[u] + a[f] * o[u - f - 1] + s, t[u--] = s % 10, s = s / 10 | 0;
    t[u] = s;
  }
  for (s ? ++e.e : t.shift(), f = t.length; !t[--f]; )
    t.pop();
  return e.c = t, e;
};
be.toExponential = function(e, t) {
  var n = this, r = n.c[0];
  if (e !== Be) {
    if (e !== ~~e || e < 0 || e > st)
      throw Error(an);
    for (n = lt(new n.constructor(n), ++e, t); n.c.length < e; )
      n.c.push(0);
  }
  return xt(n, !0, !!r);
};
be.toFixed = function(e, t) {
  var n = this, r = n.c[0];
  if (e !== Be) {
    if (e !== ~~e || e < 0 || e > st)
      throw Error(an);
    for (n = lt(new n.constructor(n), e + n.e + 1, t), e = e + n.e + 1; n.c.length < e; )
      n.c.push(0);
  }
  return xt(n, !1, !!r);
};
be[Symbol.for("nodejs.util.inspect.custom")] = be.toJSON = be.toString = function() {
  var e = this, t = e.constructor;
  return xt(e, e.e <= t.NE || e.e >= t.PE, !!e.c[0]);
};
be.toNumber = function() {
  var e = Number(xt(this, !0, !0));
  if (this.constructor.strict === !0 && !this.eq(e.toString()))
    throw Error(jt + "Imprecise conversion");
  return e;
};
be.toPrecision = function(e, t) {
  var n = this, r = n.constructor, o = n.c[0];
  if (e !== Be) {
    if (e !== ~~e || e < 1 || e > st)
      throw Error(ut + "precision");
    for (n = lt(new r(n), e, t); n.c.length < e; )
      n.c.push(0);
  }
  return xt(n, e <= n.e || n.e <= r.NE || n.e >= r.PE, !!o);
};
be.valueOf = function() {
  var e = this, t = e.constructor;
  if (t.strict === !0)
    throw Error(jt + "valueOf disallowed");
  return xt(e, e.e <= t.NE || e.e >= t.PE, !0);
};
var Ju = yi(), Qu = Ju;
function el(e, t, n) {
  const r = t.formats.number[n];
  return new globalThis.Intl.NumberFormat(t.locale, r).format(Qu(e).toNumber());
}
var tl = 2, Qn = 2, er = {
  locale: "en-US",
  formats: {
    number: {
      USD: {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: tl,
        maximumFractionDigits: Qn
      }
    }
  }
}, Cr = ({
  component: e,
  value: t,
  defaultValue: n,
  config: r,
  currency: o,
  max: a,
  autoFocus: c,
  autoSelect: s,
  autoReset: f,
  onChange: u,
  onBlur: h,
  onFocus: v,
  onKeyPress: w,
  inputRef: y,
  ...S
}) => {
  const m = pe(null), [C, $] = xe("0"), _ = Pt(() => () => {
    const { formats: { number: { [o]: { maximumFractionDigits: X = Qn } } } } = r, H = {
      ...er,
      ...r
    };
    return H.formats.number[o].minimumFractionDigits = X, H;
  }, [er, r]), N = (X) => typeof X == "number" ? X : Number(X.replace(/[^0-9-]/g, "")) || 0, P = (X) => {
    const { formats: { number: { [o]: { maximumFractionDigits: H = Qn } } } } = _();
    let Y = X;
    return typeof X == "string" ? (Y = N(X), Y % 1 !== 0 && (Y = Y.toFixed(H))) : Y = Number.isInteger(Y) ? Number(Y) * 10 ** H : Number(Y).toFixed(H), N(Y) / 10 ** H;
  }, x = (X) => {
    const H = P(X), Y = el(H, _(), o);
    return [H, Y];
  }, j = (X) => {
    const [H, Y] = x(X);
    return !a || H <= a ? ($(Y), [H, Y]) : [P(C), C];
  }, q = (X) => {
    X.preventDefault();
    const [H, Y] = j(X.target.value);
    Y && u(X, H, Y);
  }, K = (X) => {
    const [H, Y] = j(X.target.value);
    f && x(0), Y && h(X, H, Y);
  }, Z = (X) => {
    s && m.current.select();
    const [H, Y] = j(X.target.value);
    Y && v(X, H, Y);
  }, se = (X) => w(X, X.key, X.keyCode);
  return $e(() => {
    const X = t || n || 0, [, H] = x(X);
    $(H), c && m.current && m.current.focus();
  }, [c, s, o, t, n, r]), /* @__PURE__ */ W.jsx(
    e,
    {
      ...S,
      ref: y || m,
      value: C,
      onChange: q,
      onBlur: K,
      onFocus: Z,
      onKeyUp: se
    }
  );
}, nl = () => Element ? (0, Re.instanceOf)(Element) : Re.any;
Cr.propTypes = {
  defaultValue: Re.number,
  value: Re.number,
  max: Re.number,
  component: Re.node.isRequired,
  currency: Re.string.isRequired,
  config: (0, Re.shape)({}).isRequired,
  autoFocus: Re.bool.isRequired,
  autoSelect: Re.bool.isRequired,
  autoReset: Re.bool.isRequired,
  onChange: Re.func.isRequired,
  onBlur: Re.func.isRequired,
  onFocus: Re.func.isRequired,
  onKeyPress: Re.func.isRequired,
  inputRef: (0, Re.oneOfType)([
    Re.func,
    (0, Re.shape)({ current: nl() })
  ])
};
Cr.defaultProps = {
  component: "input",
  currency: "USD",
  value: 0,
  config: er,
  autoFocus: !1,
  autoSelect: !1,
  autoReset: !1,
  onChange: () => {
  },
  onBlur: () => {
  },
  onFocus: () => {
  },
  onKeyPress: () => {
  },
  inputRef: null
};
var rl = Cr;
/*! Bundled license information:

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

object-assign/index.js:
  (*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  *)
*/
const ol = {
  locale: "en-US",
  formats: {
    number: {
      USD: {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    }
  }
}, gl = fe(sn);
/**
 * @preserve
 * A currency input field component.
 *
 * @component
 * @param {object} props - The props for the CurrencyInput component.
 * @param {function} props.onChange - The callback to be called when the value of the input changes.
 * @param {number} [props.decimalsLimit=2] - The maximum number of decimal places allowed.
 *
 * @returns {JSX.Element} - The rendered CurrencyInput component.
 */
function sn({ decimalsLimit: e, ...t }, n) {
  const [r, o] = xe(t.value), a = pe(n), c = (s, f, u) => {
    s.preventDefault(), o(f), t.onChange(f, u, s);
  };
  return /* @__PURE__ */ W.jsx(
    qe,
    {
      type: "text",
      inputmode: "decimal",
      decimalsLimit: e,
      leftSlot: /* @__PURE__ */ W.jsx("span", { children: "$" }, "currency"),
      ...t,
      onChange: c,
      value: r,
      as: (s) => /* @__PURE__ */ W.jsx(rl, { currency: "USD", config: ol, ...s }),
      ref: a
    }
  );
}
sn.displayName = "CurrencyInput";
sn.propTypes = {
  step: V.number,
  placeholder: V.string,
  value: V.oneOfType([V.string, V.number]),
  onChange: V.func,
  decimalsLimit: V.number
};
sn.defaultProps = {
  step: 0.01,
  placeholder: "0.00",
  onChange: Ue,
  decimalsLimit: 2
};
const bl = fe(cn);
/**
 * @preserve
 * A distance input field component.
 *
 * @component
 * @param {object} props - The props for the DistanceInput component.
 * @param {number} [props.step=0.1] - The step value for the input field. Default is 0.1.
 * @param {'us' | 'uk' | 'ca'} props.countryCode - The country code to determine the unity of the distance. Default is "us".
 * @returns {JSX.Element} - The rendered DistanceInput component.
 */
function cn({ countryCode: e, ...t }, n) {
  const r = e === "us" ? "mi" : "km";
  return /* @__PURE__ */ W.jsx(
    qe,
    {
      type: "number",
      inputmode: "decimal",
      invalid: !1,
      rightSlot: /* @__PURE__ */ W.jsx("span", { children: r }),
      ...t,
      ref: n
    }
  );
}
cn.displayName = "DistanceInput";
cn.propTypes = {
  step: V.number,
  placeholder: V.string,
  countryCode: V.oneOf(["us", "uk", "ca"])
};
cn.defaultProps = {
  step: 0.1,
  placeholder: "0.0",
  countryCode: "us"
};
const yl = fe(un);
/**
 * @preserve
 * An email input field component.
 *
 * @component
 * @param {object} props - The props for the EmailInput component.
 * @returns {JSX.Element} - The rendered EmailInput component.
 */
function un({ ...e }, t) {
  return /* @__PURE__ */ W.jsx(
    qe,
    {
      type: "email",
      leftSlot: /* @__PURE__ */ W.jsx(Ee, { name: "mail" }),
      ...e,
      ref: t
    }
  );
}
un.displayName = "EmailInput";
un.propTypes = {
  placeholder: V.string
};
un.defaultProps = {
  placeholder: "Email address"
};
const wl = fe(ln);
/**
 * @preserve
 * A basic number input field component.
 *
 * @component
 * @param {object} props - The props for the NumberInput component.
 * @param {number} props.value - The initial value for the input field.
 * @param {number} [props.step=1] - The step value for the input field.
 * @param {number} [props.min] - The minimum value for the input field.
 * @param {number} [props.max] - The maximum value for the input field.
 * @param {string | number} props.placeholder - The placeholder text for the input field.
 * @returns {JSX.Element} - The rendered NumberInput component.
 */
function ln({ value: e, step: t, min: n, max: r, disabled: o, ...a }, c) {
  var S, m;
  const [s, f] = xe(e), u = pe(c), h = () => {
    var C, $;
    (C = u.current) == null || C.stepUp(), f(($ = u.current) == null ? void 0 : $.value);
  }, v = () => {
    var C, $;
    (C = u.current) == null || C.stepDown(), f(($ = u.current) == null ? void 0 : $.value);
  }, w = o || r !== null && ((S = u.current) == null ? void 0 : S.value) >= r, y = o || n !== null && ((m = u.current) == null ? void 0 : m.value) <= n;
  return $e(() => {
    function C($) {
      var _;
      $.target === u.current && f((_ = $.target) == null ? void 0 : _.value);
    }
    return document.addEventListener("keyup", C), () => {
      document.removeEventListener("keyup", C);
    };
  }, []), $e(() => {
    f(e);
  }, [e]), /* @__PURE__ */ W.jsx(
    qe,
    {
      type: "number",
      step: t,
      min: n,
      max: r,
      value: s,
      inputmode: "decimal",
      disabled: o,
      rightSlot: /* @__PURE__ */ W.jsx(
        fn,
        {
          onStepUp: h,
          onStepDown: v,
          disableUp: w,
          disableDown: y
        },
        "stepper"
      ),
      ...a,
      ref: u
    }
  );
}
ln.displayName = "NumberInput";
ln.propTypes = {
  value: V.number,
  placeholder: V.string,
  disabled: V.bool,
  step: V.number,
  min: V.number,
  max: V.number
};
ln.defaultProps = {
  value: null,
  disabled: !1,
  placeholder: "Insert a number",
  step: 1,
  min: null,
  max: null
};
function fn({ disableUp: e, disableDown: t, onStepUp: n, onStepDown: r }) {
  return /* @__PURE__ */ W.jsxs("div", { className: "mds-input-number-stepper", children: [
    /* @__PURE__ */ W.jsx(
      "button",
      {
        type: "button",
        className: "mds-input-number-stepper-button mds-input-number-stepper-button-up",
        onClick: n,
        disabled: e,
        children: /* @__PURE__ */ W.jsx(Ee, { name: "arrow-down-b" })
      }
    ),
    /* @__PURE__ */ W.jsx(
      "button",
      {
        type: "button",
        className: "mds-input-number-stepper-button mds-input-number-stepper-button-down",
        onClick: r,
        disabled: t,
        children: /* @__PURE__ */ W.jsx(Ee, { name: "arrow-down-b" })
      }
    )
  ] });
}
fn.displayName = "NumberInput-Stepper";
fn.propTypes = {
  disableUp: V.bool,
  disableDown: V.bool,
  onStepUp: V.func,
  onStepDown: V.func
};
fn.defaultProps = {
  disableUp: !1,
  disableDown: !1,
  onStepUp: Ue,
  onStepDown: Ue
};
const El = fe(dn);
/**
 * @preserve
 * A password input component with reveal action.
 *
 * @param {Object} props - The component props.
 * @returns {JSX.Element} The rendered SearchInput component.
 */
function dn({ ...e }, t) {
  const [n, r] = xe(!1), o = () => r((a) => !a);
  return /* @__PURE__ */ W.jsx(
    qe,
    {
      type: n ? "text" : "password",
      leftSlot: /* @__PURE__ */ W.jsx(Ee, { name: "lock" }),
      rightSlot: /* @__PURE__ */ W.jsx("button", { type: "button", disabled: e.disabled, onClick: o, children: n ? /* @__PURE__ */ W.jsx(Ee, { name: "eye-2" }) : /* @__PURE__ */ W.jsx(Ee, { name: "eye-1" }) }),
      ...e,
      ref: t
    }
  );
}
dn.displayName = "PasswordInput";
dn.propTypes = {
  disabled: V.bool,
  placeholder: V.string
};
dn.defaultProps = {
  placeholder: "Password"
};
const Sl = fe(pn), il = {
  us: "(+1) 999 999 9999",
  ca: "(+1) 999 999 9999",
  uk: "(+44) 9999 999 999"
};
/**
 * @preserve
 * A phone input field component masked by country selector.
 *
 * @component
 * @param {object} props - The props for the PhoneInput component.
 * @param {string} [props.defaultCountry="us"] - The default country code for the input.
 * @param {string} [props.placeholder="Phone number"] - The placeholder text for the input field.
 * @returns {JSX.Element} - The rendered PhoneInput component.
 */
function pn({ defaultCountry: e, ...t }, n) {
  const r = pe(n), [o, a] = xe(e), c = _e(
    (s) => {
      a(s), setTimeout(() => {
        var f, u, h, v;
        (v = (h = (u = (f = r.current) == null ? void 0 : f.getInputDOMNode) == null ? void 0 : u.call(f)) == null ? void 0 : h.focus) == null || v.call(h);
      }, 5);
    },
    [a, r]
  );
  return $e(() => {
    a(e);
  }, [e]), /* @__PURE__ */ W.jsx(
    qe,
    {
      type: "tel",
      leftSlot: /* @__PURE__ */ W.jsx(
        vn,
        {
          selected: o,
          onChange: c
        },
        "flag-selector"
      ),
      mask: il[o],
      ...t,
      ref: r
    }
  );
}
pn.displayName = "PhoneInput";
pn.propTypes = {
  defaultCountry: V.oneOf(["us", "ca", "uk"]),
  placeholder: V.string
};
pn.defaultProps = {
  defaultCountry: "us",
  placeholder: "Phone number"
};
function vn({ selected: e, onChange: t }) {
  return /* @__PURE__ */ W.jsx(
    pi,
    {
      items: [
        {
          key: "us",
          onSelect: () => {
            t("us");
          },
          render: () => /* @__PURE__ */ W.jsxs("span", { className: "mds-input-flagSelector--option", children: [
            /* @__PURE__ */ W.jsx(gt, { countryCode: "us", size: "22" }),
            "United States (+1)"
          ] }),
          text: "United States (+1)"
        },
        {
          key: "ca",
          onSelect: () => {
            t("ca");
          },
          render: () => /* @__PURE__ */ W.jsxs("span", { className: "mds-input-flagSelector--option", children: [
            /* @__PURE__ */ W.jsx(gt, { countryCode: "ca", size: "22" }),
            "Canada (+1)"
          ] }),
          text: "Canada (+1)"
        },
        {
          key: "uk",
          onSelect: () => {
            t("uk");
          },
          render: () => /* @__PURE__ */ W.jsxs("span", { className: "mds-input-flagSelector--option", children: [
            /* @__PURE__ */ W.jsx(gt, { countryCode: "uk", size: "22" }),
            "United Kingdom (+44)"
          ] }),
          text: "United Kingdom (+44)"
        }
      ],
      trigger: /* @__PURE__ */ W.jsxs("button", { type: "button", className: "mds-input-flagSelector", children: [
        /* @__PURE__ */ W.jsx(gt, { countryCode: e }),
        /* @__PURE__ */ W.jsx(Ee, { name: "arrow-down", size: "20" })
      ] })
    },
    "flag-selector-dropdown"
  );
}
vn.displayName = "FlagSelector";
vn.propTypes = {
  selected: V.oneOf(["us", "ca", "uk"]).isRequired,
  onChange: V.func
};
vn.defaultProps = {
  onChange: Ue
};
const $l = fe(hn);
/**
 * @preserve
 * A rate - or cost per distance - input field component.
 *
 * @component
 * @param {object} props - The props for the RateInput component.
 *
 * @returns {JSX.Element} - The rendered RateInput component.
 */
function hn({ options: e, selected: t, onDropdownChange: n, ...r }, o) {
  const a = pe(o), [c, s] = xe(t), f = _e(
    (u) => {
      s(u), n(u), setTimeout(() => {
        var h, v;
        (v = (h = a.current) == null ? void 0 : h.focus) == null || v.call(h);
      }, 5);
    },
    [n, s]
  );
  return /* @__PURE__ */ W.jsx(
    qe,
    {
      type: "number",
      inputmode: "decimal",
      decimalsLimit: 2,
      rightSlot: /* @__PURE__ */ W.jsx(
        mn,
        {
          options: e,
          selected: c,
          onChange: f
        }
      ),
      ...r,
      ref: a
    }
  );
}
hn.displayName = "RateInput";
hn.propTypes = {
  selected: V.object.isRequired,
  step: V.number,
  placeholder: V.string,
  onDropdownChange: V.func,
  options: V.arrayOf(
    V.shape({
      key: V.string,
      value: V.string,
      label: V.string
    })
  ).isRequired
};
hn.defaultProps = {
  step: 0.01,
  placeholder: "0.00",
  onDropdownChange: Ue
};
function mn({ options: e, selected: t, onChange: n }) {
  return /* @__PURE__ */ W.jsx(
    pi,
    {
      items: e == null ? void 0 : e.map((r) => ({
        key: r.key,
        onSelect: () => {
          n(r);
        },
        text: r.label
      })),
      trigger: /* @__PURE__ */ W.jsxs("button", { type: "button", className: "mds-input-RateUnitySelector", children: [
        t == null ? void 0 : t.label,
        /* @__PURE__ */ W.jsx(Ee, { name: "arrow-down", size: "20" })
      ] })
    },
    "rateunity-selector-dropdown"
  );
}
mn.displayName = "RateUnitySelector";
mn.propTypes = {
  options: V.arrayOf(
    V.shape({
      key: V.string,
      value: V.string,
      label: V.string
    })
  ),
  selected: V.object.isRequired,
  onChange: V.func
};
mn.defaultProps = {
  options: [],
  selected: null,
  onChange: Ue
};
const Cl = fe(gn);
/**
 * @preserve
 * A search input component with clear action.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.onClear - The callback function to be called when the clear button is clicked.
 *
 * @returns {JSX.Element} The rendered SearchInput component.
 */
function gn({ onClear: e, ...t }, n) {
  const r = pe(n), o = !(t != null && t.disabled), a = _e(() => {
    r.current.value = "", e == null || e(), setTimeout(() => {
      var c, s;
      (s = (c = r.current) == null ? void 0 : c.focus) == null || s.call(c);
    }, 5);
  }, [r, e]);
  return /* @__PURE__ */ W.jsx(
    qe,
    {
      type: "search",
      leftSlot: /* @__PURE__ */ W.jsx(Ee, { name: "search", size: "20" }),
      rightSlot: o && /* @__PURE__ */ W.jsx("button", { type: "button", onClick: a, children: /* @__PURE__ */ W.jsx(Ee, { name: "clear", size: "16" }) }),
      ...t,
      ref: r
    }
  );
}
gn.displayName = "SearchInput";
gn.propTypes = {
  disabled: V.bool,
  onClear: V.func
};
gn.defaultProps = {
  disabled: !1,
  placeholder: "Search",
  onClear: Ue
};
const xl = fe(wi);
/**
 * @preserve
 * A basic text input field component.
 *
 * @component
 * @param {object} props - The props for the TextInput component.
 * @returns {JSX.Element} - The rendered TextInput component.
 */
function wi({ ...e }, t) {
  return /* @__PURE__ */ W.jsx(qe, { type: "text", ...e, ref: t });
}
wi.displayName = "TextInput";
function xr({
  children: e,
  label: t,
  error: n,
  hint: r,
  suggestion: o,
  action: a,
  ...c
}) {
  let s = ["mds-form-control"];
  return n && s.push("with-error"), /* @__PURE__ */ W.jsx("div", { className: s.join(" "), ...c, children: /* @__PURE__ */ W.jsxs("label", { children: [
    t || a ? /* @__PURE__ */ W.jsxs("span", { className: "mds-form-control-label", children: [
      t,
      a
    ] }) : null,
    e,
    n && /* @__PURE__ */ W.jsxs("span", { className: "mds-form-control-error", children: [
      /* @__PURE__ */ W.jsx(Ee, { name: "info-1" }),
      n
    ] }),
    !n && r && /* @__PURE__ */ W.jsx("span", { className: "mds-form-control-hint", children: r }),
    !n && o && /* @__PURE__ */ W.jsxs("span", { className: "mds-form-control-suggestion", children: [
      /* @__PURE__ */ W.jsx(Ee, { name: "info-1" }),
      o
    ] })
  ] }) });
}
xr.displayName = "FormControl";
xr.propTypes = {
  label: V.string,
  error: V.string,
  hint: V.string,
  suggestion: V.string,
  action: V.oneOf([V.arrayOf(V.node), V.node]),
  children: V.oneOf([
    V.arrayOf(V.node),
    V.node
  ])
};
xr.defaultProps = {
  label: "",
  error: "",
  hint: "",
  suggestion: "",
  action: null
};
export {
  ul as Button,
  fl as ClassificationButton,
  gt as CountryFlag,
  ml as CreditCardNumberInput,
  gl as CurrencyInput,
  bl as DistanceInput,
  pi as Dropdown,
  yl as EmailInput,
  cl as FilterButton,
  xr as FormControl,
  Ee as Icon,
  ll as IconButton,
  dl as NavbarButton,
  wl as NumberInput,
  El as PasswordInput,
  Sl as PhoneInput,
  pl as PurposeButton,
  $l as RateInput,
  Cl as SearchInput,
  xl as TextInput
};
